<template>
	<div class="container">
		<b-row>
			<b-container>
				<h3 class="text-center py-2">
					<b><i>{{ f_titulo() }}</i></b>
				</h3>

				<h5 class="text-center py-2">
					<b-row class="mb-4 align-items-center text-lg">
						<b-col md="3">
							<label class="d-block fw-bold fs-5"><b>Reporte:</b></label>
							<select v-model="dialogReportes" class="form-control form-control-lg">
								<option value="">Seleccione...</option>
								<option v-for="(item, idx) in reportes" :key="'codigo-' + idx" :value="item.codigo">
									{{ item.codigo }}-{{ item.nombre }}
								</option>
							</select>
						</b-col>

						<!-- Vigencia -->
						<b-col md="3">
							<label class="d-block fw-bold fs-5"><b>Vigencia:</b></label>
							<select v-model="dialogFechas" @click="f_fechas" class="form-control form-control-lg">
								<option value="">Seleccione...</option>
								<option v-for="(item, idx) in fechas" :key="'fecha-' + idx" :value="item.fecha">
									{{ item.fecha }}
								</option>
							</select>
						</b-col>

						<!-- Grupo -->
						<b-col md="3">
							<label class="d-block fw-bold fs-5"><b>Grupo:</b></label>
							<select v-model="selectedGrupo" @change="filtraCompaniasPorGrupo"
								class="form-control form-control-lg">
								<option value="">Todos los grupos</option>
								<option v-for="grupo in grupos" :key="grupo.id" :value="grupo.id">
									{{ grupo.nombre }}
								</option>
							</select>
						</b-col>

						<!-- Compañía -->
						<b-col md="3">
							<label class="d-block fw-bold fs-5"><b>Compañía:</b></label>
							<select v-model="dialogCompanias"
								@click="seleccionaCompania(); showDialog = false; showDialogCuenta = false"
								class="form-control form-control-lg">
								<option value="">Seleccione...</option>
								<option v-for="compania in companiasFiltradas" :key="compania.id" :value="compania.id">
									{{ compania.acronym }} {{ compania.nombre }}
								</option>
							</select>
						</b-col>
					</b-row>

					<!-- FILA DE CHECKBOXES Y BOTÓN GENERAR -->
					<b-row class="mb-3 align-items-center fs-5">
						<b-col md="8">
							<div class="d-flex flex-wrap">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="checkbox" id="Balance" value="Balance"
										v-model="Balance" @change="uncheck(1)">
									<label class="form-check-label" for="Balance">Balance</label>
								</div>

								<div class="form-check form-check-inline">
									<input class="form-check-input" type="checkbox" id="Comparativo" value="Comparativo"
										v-model="Comparativo" @change="uncheck(3)">
									<label class="form-check-label" for="Comparativo">Comparativo</label>
								</div>

								<div class="form-check form-check-inline">
									<input class="form-check-input" type="checkbox" id="ConsolidadoGe"
										value="ConsolidadoGe" v-model="ConsolidadoGe" @change="uncheck(20)">
									<label class="form-check-label" for="ConsolidadoGe">Consolidado</label>
								</div>

								<div class="form-check form-check-inline" v-show="ConsolidadoGe">
									<input class="form-check-input" type="checkbox" id="Consolidado" value="Individual"
										v-model="Consolidado" @click="uncheck(2)" :disabled="!ConsolidadoGe">
									<label class="form-check-label" for="Consolidado">Individual</label>
								</div>

								<div class="form-check form-check-inline" v-if="Consolidado">
									<input class="form-check-input" type="checkbox" id="Empresas" value="Empresas"
										v-model="showConsolidationSection" @click="uncheck(21)">
									<label class="form-check-label" for="Empresas">Empresas</label>
								</div>

								<div class="form-check form-check-inline" v-if="Consolidado">
									<input class="form-check-input" type="checkbox" id="Grupos" value="Grupos"
										v-model="Grupos" @click="uncheck(22)">
									<label class="form-check-label" for="Grupos">Grupos</label>
								</div>

								<div class="form-check form-check-inline" v-if="isNotasVisible">
									<input class="form-check-input" type="checkbox" id="Notas" value="Notas"
										v-model="Notas" @click="uncheck(4)">
									<label class="form-check-label" for="Notas">Notas</label>
								</div>

								<div class="form-check form-check-inline">
									<input class="form-check-input" type="checkbox" id="Informacion" value="Informacion"
										v-model="Informacion" @click="uncheck(5)">
									<label class="form-check-label" for="Informacion">Informacion</label>
								</div>
							</div>
						</b-col>

						<b-col md="4" class="text-end">
							<b-button variant="primary" @click="generar" class="btn-lg px-4">
								<b><i>{{ labels.generar }}</i></b>
							</b-button>
						</b-col>
					</b-row>

					<!-- MODAL DE PROGRESO -->
					<b-modal v-model="showGeneratingModal" title="Generando Detalle" hide-footer centered
						no-close-on-backdrop no-close-on-esc>
						<div class="text-center">
							<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
							<h5 class="mt-3">
								<b><i>{{ generatingMessage }}</i></b>
							</h5>
							<p class="mt-2">{{ generatingSubMessage }}</p>
							<b-progress v-if="generatingProgress >= 0" class="mt-3">
								<b-progress-bar :value="generatingProgress" :label="`${generatingProgress}%`"
									variant="primary" striped animated>
								</b-progress-bar>
							</b-progress>
						</div>
					</b-modal>

					<!-- MODAL DE PROGRESO PARA WORD -->
					<b-modal v-model="showGeneratingWordModal" title="Generando Documento Word" hide-footer centered
						no-close-on-backdrop no-close-on-esc>
						<div class="text-center">
							<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
							<h5 class="mt-3">
								<b><i>{{ generatingWordMessage }}</i></b>
							</h5>
							<p class="mt-2">{{ generatingWordSubMessage }}</p>
							<b-progress v-if="generatingWordProgress >= 0" class="mt-3">
								<b-progress-bar :value="generatingWordProgress" :label="`${generatingWordProgress}%`"
									variant="primary" striped animated>
								</b-progress-bar>
							</b-progress>
						</div>
					</b-modal>

					<!-- EMPRESAS PARA CONSOLIDACIÓN (SI APLICA) -->
					<b-row v-if="showConsolidationSection && Empresas" class="mt-4">
						<b-col md="12">
							<div class="consolidation-section p-4 border rounded bg-light">
								<label class="d-block fw-bold fs-5 mb-3 text-center">
									<b>Empresas para consolidar:</b>
								</label>

								<!-- Botón "Seleccionar Todas" -->
								<div class="mb-3 text-center">
									<b-form-checkbox v-model="selectAllCompanies" @change="toggleAllCompanies"
										class="fw-bold fs-6">
										{{ selectAllCompanies ? 'Deseleccionar todas' : 'Seleccionar todas' }}
									</b-form-checkbox>
								</div>

								<!-- Lista de checkboxes para cada compañía -->
								<div class="companies-checkbox-list"
									style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 15px; border-radius: 5px; background-color: white;">
									<b-form-checkbox-group v-model="EmpresasConsolida" stacked class="checkbox-group">
										<b-form-checkbox v-for="compania in companiasFiltradas" :key="compania.id"
											:value="compania.id" class="company-checkbox">
											{{ compania.acronym }} {{ compania.nombre }}
										</b-form-checkbox>
									</b-form-checkbox-group>
								</div>

								<!-- Botón para ocultar la sección manualmente -->
								<div class="text-center mt-3">
									<b-button variant="outline-secondary" @click="toggleConsolidationSection"
										class="btn-sm">
										Ocultar selección
									</b-button>
								</div>
							</div>
						</b-col>
					</b-row>
					<!-- SECCIÓN DE GRUPOS PARA CONSOLIDACIÓN -->
					<b-row v-if="Grupos" class="mt-4">
						<b-col md="12">
							<div class="consolidation-section p-4 border rounded bg-light">
								<label class="d-block fw-bold fs-5 mb-3 text-center">
									<b>Grupos para consolidar:</b>
								</label>

								<!-- Botón "Seleccionar Todos" -->
								<div class="mb-3 text-center">
									<b-form-checkbox v-model="selectAllGroups" @change="toggleAllGroups"
										class="fw-bold fs-6">
										{{ selectAllGroups ? 'Deseleccionar todos' : 'Seleccionar todos' }}
									</b-form-checkbox>
								</div>

								<!-- Lista de checkboxes para cada grupo -->
								<div class="groups-checkbox-list"
									style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 15px; border-radius: 5px; background-color: white;">
									<b-form-checkbox-group v-model="GruposConsolida" stacked class="checkbox-group">
										<b-form-checkbox v-for="grupo in gruposFiltrados" :key="grupo.id"
											:value="grupo.id" class="group-checkbox">
											{{ grupo.nombre }}
										</b-form-checkbox>
									</b-form-checkbox-group>
								</div>

								<!-- Botón para ocultar la sección manualmente -->
								<div class="text-center mt-3">
									<b-button variant="outline-secondary" @click="toggleGroupConsolidationSection"
										class="btn-sm">
										Ocultar selección
									</b-button>
								</div>
							</div>
						</b-col>
					</b-row>
				</h5>
			</b-container>
		</b-row>
		<b-row>
			<b-container v-if="!isEmpty && Balance" class="pb-5">
				<md-table v-model="balance" md-card md-fixed-header class="balance-table" @md-selected="f_muestra">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<!-- Título centrado -->
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title">
									<b><i>BALANCE {{ nombreCompaniaSeleccionada }} {{ vigencia }} Moneda {{ moneda }}</i></b>
								</h1>
							</div>

							<!-- Botones a la derecha -->
							<div style="display: flex; align-items: center; gap: 10px;">
								<!-- Botón Excel -->
								<md-button v-if="fgl_excel" @click="excel(1)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
						<md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">
							{{ item.descripcion }}
						</md-table-cell>

						<!-- Columna Saldo Actual - CAMBIADO A "Local" -->
						<md-table-cell :md-label="labels.saldo_actual" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion) && mostrarColumnas.saldo" key="saldo-actual">
							{{ formato(item.saldo_actual) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.saldo_actual" class="text-right border number-cell"
							v-if="!f_escribe_renglon(item.informacion) && mostrarColumnas.saldo"
							key="saldo-actual-empty">
						</md-table-cell>

						<!-- Columnas para vista Funcional -->
						<md-table-cell :md-label="labels.funcional1" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion) && mostrarColumnas.funcional" key="funcional1">
							{{ formato(item.funcional1) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.funcional1" class="text-right border number-cell"
							v-if="!f_escribe_renglon(item.informacion) && mostrarColumnas.funcional"
							key="funcional1-empty">
						</md-table-cell>

						<md-table-cell :md-label="labels.interna1" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion) && mostrarColumnas.funcional" key="interna1">
							{{ formato(item.interna1) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.interna1" class="text-right border number-cell"
							v-if="!f_escribe_renglon(item.informacion) && mostrarColumnas.funcional"
							key="interna1-empty">
						</md-table-cell>

						<!-- SOLO mostrar promedio1 en vista Funcional -->
						<md-table-cell :md-label="labels.promedio1" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion) && vistaActiva === 'funcional'" key="promedio1">
							{{ formato(item.promedio1) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.promedio1" class="text-right border number-cell"
							v-if="!f_escribe_renglon(item.informacion) && vistaActiva === 'funcional'"
							key="promedio1-empty">
						</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>

			<b-container v-if="!isEmpty && Consolidado" class="pb-5">

				<!-- TÍTULO -->
				<md-table-toolbar>
					<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
						<div style="flex: 1; text-align: center;">
							<h1 class="md-title">
								<b><i>{{ f_titulo() }}</i></b>
							</h1>
						</div>
					</div>
				</md-table-toolbar>

				<!-- BOTONES -->
				<div class="download-box">

					<div v-for="(col, idx) in columnas" :key="'download-col-' + col" class="download-pill">

						<span class="pill-label">
							{{ titulo_columna[idx] }}
						</span>

						<md-button class="md-icon-button md-primary pill-icon" @click="excelColumna(col)">
							<md-icon>file_download</md-icon>
						</md-button>
					</div>

					<!-- General -->
					<div class="download-pill">
						<span class="pill-label">General</span>

						<md-button v-if="fgl_excel" @click="excel(3)" class="md-icon-button md-primary pill-icon">
							<md-icon>description</md-icon>
						</md-button>
					</div>

					<!-- Detalle General -->
					<div class="download-pill">
						<span class="pill-label">Detalle General</span>

						<md-button @click="excelDetalleCompleto" class="md-icon-button md-primary pill-icon">
							<md-icon>description</md-icon>
						</md-button>
					</div>

					<!-- Switch -->
					<div class="compact-toggle-container">
						<div class="toggle-label">
							{{ vistaConsolidado === 'normal' ? 'Combinado' : 'Combinado' }}
						</div>

						<label class="compact-switch">
							<input type="checkbox" v-model="vistaConsolidadoBool">
							<span class="compact-slider"></span>
						</label>
					</div>

				</div>

				<!-- 🔥 WRAPPER CON SCROLL -->
				<div class="table-wrapper">

					<md-table :key="columnas.length + '-' + vistaConsolidado" v-model="balance" md-card md-fixed-header
						class="balance-table">

						<md-table-row slot="md-table-row" slot-scope="{ item }">

							<!-- DESCRIPCIÓN (ANCHO FIJO POR CSS) -->
							<md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">
								{{ item.descripcion }}
							</md-table-cell>

							<!-- COLUMNAS DE COMPAÑÍAS -->
							<md-table-cell v-for="(col, idx) in columnas" :key="'col-' + col"
								:md-label="titulo_columna[idx]" class="text-right border number-cell">

								{{ f_escribe_renglon(item.informacion)
									? formato_consol(item['c' + col])
									: '' }}

							</md-table-cell>

							<!-- COLUMNAS DINÁMICAS FINALES -->
							<md-table-cell v-for="col in columnasVisibles" :key="'final-' + col.field"
								:md-label="col.label" class="text-right border number-cell">

								{{ f_escribe_renglon(item.informacion)
									? formato_consol(item[col.field])
									: '' }}

							</md-table-cell>

						</md-table-row>

					</md-table>

				</div>

			</b-container>

		</b-row>
		<b-row>
			<b-container v-if="!isEmpty && Comparativo" class="pb-5">
				<md-table v-model="balance" md-card md-fixed-header class="balance-table">
					<md-table-toolbar>
						<h1 class="md-title">
							<b><i>{{ f_titulo() }}</i></b> &nbsp;&nbsp;
							<md-button v-if="fgl_excel" @click="excel(2)" class="md-fab md-primary">
								<md-icon>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path
											d="M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M7 13.06L8.18 15.28H9.97L8 12.06L9.93 8.89H8.22L7.13 10.9L7.09 10.96L7.06 11.03Q6.8 10.5 6.5 9.96 6.25 9.43 5.97 8.89H4.16L6.05 12.08L4 15.28H5.78M13.88 19.5V17H8.25V19.5M13.88 15.75V12.63H12V15.75M13.88 11.38V8.25H12V11.38M13.88 7V4.5H8.25V7M20.75 19.5V17H15.13V19.5M20.75 15.75V12.63H15.13V15.75M20.75 11.38V8.25H15.13V11.38M20.75 7V4.5H15.13V7Z" />
									</svg>
								</md-icon>
							</md-button>
						</h1>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }">
						<md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">
							{{ item.descripcion }}
						</md-table-cell>
						<md-table-cell :md-label="titulo(0)" class="text-right border number-cell"
							v-if="f_escribe_renglon1(item.informacion)">{{ formato(item.anterior) }}</md-table-cell>
						<md-table-cell :md-label="titulo(0)" class="text-right border number-cell"
							v-if="!f_escribe_renglon1(item.informacion)"></md-table-cell>
						<md-table-cell :md-label="titulo(1)" class="text-right border number-cell"
							v-if="f_escribe_renglon1(item.informacion)">{{ formato(item.actual) }}</md-table-cell>
						<md-table-cell :md-label="titulo(1)" class="text-right border number-cell"
							v-if="!f_escribe_renglon1(item.informacion)"></md-table-cell>
						<md-table-cell :md-label="titulo(-1)" class="text-right border number-cell"
							v-if="f_escribe_renglon1(item.informacion)">{{ formato(item.diferencia) }}</md-table-cell>
						<md-table-cell :md-label="labels.diferencia" class="text-right border number-cell"
							v-if="!f_escribe_renglon1(item.informacion)"></md-table-cell>
						<md-table-cell :md-label="titulo(2)" class="text-right border number-cell"
							v-if="f_escribe_renglon1(item.informacion)">{{ formato(item.funcional_ant)
							}}</md-table-cell>
						<md-table-cell :md-label="titulo(2)" class="text-right border number-cell"
							v-if="!f_escribe_renglon1(item.informacion)"></md-table-cell>
						<md-table-cell :md-label="titulo(3)" class="text-right border number-cell"
							v-if="f_escribe_renglon1(item.informacion)">{{ formato(item.funcional_act)
							}}</md-table-cell>
						<md-table-cell :md-label="titulo(3)" class="text-right border number-cell"
							v-if="!f_escribe_renglon1(item.informacion)"></md-table-cell>
						<md-table-cell :md-label="titulo(-2)" class="text-right border number-cell"
							v-if="f_escribe_renglon1(item.informacion)">{{ formato(item.funcional_dif)
							}}</md-table-cell>
						<md-table-cell :md-label="labels.funcional_dif" class="text-right border number-cell"
							v-if="!f_escribe_renglon1(item.informacion)"></md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>
			<b-container v-if="isEmpty">
				<b-col md="2" class="mx-auto">
					<div class="success-svg mb-4" :class="{ active: isEmpty }">
						<img src="../../assets/imgs/file-2.svg" alt="warning" />
					</div>
				</b-col>
				<b-col md="12" class="justify-content-around">
					<span id="message" v-if="isEmpty">{{ labels.empty }}</span>
				</b-col>
			</b-container>
			<md-dialog :md-active.sync="showDialogCuenta" style="max-width: 95%;">
				<md-dialog-title class="text-center">
					<h3><b><i>{{ f2_titulo() }}</i></b> &nbsp;&nbsp;
						<md-button v-if="fgl_excel" @click="excel(4)" class="md-fab md-primary md-mini">
							<md-icon>description</md-icon>
						</md-button>
					</h3>
				</md-dialog-title>
				<md-dialog-content>
					<md-table v-model="cuentas" md-card md-fixed-header class="balance-table">
						<md-table-row slot="md-table-row" slot-scope="{ item }">
							<!-- Columna Cuenta -->
							<md-table-cell :md-label="labels.cuenta" class="text-left border descripcion-cell">
								{{ item.cuenta }}
							</md-table-cell>

							<!-- Columna Descripción -->
							<md-table-cell :md-label="labels.descripcion_cuenta"
								class="text-left border descripcion-cell">
								{{ item.descripcion }}
							</md-table-cell>

							<!-- Columnas dinámicas según la vista activa -->

							<!-- Saldo Actual (solo en vista balance) -->
							<md-table-cell v-if="mostrarColumnas.saldo && vistaActiva === 'balance'"
								:md-label="labels.saldo_actual" class="text-right border number-cell">
								{{ formato(item.saldo_actual) }}
							</md-table-cell>

							<!-- Columnas Funcional (vista balance y funcional) -->
							<md-table-cell
								v-if="mostrarColumnas.funcional && (vistaActiva === 'balance' || vistaActiva === 'funcional')"
								:md-label="labels.funcional1" class="text-right border number-cell">
								{{ formato(item.funcional1) }}
							</md-table-cell>

							<md-table-cell
								v-if="mostrarColumnas.funcional && (vistaActiva === 'balance' || vistaActiva === 'funcional')"
								:md-label="labels.interna1" class="text-right border number-cell">
								{{ formato(item.interna1) }}
							</md-table-cell>

							<!-- Promedio USD (solo en vista funcional) -->
							<md-table-cell v-if="vistaActiva === 'funcional'" :md-label="labels.promedio1"
								class="text-right border number-cell">
								{{ formato(item.promedio1) }}
							</md-table-cell>

							<!-- Columnas Alterna (vista balance y alterna) -->
							<md-table-cell
								v-if="mostrarColumnas.alterna && (vistaActiva === 'balance' || vistaActiva === 'alterna')"
								:md-label="labels.funcional2" class="text-right border number-cell">
								{{ formato(item.funcional2) }}
							</md-table-cell>

							<!-- Interna COP (solo en vista alterna) -->
							<md-table-cell v-if="vistaActiva === 'alterna'" :md-label="labels.interna2"
								class="text-right border number-cell">
								{{ formato(item.interna2) }}
							</md-table-cell>

							<!-- Promedio COP (solo en vista alterna) -->
							<md-table-cell v-if="vistaActiva === 'alterna'" :md-label="labels.promedio2"
								class="text-right border number-cell">
								{{ formato(item.promedio2) }}
							</md-table-cell>
						</md-table-row>
					</md-table>
					<md-dialog-actions>
						<md-button class="md-accent" @click="showDialogCuenta = false">Cerrar</md-button>
					</md-dialog-actions>
				</md-dialog-content>
			</md-dialog>
			<b-container v-if="showDialog" class="pb-5">
				<!-- TÍTULO DEL PÁRRAFO -->
				<b-row>
					<b-col cols="4" class="text-left border">
						<h4><b><i>{{ labels.parrafo }}</i></b></h4>
					</b-col>
					<b-col cols="8" class="text-left border">
						<h4><b><i>{{ formParrafo.parrafo }}</i></b></h4>
					</b-col>
				</b-row>

				<b-row>
					<b-col cols="4" class="text-left border">
						<h4><b><i>{{ labels.tipo }}</i></b></h4>
					</b-col>
					<b-col cols="8" class="text-left border">
						<h4><b><i>{{ formParrafo.tipo }}</i></b></h4>
					</b-col>
				</b-row>

				<b-row>
					<b-col cols="4" class="text-left border">
						<h4><b><i>{{ labels.parrafo_titulo }}</i></b></h4>
					</b-col>
					<b-col cols="8" class="text-left border">
						<h4><b><i>{{ formParrafo.titulo }}</i></b></h4>
					</b-col>
				</b-row>

				<!-- TABLA TBM (SOLO PARA TIPO TBM) -->
				<div v-if="formParrafo.tipo === 'TBM'">
					<b-row class="mt-4">
						<b-col cols="12">
							<div class="tbm-table-container p-4 border rounded bg-light">
								<label class="d-block fw-bold fs-5 mb-3 text-center">
									<b>Tabla: {{ formParrafo.titulo || 'Datos de Tabla' }}</b>
								</label>

								<!-- Tabla editable TBM -->
								<div class="table-responsive"
									v-if="tbmTableData.columns.length > 0 && tbmTableData.rows.length > 0">
									<table class="table table-bordered table-sm table-editable">
										<thead class="thead-light">
											<tr>
												<!-- Celda vacía esquina superior izquierda -->
												<th
													style="min-width: 200px; background-color: #e9ecef; font-weight: bold; vertical-align: middle;">
													Descripción
												</th>
												<!-- Encabezados de columnas -->
												<th v-for="col in tbmTableData.columns" :key="'col-' + col.columna"
													style="min-width: 150px; background-color: #e9ecef; font-weight: bold; text-align: center; vertical-align: middle;">
													{{ col.descripcion }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="fila in tbmTableData.rows" :key="'fila-' + fila.fila"
												class="tbm-table-row">
												<!-- Descripción de la fila -->
												<td
													style="background-color: #f8f9fa; font-weight: bold; vertical-align: middle;">
													{{ fila.descripcion }}
												</td>
												<!-- Celdas editables -->
												<td v-for="col in tbmTableData.columns"
													:key="'cell-' + fila.fila + '-' + col.columna"
													class="tbm-table-cell">
													<b-form-input
														v-model="tbmTableData.values[`${fila.fila}-${col.columna}`]"
														@input="onTbmCellChange(fila.fila, col.columna, $event)"
														size="sm" class="text-right cell-input" placeholder="0"
														:id="'tbm-cell-' + fila.fila + '-' + col.columna" />
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<!-- Mensaje si no hay datos de tabla -->
								<div v-else class="text-center p-4">
									<p class="text-muted">No se encontraron datos de tabla configurados.</p>
								</div>

								<!-- Botones específicos para TBM -->
								<div class="text-center mt-4">
									<md-button class="md-primary md-raised" @click="guardarTablaTBM()">
										<md-icon>save</md-icon> Guardar Tabla
									</md-button>
									<md-button class="md-accent" @click="showDialog = false; Informacion = true">
										<md-icon>close</md-icon> Cerrar
									</md-button>
								</div>
							</div>
						</b-col>
					</b-row>
				</div>

				<!-- FORMULARIO PARA TIPOS DE TEXTO (TFG, TFC, TVG, TVC) -->
				<div v-else>
					<!-- Texto HTML con editor (solo si existe texto) -->
					<b-row v-if="formParrafo.texto">
						<b-col cols="4" class="text-left border">
							<h4><b><i>{{ labels.parrafo_texto }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<RichTextEditor ref="textEditor" v-model="formParrafo.texto_html" :height="400"
								placeholder="Edite el texto aquí..." @input="f_cambia_texto_html"
								@change="f_cambia_texto_html" />
							<input type="hidden" v-model="formParrafo.texto" />
						</b-col>
					</b-row>

					<!-- Campos variables (campo0 a campo9) -->
					<b-row v-if="formParrafo.campo0">
						<b-col cols="4" class="text-left border">
							<h4><b><i>0) {{ formParrafo.campo0 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo0" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo1">
						<b-col cols="4" class="text-left border">
							<h4><b><i>1) {{ formParrafo.campo1 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo1" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo2">
						<b-col cols="4" class="text-left border">
							<h4><b><i>2) {{ formParrafo.campo2 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo2" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo3">
						<b-col cols="4" class="text-left border">
							<h4><b><i>3) {{ formParrafo.campo3 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo3" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo4">
						<b-col cols="4" class="text-left border">
							<h4><b><i>4) {{ formParrafo.campo4 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo4" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo5">
						<b-col cols="4" class="text-left border">
							<h4><b><i>5) {{ formParrafo.campo5 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo5" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo6">
						<b-col cols="4" class="text-left border">
							<h4><b><i>6) {{ formParrafo.campo6 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo6" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo7">
						<b-col cols="4" class="text-left border">
							<h4><b><i>7) {{ formParrafo.campo7 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo7" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo8">
						<b-col cols="4" class="text-left border">
							<h4><b><i>8) {{ formParrafo.campo8 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo8" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<b-row v-if="formParrafo.campo9">
						<b-col cols="4" class="text-left border">
							<h4><b><i>9) {{ formParrafo.campo9 }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<md-field>
								<h4><md-input v-model="formParrafo.valor_campo9" type="text"></md-input></h4>
							</md-field>
						</b-col>
					</b-row>

					<!-- Campos TBLM (si existen) - Para otros tipos de tablas -->
					<span v-for="(celda, idx) in formParrafo.TBLM" :key="idx">
						<b-row>
							<b-col cols="4" class="text-left border">
								<h4><b><i>{{ celda.descripcion }}</i></b></h4>
							</b-col>
							<b-col cols="8" class="border">
								<md-field>
									<h4><md-input v-model="celda.valor" type="text"></md-input></h4>
								</md-field>
							</b-col>
						</b-row>
					</span>

					<!-- Botones para tipos de texto -->
					<div class="mt-4">
						<md-button v-if="formParrafo.texto || formParrafo.TBLM" class="md-primary md-raised"
							@click="grabeNotaParrafo()">
							<md-icon>save</md-icon> Guardar
						</md-button>
						<md-button class="md-accent" @click="showDialog = false; Informacion = true">
							<md-icon>close</md-icon> Cerrar
						</md-button>
					</div>
				</div>
			</b-container>
		</b-row>
		<b-row>
			<b-container v-if="!isEmpty && Notas" class="pb-5">
				<md-table v-model="notasEF" md-card md-fixed-header @md-selected="f_muestra_nota">
					<md-table-toolbar>
						<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b> &nbsp;&nbsp; &nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
							<b-button variant="outline-primary" @click="f_todas_notas">
								<h4><b><i>{{ labels.todas }}</i></b></h4>
							</b-button>
						</h1>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
						<md-table-cell :md-label="labels.nota" class="text-left border">{{ item.numero
						}}</md-table-cell>
						<md-table-cell :md-label="labels.descripcion_nota" class="text-left border">{{ item.descripcion
						}}</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>
			<b-container v-if="!isEmpty && Informacion" class="pb-5">
				<md-table v-model="notasEF" md-card md-fixed-header @md-selected="f_modifica_nota">
					<md-table-toolbar>
						<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b> &nbsp;&nbsp; &nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
						</h1>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
						<md-table-cell :md-label="labels.nota" class="text-left border">{{ item.numero
						}}</md-table-cell>
						<md-table-cell :md-label="labels.descripcion_nota" class="text-left border">{{ item.descripcion
						}}</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>
			<b-container v-if="!isEmpty && Informacion && Modifica" class="pb-5">
				<md-table v-model="a_detalle" md-card md-fixed-header @md-selected="f_actualiza_nota">
					<md-table-toolbar>
						<h1 class="md-title"><b><i>{{ f1_titulo() }}</i></b> &nbsp;&nbsp; &nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
						</h1>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
						<md-table-cell :md-label="labels.parrafo" class="text-left border">{{ item.parrafo
						}}</md-table-cell>
						<md-table-cell :md-label="labels.tipo" class="text-left border">{{ item.tipo }}</md-table-cell>
						<md-table-cell :md-label="labels.parrafo_titulo" class="text-left border">{{ item.titulo
						}}</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>
		</b-row>

	</div>
</template>
<script>
import Balance from "@/services/BalanceNiif"
import Currency from "@/services/Currency"
import Grupo from "@/services/Grupo"
import * as XLSX from "exceljs"
import { Document, Packer, Paragraph, TextRun, AlignmentType } from "docx"
import { Table, TableRow, TableCell } from "docx"
import RichTextEditor from '@/components/RichTextEditor.vue'

const ordenefechas = (arreglo = undefined) => {
	return [...arreglo].sort((a, b) => a - b)
}

export default {
	name: "BalanceNiif",

	data: () => ({
		rolSeleccionado: {},
		myOptions: [],
		rolSelected: '',
		vistaConsolidado: 'Normal',
		components: {
			RichTextEditor
		},
		tbmTableData: {
			columns: [],
			rows: [],
			values: {}
		},
		showDialog: false,
		showDialogCuenta: false,
		grupos: [],
		selectedGrupo: '',
		companiasFiltradas: [],
		selectAllCompanies: false,
		formCuentas: {},
		formNotas: {},
		dialogItem: {},
		balance: [],
		notas: [],
		cuentas: [],
		searched: [],
		isEmpty: true,
		isLoading: false,
		error: false,
		idCompania: 1,
		vigencia: '',
		codReporte: '',
		Balance: true,
		Comparativo: false,
		Consolidado: false,
		ConsolidadoGe: false,
		Empresas: false,
		Notas: false,
		Informacion: false,
		Modifica: false,
		showConsolidationSection: true,
		companias: [],
		companiaUsuario: [],
		currency: [],
		tasasCambio: [],
		saldos: [],
		EmpresasConsolida: [],
		fechas: [],
		reportes: [],
		dialogReportes: "",
		dialogFechas: "",
		dialogCompanias: "",
		columnas: 0,
		titulo_columna: [],
		generado: false,
		codigoCompanias: "",
		moneda: '',
		cmoneda: 0,
		amoneda: 0,
		tasa_cambio: 1,
		t_saldo: 0,
		t_funcional: 0,
		t_promedio: 0,
		t_alterna: 0,
		t_prom_alterna: 0,
		rutaExcel: '',
		fgl_excel: true,
		Grupos: false,
		showGroupConsolidationSection: false,
		GruposConsolida: [],
		selectAllGroups: false,
		gruposFiltrados: [],
		showGeneratingWordModal: false,
		generatingWordMessage: '',
		generatingWordSubMessage: '',
		generatingWordProgress: 0,

		a_detalle: [],
		a_detalle_columnas: [],
		a_detalle_cuentas: [],
		a_detalle_niif: [],
		a_detalle_filas: [],
		a_detalle_tabla: [],
		a_detalle_texto: [],
		a_informacion_tblm: [],
		a_informacion_txfc: [],
		a_informacion_txfg: [],
		a_informacion_txvc: [],
		a_informacion_txvg: [],
		formParrafo: '',
		a_Paragraph: [],
		a_titulos: [],
		a_informacion: [],

		showGeneratingModal: false,
		generatingMessage: '',
		generatingSubMessage: '',
		generatingProgress: 0,

		saldo_actual: 'Saldo Actual',
		funcional1: 'Funcional',
		funcional2: 'Alterna',
		promedio1: 'Promedio',
		promedio2: 'Promedio',
		vistaActiva: 'balance',
		mostrarColumnas: {
			saldo: true,
			funcional: true,
			alterna: true
		}
	}),
	computed: {
		labels() {
			const monedaFuncional = this.currency.find(moneda => moneda.isFuncional == 1);
			const acronimoFuncional = monedaFuncional ? monedaFuncional.acronimo : 'USD';
			const acronimoInterna = 'USD';

			if (this.$store.state._language == "es-ES") {
				return {
					title: "BALANCE",
					codigo: "Codigo",
					nota: "Numero",
					parrafo: "Parrafo",
					parrafo_titulo: "Titulo",
					parrafo_texto: "Texto",
					tipo: "Tipo",
					descripcion: "Descripcion / Niif (IFRS)",
					descripcion_nota: "Descripcion",
					cuenta: "Cuenta",
					descripcion_cuenta: "Descripcion",
					saldo_periodo_anterior: "Saldo Periodo Anterior",
					saldo_actual: this.mostrarColumnas.saldo ? "Local" : "",
					funcional1: this.mostrarColumnas.funcional ? `Funcional ${acronimoFuncional}` : "",
					promedio1: this.mostrarColumnas.funcional ? `Prom-${acronimoFuncional}` : "",
					interna1: this.mostrarColumnas.funcional ? `Interna ${acronimoInterna}` : "",
					saldo_periodo_actual: "Saldo A",
					diferencia: "Diferencia",
					funcional_dif: "Dif Funcional",
					alterna_dif: "Dif Alterna",
					compania: "Compañia",
					empty: "Sin Seleccion",
					notFoundMessage: "Sin Informacion",
					generar: "Generar",
					todas: "Genera Notas",
					ajustes: "Ajustes",
					consolidado: "Consolidado",
					moneda: "Moneda",
					select: "Seleccione...",
					allGroups: "Todos los grupos",
				}
			} else {
				return {
					title: "NIIF CHECKING BALANCE",
					codigo: "Code",
					cuenta: "Account",
					descripcion_cuenta: "Description",
					descripcion_nota: "Descripcion",
					nota: "Number",
					parrafo: "Paragrah",
					parrafo_titulo: "Heading",
					parrafo_texto: "Text",
					tipo: "Kind",
					descripcion: "Description",
					saldo_actual: this.mostrarColumnas.saldo ? "Local" : "",
					funcional1: this.mostrarColumnas.funcional ? `Functional ${acronimoFuncional}` : "",
					promedio1: this.mostrarColumnas.funcional ? `Avg-${acronimoFuncional}` : "",
					interna1: this.mostrarColumnas.funcional ? `Internal ${acronimoInterna}` : "",
					saldo_periodo_anterior: "Previous Period Balance",
					saldo_periodo_actual: "Current Period Balance",
					diferencia: "Difference",
					funcional_dif: "Dif Funcional",
					alterna_dif: "Dif Alternate",
					monto: "Amount",
					compania: "Company",
					empty: "Without Information",
					notFoundMessage: "Without Information",
					generar: "Trigger",
					todas: "All Notes",
					ajustes: "Settings",
					consolidado: "Consolidated",
					moneda: "Currency",
					select: "Select...",
					allGroups: "All groups",
				}
			}
		},
		vistaConsolidadoBool: {
			get() {
				return this.vistaConsolidado === 'combinado';
			},
			set(value) {
				this.vistaConsolidado = value ? 'combinado' : 'normal';
			}
		},

		nombreCompaniaSeleccionada() {
			if (this.dialogCompanias) {
				const compania = this.companias.find(c => c.id == this.dialogCompanias);
				return compania ? compania.nombre : '';
			}
			return '';
		},
		columnasVisibles() {
			let base = [
				{ label: this.labels.ajustes, field: 'ajustes' },
				{ label: this.labels.consolidado, field: 'total' }
			]

			if (this.vistaConsolidado === 'combinado') {
				base.push(
					{ label: 'Combinado', field: 'combinado' },
					{ label: 'Total Combinado', field: 'total_combinado' }
				)
			}

			return base
		},
		gruposFiltrados() {
			console.log('gruposFiltrados ejecutado');
			console.log('this.grupos:', this.grupos);
			if (this.grupos && this.grupos.length > 0) {
				return this.grupos;
			}

			return [];
		},

		isNotasVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Notas')
		},

		isBalanceVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Balance')
		},

		isComparativoVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Comparativo')
		},

		isConsolidadoVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Consolidado')
		},

		isInformacionVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Informacion')
		},

	},
	methods: {
		f_fechas() {
			this.isEmpty = true
			this.showDialog = false
			this.showDialogCuenta = false
			Balance.leeTasas(this.dialogFechas)
				.then((result) => {
					this.tasasCambio = result.data.tasasCambio
				})
		},

		onTbmCellChange(fila, columna, valor) {
			const key = `${fila}-${columna}`
			this.tbmTableData.values[key] = valor
		},

		async guardarTablaTBM() {
			try {
				this.showGeneratingModal = true
				this.generatingMessage = 'Guardando tabla...'
				this.generatingProgress = 0

				// Preparar datos para enviar
				const datos = {
					codReporte: this.codReporte,
					numero: this.formParrafo.numero,
					parrafo: this.formParrafo.parrafo,
					idCompania: this.idCompania,
					vigencia: this.vigencia,
					userId: this.$store.state.userId,
					valores: []
				}

				// Convertir valores de tabla a array
				this.tbmTableData.rows.forEach(fila => {
					this.tbmTableData.columns.forEach(col => {
						const key = `${fila.fila}-${col.columna}`
						const valor = this.tbmTableData.values[key] || ''

						datos.valores.push({
							fila: fila.fila,
							columna: col.columna,
							valor: valor.toString().trim()
						})
					})
				})

				// Llamar al servicio para guardar
				const response = await Balance.guardarTablaTBM(datos)

				if (response.data.success) {
					this.$toast.success("Tabla guardada exitosamente")
					this.showDialog = false
					this.Informacion = true

					// Actualizar datos locales
					this.a_informacion_tblm = response.data.nuevosValores || datos.valores
				} else {
					this.$toast.error("Error al guardar la tabla")
				}

			} catch (error) {
				console.error('Error guardando tabla TBM:', error)
				this.$toast.error("Error al guardar la tabla")
			} finally {
				this.showGeneratingModal = false
			}
		},

		filtraCompaniasPorGrupo() {
			if (!this.selectedGrupo) {
				// Si no hay grupo seleccionado, mostrar todas las compañías
				this.companiasFiltradas = this.companias;
			} else {
				// Filtrar compañías por el grupo seleccionado (buscando en el string)
				this.companiasFiltradas = this.companias.filter(compania => {
					if (!compania.id_grupos) return false;

					// Convertir el string "1,3,5" a array y buscar el grupo seleccionado
					const gruposCompania = compania.id_grupos
						.split(',')
						.map(id => id.trim());

					return gruposCompania.includes(this.selectedGrupo.toString());
				});
			}
			// Resetear la compañía seleccionada
			this.dialogCompanias = '';
			this.EmpresasConsolida = [];

			// SOLO resetear showConsolidationSection, pero NO forzar Empresas = true
			this.showConsolidationSection = false; // Mantener oculta
			// this.Empresas = true; // ELIMINAR esta línea
		},

		toggleAllGroups() {
			if (this.selectAllGroups) {
				this.GruposConsolida = this.gruposFiltrados.map(grupo => grupo.id);
			} else {
				this.GruposConsolida = [];
			}
		},

		toggleGroupConsolidationSection() {
			this.showGroupConsolidationSection = !this.showGroupConsolidationSection;
		},

		getEmpresasFromGrupos(gruposSeleccionados) {
			if (!this.companias || !gruposSeleccionados || gruposSeleccionados.length === 0) {
				return [];
			}

			const empresasDelGrupo = [];

			this.companias.forEach(company => {
				if (!company.id_grupos) return;

				// Convertir los grupos de la empresa a array
				const gruposCompania = company.id_grupos
					.split(',')
					.map(id => id.trim());

				// Verificar si la empresa pertenece a alguno de los grupos seleccionados
				const perteneceAlgunGrupo = gruposSeleccionados.some(grupoId =>
					gruposCompania.includes(grupoId.toString())
				);

				if (perteneceAlgunGrupo) {
					empresasDelGrupo.push(company.id);
				}
			});

			console.log('Grupos seleccionados:', gruposSeleccionados);
			console.log('Empresas de los grupos seleccionados:', empresasDelGrupo);
			return empresasDelGrupo;
		},
		async hojaExcelDetalleCompleto(datos, companiaId, esCombinado = false) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const detalleCompleto = datos.informacion
			const ajustesCompania = datos.ajustes || []

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("Detalle")

			// Determinar si estamos en vista combinado (usar el parámetro)
			// const esCombinado = this.vistaConsolidado === 'combinado'

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezadoLinea: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
				},
				encabezadoCuentas: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				datoCuenta: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "left", vertical: "middle" },
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				},
				datoNumerico: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				}
			}

			// ENCABEZADO PRINCIPAL
			let columnasDetalle = 3 // CUENTA + DESCRIPCIÓN + FUNCIONAL
			if (esCombinado) {
				columnasDetalle = 5 // + AJUSTES + CONSOLIDADO
			}
			const endCol = String.fromCharCode(65 + columnasDetalle - 1)

			worksheet.mergeCells(`A1:${endCol}1`)
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells(`A2:${endCol}2`)
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells(`A3:${endCol}3`)
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			let n_fila = 5

			detalleCompleto.forEach((linea) => {
				worksheet.mergeCells(`A${n_fila}:${endCol}${n_fila}`)
				worksheet.getCell(`A${n_fila}`).value = `${linea.niif} - ${linea.linea}`
				Object.assign(worksheet.getCell(`A${n_fila}`), styles.encabezadoLinea)
				n_fila++

				// ENCABEZADO DE COLUMNAS - DINÁMICO SEGÚN VISTA
				const HEADER_ROW = ['CUENTA', 'DESCRIPCIÓN', 'FUNCIONAL']
				if (esCombinado) {
					HEADER_ROW.push('AJUSTES')
					HEADER_ROW.push('CONSOLIDADO')
				}

				const headerRow = worksheet.addRow(HEADER_ROW)
				headerRow.eachCell((cell) => {
					Object.assign(cell, styles.encabezadoCuentas)
				})
				n_fila++

				let totalLinea = 0
				let totalAjustesLinea = 0
				let totalConsolidadoLinea = 0

				linea.cuentas.forEach((cuenta) => {
					if (cuenta.cuenta) {
						const v_fila = [
							cuenta.cuenta,
							cuenta.descripcion,
							parseFloat(cuenta.funcional1) || 0
						]

						if (esCombinado) {
							// En vista combinado, usar los campos específicos si existen
							const ajusteCuenta = parseFloat(
								cuenta.ajuste_funcional1 ||
								cuenta.ajuste_funcional1_rounded ||
								cuenta.ajuste_actual ||
								cuenta.ajuste_actual_rounded ||
								0
							) || 0
							const consolidadoCuenta = parseFloat(cuenta.consolidado) ||
								(parseFloat(cuenta.funcional1) + ajusteCuenta) || 0

							v_fila.push(ajusteCuenta)
							v_fila.push(consolidadoCuenta)

							totalAjustesLinea += ajusteCuenta
							totalConsolidadoLinea += consolidadoCuenta
						}

						const currentRow = worksheet.addRow(v_fila)

						currentRow.eachCell((cell, colNumber) => {
							if (colNumber <= 2) {
								Object.assign(cell, styles.datoCuenta)
							} else {
								Object.assign(cell, styles.datoNumerico)
							}
						})

						n_fila++
						totalLinea += parseFloat(cuenta.funcional1 || 0)
					}
				})

				// FILA DE TOTAL POR LÍNEA
				const totalRow = ['', `TOTAL ${linea.niif}`, totalLinea]

				if (esCombinado) {
					totalRow.push(totalAjustesLinea)
					totalRow.push(totalConsolidadoLinea)
				}

				worksheet.addRow(totalRow)

				// Estilos para fila de total
				const totalRowIndex = n_fila
				for (let i = 1; i <= totalRow.length; i++) {
					const cell = worksheet.getCell(totalRowIndex, i)
					if (i === 2) {
						cell.font = { name: "Calibri", size: 10, bold: true }
						cell.alignment = { horizontal: "right", vertical: "middle" }
					} else if (i >= 3) {
						Object.assign(cell, styles.datoNumerico)
						cell.font = { ...cell.font, bold: true }
					}
				}

				n_fila++
				worksheet.addRow([])
				n_fila++
			})

			// SECCIÓN DE AJUSTES (solo si hay ajustes)
			if (ajustesCompania && ajustesCompania.length > 0 && !datos.esDescargaIndividual) {
				const ajustesFiltrados = ajustesCompania.filter(ajuste => {
					const ajusteFuncional =
						ajuste.ajuste_funcional1 ||
						ajuste.ajuste_funcional1_rounded ||
						ajuste.ajuste_actual ||
						ajuste.ajuste_actual_rounded ||
						0
					return Math.abs(ajusteFuncional) > 0.01
				})

				if (ajustesFiltrados.length > 0) {
					worksheet.addRow([])
					n_fila++

					// Determinar número de columnas para ajustes
					const columnasAjustes = 9 // Columnas fijas para ajustes
					const endColAjustes = String.fromCharCode(65 + columnasAjustes - 1)

					worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`)
					worksheet.getCell(`A${n_fila}`).value = `AJUSTES DE CONSOLIDACIÓN - RELACIONES CON EMPRESAS SELECCIONADAS`
					worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 12, bold: true }
					worksheet.getCell(`A${n_fila}`).fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FFF2CC" }
					}
					n_fila++

					worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`)
					worksheet.getCell(`A${n_fila}`).value = `Compañía analizada: ${compania}`
					worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 11, italic: true }
					n_fila++

					const ajustesHeaders = [
						'COMPAÑIA',
						'NIIF',
						'SECUENCIA',
						'TIPO',
						'TIPO AJUSTE',
						'CUENTA',
						'SALDO ORIGINAL',
						'AJUSTE LOCAL',
						'AJUSTE FUNCIONAL'
					]

					for (let i = 0; i < ajustesHeaders.length; i++) {
						const cell = worksheet.getCell(n_fila, i + 1)
						cell.value = ajustesHeaders[i]
						cell.font = { name: "Calibri", size: 11, bold: true }
						cell.alignment = { horizontal: "center", vertical: "middle" }
						cell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						}
						cell.border = {
							top: { style: "thin" },
							left: { style: "thin" },
							bottom: { style: "thin" },
							right: { style: "thin" }
						}
					}
					n_fila++

					ajustesFiltrados.forEach((ajuste) => {
						let tipoAjusteFormateado = ajuste.tipo_ajuste || ''
						if (tipoAjusteFormateado === 'O') {
							tipoAjusteFormateado = 'Origen'
						} else if (tipoAjusteFormateado === 'D') {
							tipoAjusteFormateado = 'Destino'
						}

						let niifConDescripcion = ajuste.niif || ''
						if (this.balance && this.balance.length > 0 && ajuste.niif) {
							const niifInfo = this.balance.find(item => item.niif === ajuste.niif)
							if (niifInfo && niifInfo.descripcion) {
								niifConDescripcion = `${ajuste.niif} - ${niifInfo.descripcion}`
							}
						}

						worksheet.getCell(n_fila, 1).value = compania
						worksheet.getCell(n_fila, 2).value = niifConDescripcion
						worksheet.getCell(n_fila, 3).value = ajuste.secuencia || ''
						worksheet.getCell(n_fila, 4).value = ajuste.tipo_participante || ''
						worksheet.getCell(n_fila, 5).value = tipoAjusteFormateado
						worksheet.getCell(n_fila, 6).value = ajuste.cuenta || ''
						worksheet.getCell(n_fila, 7).value = ajuste.saldo_actual || 0
						worksheet.getCell(n_fila, 8).value = ajuste.ajuste_actual || ajuste.ajuste_actual_rounded || 0
						worksheet.getCell(n_fila, 9).value =
							ajuste.ajuste_funcional1 ||
							ajuste.ajuste_funcional1_rounded ||
							ajuste.ajuste_actual ||
							ajuste.ajuste_actual_rounded ||
							0

						const esAjustePropio = ajuste.id_compania == companiaId
						if (esAjustePropio) {
							for (let i = 1; i <= ajustesHeaders.length; i++) {
								const cell = worksheet.getCell(n_fila, i)
								cell.fill = {
									type: "pattern",
									pattern: "solid",
									fgColor: { argb: "E1F5FE" }
								}
							}
						}

						for (let i = 1; i <= ajustesHeaders.length; i++) {
							const cell = worksheet.getCell(n_fila, i)
							cell.font = { name: "Calibri", size: 10 }
							cell.alignment = { horizontal: "left", vertical: "middle" }

							if (i >= 7 && i <= 9) {
								cell.alignment = { horizontal: "right", vertical: "middle" }
								cell.numFmt = "#,##0"
							}

							cell.border = {
								left: { style: "thin" },
								right: { style: "thin" },
								bottom: { style: "thin" }
							}
						}
						n_fila++
					})
				}
			}

			// Ajustar ancho de columnas
			if (esCombinado) {
				worksheet.columns = [
					{ width: 15 },
					{ width: 40 },
					{ width: 18 },
					{ width: 18 },
					{ width: 18 }
				]
			} else {
				worksheet.columns = [
					{ width: 15 },
					{ width: 40 },
					{ width: 15 }
				]
			}

			worksheet.views = [
				{ state: 'frozen', ySplit: 4 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")

			let nombreArchivo = `Detalle_${compania}_${vigencia}_${createdAt}.xlsx`
			if (esCombinado) {
				nombreArchivo = `Detalle_Combinado_${compania}_${vigencia}_${createdAt}.xlsx`
			}

			downloadLink.download = nombreArchivo
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			downloadLink.remove()
		},

		excelDetalleGeneral() {
			this.columnas.forEach(col => {
				this.excelColumna(col);
			});
		},

		procesarMultiplesGrupos(gruposConDatos) {
			console.log('Datos recibidos del backend (MÚLTIPLES GRUPOS):', gruposConDatos);

			if (gruposConDatos.length === 1) {
				const grupoData = gruposConDatos[0].data;

				let numColumnas = 0;
				if (grupoData.length > 0 && grupoData[0].columnas) {
					numColumnas = parseInt(grupoData[0].columnas) || 0;
				}

				console.log(`Grupo único tiene ${numColumnas} columnas de empresas`);

				this.balance = grupoData.map(item => {
					let sumaEmpresas = 0;
					for (let i = 1; i <= numColumnas; i++) {
						const columnaKey = 'c' + i;
						if (item[columnaKey] !== undefined && item[columnaKey] !== null) {
							sumaEmpresas += parseFloat(item[columnaKey]) || 0;
						}
					}

					return {
						...item,
						c1: sumaEmpresas,
						ajustes: parseFloat(item.ajustes) || 0,
						total: sumaEmpresas + (parseFloat(item.ajustes) || 0),
						columnas_original: numColumnas,
						columnas: 1
					};
				});

				this.titulo_columna = [this.getNombreGrupo(gruposConDatos[0].grupoId)];
				this.columnas = 1;
			}
			else {
				console.log('Procesando múltiples grupos con diferentes estructuras');

				const gruposOrdenados = [...gruposConDatos];
				const numGrupos = gruposOrdenados.length;

				// Usar el primer grupo como base para las filas (asumiendo misma estructura de códigos)
				const baseData = gruposOrdenados[0].data;

				// Crear un mapa para acceso rápido a las filas de cada grupo por código
				const mapaFilasPorGrupo = {};
				gruposOrdenados.forEach((grupo, idx) => {
					mapaFilasPorGrupo[idx] = {};
					grupo.data.forEach(item => {
						mapaFilasPorGrupo[idx][item.codigo] = item;
					});
				});

				console.log('Mapa de filas creado por código');

				// Procesar cada fila base combinando datos de todos los grupos
				this.balance = baseData.map((filaBase) => {
					const codigoBase = filaBase.codigo;

					// Crear objeto base con valores por defecto
					const nuevaFila = {
						...filaBase,
						// Inicializar columnas dinámicas con 0
						...Object.fromEntries(Array.from({ length: 50 }, (_, i) => [`c${i + 1}`, 0])),
						// Inicializar etiquetas de empresas con string vacío
						...Object.fromEntries(Array.from({ length: 50 }, (_, i) => [`e${i + 1}`, '']))
					};

					let sumaAjustes = 0;

					// Procesar cada grupo para esta fila
					gruposOrdenados.forEach((grupo, grupoIndex) => {
						const columnaDestino = grupoIndex + 1;
						const filaGrupo = mapaFilasPorGrupo[grupoIndex][codigoBase];

						if (filaGrupo) {
							let sumaEmpresasGrupo = 0;
							// Obtener el número de columnas (empresas) que tiene este grupo en esta fila
							const numColsGrupo = parseInt(filaGrupo.columnas_original || filaGrupo.columnas) || 0;

							// Sumar todas las empresas de este grupo para esta fila
							for (let i = 1; i <= numColsGrupo; i++) {
								const colKey = 'c' + i;
								if (filaGrupo[colKey] !== undefined && filaGrupo[colKey] !== null) {
									sumaEmpresasGrupo += parseFloat(filaGrupo[colKey]) || 0;
								}
							}

							// Asignar la suma de empresas a la columna correspondiente
							nuevaFila['c' + columnaDestino] = sumaEmpresasGrupo;
							// Asignar el nombre del grupo como etiqueta
							nuevaFila['e' + columnaDestino] = this.getNombreGrupo(grupo.grupoId);

							// *** CORRECCIÓN IMPORTANTE: Sumar los ajustes de CADA empresa dentro del grupo ***
							// El campo 'ajustes' en filaGrupo YA contiene la suma de ajustes de TODAS las empresas
							// de ese grupo para esta fila específica
							const ajustesGrupo = parseFloat(filaGrupo.ajustes) || 0;
							sumaAjustes += ajustesGrupo;

							console.log(`  Código ${codigoBase} en Grupo ${grupoIndex + 1}: empresas=${sumaEmpresasGrupo}, ajustes=${ajustesGrupo}`);
						} else {
							// Si la fila no existe en este grupo, poner ceros
							nuevaFila['c' + columnaDestino] = 0;
							nuevaFila['e' + columnaDestino] = this.getNombreGrupo(grupo.grupoId);
							console.log(`  Código ${codigoBase} NO existe en Grupo ${grupoIndex + 1}`);
						}
					});

					// Asignar la suma total de ajustes de TODOS los grupos
					nuevaFila.ajustes = sumaAjustes;
					console.log(`  FILA ${codigoBase} - ${filaBase.descripcion} - AJUSTES TOTALES: ${sumaAjustes}`);

					return nuevaFila;
				});

				// Establecer los títulos de las columnas (nombres de los grupos)
				this.titulo_columna = gruposOrdenados.map((grupo) =>
					this.getNombreGrupo(grupo.grupoId)
				);
				this.columnas = numGrupos;

				console.log('Títulos de columnas:', this.titulo_columna);
				console.log(`Total de filas procesadas: ${this.balance.length}`);
			}

			// Actualizar los totales para todas las filas
			this.balance = this.balance.map((nuevaFila) => {
				let sumaColumnas = 0;

				// Sumar todas las columnas de empresas
				for (let i = 1; i <= this.columnas; i++) {
					const valorColumna = nuevaFila['c' + i];
					if (valorColumna !== undefined && valorColumna !== null) {
						sumaColumnas += parseFloat(valorColumna) || 0;
					}
				}

				// Asegurar que ajustes sea un número
				const ajustes = parseFloat(nuevaFila.ajustes) || 0;
				nuevaFila.ajustes = ajustes;

				// Calcular el total (empresas + ajustes)
				nuevaFila.total = sumaColumnas + ajustes;
				nuevaFila.columnas = this.columnas;

				return nuevaFila;
			});

			// Actualizar la data mostrada
			this.searched = this.balance;

			// Actualizar estados
			if (this.balance.length !== 0) {
				this.isEmpty = false;
				this.generado = true;

				console.log('RESULTADO FINAL - Primera fila:', this.balance[0]);

				// Configurar moneda funcional
				const monedaFuncional = this.currency.find((moneda) => moneda.isFuncional == 1);
				this.cmoneda = monedaFuncional ? monedaFuncional.id : 0;
				this.amoneda = monedaFuncional ? monedaFuncional.id : 0;
				this.tasa_cambio = 1;
			}
		},

		// Método para descargar Excel de una columna específica (compañía específica)
		excelColumna(columnaIndex) {
			console.log('Descargando detalle para columna:', columnaIndex);

			// Obtener el ID de la compañía correspondiente a esta columna
			let companiaId = null;
			let companiaNombre = this.titulo_columna[columnaIndex - 1];

			if (this.Grupos && this.GruposConsolida.length > 0) {
				// Para consolidación por grupos
				const grupoId = this.GruposConsolida[columnaIndex - 1];
				const empresasDelGrupo = this.getEmpresasFromGrupos([grupoId]);
				if (empresasDelGrupo.length > 0) {
					companiaId = empresasDelGrupo[0];
				}
			} else {
				// Para consolidación por empresas
				if (this.EmpresasConsolida && this.EmpresasConsolida.length >= columnaIndex) {
					companiaId = this.EmpresasConsolida[columnaIndex - 1];
				} else if (this.EmpresasConsolida && this.EmpresasConsolida.length > 0) {
					companiaId = this.EmpresasConsolida[0];
				} else if (this.dialogCompanias) {
					companiaId = this.dialogCompanias;
				}
			}

			if (!companiaId) {
				this.$toast.warning("No se pudo identificar la compañía para esta columna");
				return;
			}

			this.descargarDetalleCompania(companiaId, companiaNombre);
		},

		excelDetalleCompleto() {
			console.log('=== DEBUG excelDetalleCompleto ===');
			console.log('this.Consolidado:', this.Consolidado);
			console.log('this.Grupos:', this.Grupos);
			console.log('this.GruposConsolida:', this.GruposConsolida, 'length:', this.GruposConsolida?.length);
			console.log('this.Empresas:', this.Empresas);
			console.log('this.EmpresasConsolida:', this.EmpresasConsolida, 'length:', this.EmpresasConsolida?.length);
			console.log('this.Balance:', this.Balance);
			console.log('this.dialogCompanias:', this.dialogCompanias);
			console.log('this.ConsolidadoGe:', this.ConsolidadoGe);
			console.log('Vista activa:', this.vistaActiva);
			console.log('Vista consolidado:', this.vistaConsolidado);
			console.log('==============================');

			// Determinar si estamos en vista combinado
			const esCombinado = this.vistaConsolidado === 'combinado';
			console.log('¿Es vista combinado?', esCombinado);

			// CASO 1: DESCARGAR POR GRUPOS (si Consolidado + Grupos están activos)
			if (this.Consolidado && this.GruposConsolida.length > 0) {
				console.log('Modo: Descarga por Grupos', this.GruposConsolida);
				this.descargarDetallePorGrupos(esCombinado); // Pasar el parámetro
				return;
			}

			// CASO 2: DESCARGAR POR EMPRESAS SELECCIONADAS
			if (this.Consolidado && this.EmpresasConsolida && this.EmpresasConsolida.length > 0) {
				console.log('Modo: Descarga por Empresas seleccionadas', this.EmpresasConsolida);
				const companiasParaDescargar = [];

				this.EmpresasConsolida.forEach(empresaId => {
					const compania = this.companias.find(c => c.id == empresaId);
					if (compania) {
						companiasParaDescargar.push({
							id: compania.id,
							nombre: compania.nombre
						});
					}
				});

				if (companiasParaDescargar.length > 0) {
					this.descargarDetalleMultipleCompanias(companiasParaDescargar, esCombinado); // Pasar el parámetro
				} else {
					this.$toast.warning("No hay empresas seleccionadas para descargar");
				}
				return;
			}

			// CASO 3: DESCARGAR CONSOLIDADO INDIVIDUAL
			if (this.Consolidado && this.dialogCompanias) {
				console.log('Modo: Descarga Consolidado Individual', this.dialogCompanias);
				const compania = this.companias.find(c => c.id == this.dialogCompanias);
				if (compania) {
					this.descargarDetalleCompania(compania.id, compania.nombre, esCombinado); // Pasar el parámetro
				} else {
					this.$toast.warning("No hay compañía seleccionada");
				}
				return;
			}

			// CASO 4: DESCARGAR BALANCE INDIVIDUAL
			if (this.Balance && this.dialogCompanias) {
				console.log('Modo: Descarga Balance Individual', this.dialogCompanias);
				const compania = this.companias.find(c => c.id == this.dialogCompanias);
				if (compania) {
					this.descargarDetalleCompania(compania.id, compania.nombre, false); // Balance individual nunca es combinado
				} else {
					this.$toast.warning("No hay compañía seleccionada");
				}
				return;
			}

			// CASO 5: SIN SELECCIÓN VÁLIDA
			console.warn('No hay configuración válida para descargar detalle');
			this.$toast.warning("Seleccione una opción válida para descargar el detalle");
		},

		async descargarDetallePorGrupos(esCombinado = false) {
			console.log('EJECUTANDO descargarDetallePorGrupos');
			console.log('Grupos seleccionados:', this.GruposConsolida);
			console.log('Estado Consolidado:', this.Consolidado);
			console.log('Estado Grupos:', this.Grupos);

			this.showGeneratingModal = true;
			this.generatingMessage = 'Recopilando información por grupos...';
			this.generatingSubMessage = `Procesando ${this.GruposConsolida.length} grupo(s)`;
			this.generatingProgress = 0;

			try {
				this.$toast.info(`Generando detalle para ${this.GruposConsolida.length} grupo(s)...`);

				const workbook = new XLSX.Workbook();
				const totalGrupos = this.GruposConsolida.length;

				console.log('Número de grupos a procesar:', this.GruposConsolida.length);

				for (let i = 0; i < this.GruposConsolida.length; i++) {
					const grupoId = this.GruposConsolida[i];
					console.log(`Procesando grupo ${i + 1}: ID ${grupoId}`);
					const grupo = this.grupos.find(g => g.id == grupoId);
					console.log('Grupo encontrado:', grupo);

					this.generatingProgress = Math.round((i / totalGrupos) * 50);
					this.generatingMessage = `Procesando grupo ${i + 1} de ${totalGrupos}`;
					this.generatingSubMessage = `Grupo: ${grupo ? grupo.nombre : 'ID ' + grupoId}`;

					// Obtener todas las empresas de este grupo
					const empresasDelGrupo = this.getEmpresasFromGrupos([grupoId]);
					console.log(`Empresas del grupo ${grupoId}:`, empresasDelGrupo);

					if (empresasDelGrupo.length === 0) {
						console.warn(`El grupo ${grupoId} no tiene empresas`);
						continue;
					}

					// Obtener datos de las empresas del grupo
					const companiasDelGrupo = [];
					empresasDelGrupo.forEach(empresaId => {
						const compania = this.companias.find(c => c.id == empresaId);
						if (compania) {
							companiasDelGrupo.push({
								id: compania.id,
								nombre: compania.nombre
							});
						}
					});

					if (companiasDelGrupo.length === 0) {
						continue;
					}

					// Crear una hoja para este grupo
					const worksheet = workbook.addWorksheet(
						grupo ? this.sanitizeSheetName(grupo.nombre) : `Grupo_${grupoId}`,
						{ views: [{ state: 'frozen', ySplit: 4 }] }
					);

					// Procesar datos del grupo - pasar el parámetro esCombinado
					await this.procesarGrupoParaExcel(worksheet, companiasDelGrupo, grupo, esCombinado);
				}

				if (workbook.worksheets.length === 0) {
					this.showGeneratingModal = false;
					this.$toast.warning("No se pudo generar detalle para ningún grupo");
					return;
				}

				this.generatingProgress = 90;
				this.generatingMessage = 'Generando archivo Excel...';
				this.generatingSubMessage = 'Organizando hojas por grupo';

				const file = await workbook.xlsx.writeBuffer();

				this.generatingProgress = 100;
				this.generatingMessage = '¡Completado!';

				const nombreArchivo = esCombinado
					? `Detalle_Grupos_Combinado_${this.vigencia}.xlsx`
					: `Detalle_Grupos_${this.vigencia}.xlsx`;

				setTimeout(() => {
					this.showGeneratingModal = false;
					this.descargarArchivo(file, nombreArchivo);
					this.$toast.success("Detalle por grupos generado exitosamente");
				}, 500);

			} catch (error) {
				this.showGeneratingModal = false;
				console.error('Error generando detalle por grupos:', error);
				this.$toast.error("Error al generar el detalle por grupos");
			}
		},

		async procesarGrupoParaExcel(worksheet, companiasDelGrupo, grupo, esCombinado = false) {
			const titulo = `DETALLE COMPLETO - ${grupo ? grupo.nombre : 'GRUPO'}`;
			const vigencia = this.vigencia;
			const userName = this.$store.state.userName;
			const reporte = this.reportes.find(r => r.codigo === this.codReporte)?.nombre || 'Balance';

			let createdAt1 = new Date();
			let anio = createdAt1.getFullYear();
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0');
			let dia = String(createdAt1.getDate()).padStart(2, '0');
			let createdAt = anio + "-" + mes + "-" + dia;

			const combinacionesAgregadas = new Set();
			const datosPorCompania = [];
			const todosAjustes = [];

			for (let i = 0; i < companiasDelGrupo.length; i++) {
				const compania = companiasDelGrupo[i];

				try {
					const resultBalance = await Balance.getBalanceNiif(
						this.codReporte,
						compania.id,
						vigencia
					);

					const balanceCompania = resultBalance.data.balanceNiif;
					if (!balanceCompania || balanceCompania.length === 0) continue;

					const detalleCompleto = [];

					for (const linea of balanceCompania) {
						if (linea.informacion === "I") {
							try {
								const resultCuentas = await Balance.getCuentasNiif(
									this.codReporte,
									compania.id,
									vigencia,
									linea.niif
								);

								if (resultCuentas.data.cuentas?.length > 0) {
									detalleCompleto.push({
										linea: linea.descripcion,
										niif: linea.niif,
										cuentas: resultCuentas.data.cuentas
									});
								}
							} catch (error) {
								console.warn(`Error obteniendo cuentas ${linea.niif}`, error);
							}
						}
					}

					const ajustesRaw = await this.obtenerAjustesPorEmpresa(
						compania.id,
						vigencia,
						companiasDelGrupo.map(c => c.id)
					);

					const ajustesFiltrados = [];
					for (const ajuste of ajustesRaw) {
						const secuencia = ajuste.secuencia;
						const cuenta = ajuste.cuenta;
						const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || '';

						const clave = `${secuencia}|${cuenta}|${tipoAjuste}`;

						if (!combinacionesAgregadas.has(clave)) {
							combinacionesAgregadas.add(clave);
							ajustesFiltrados.push(ajuste);

							todosAjustes.push({
								...ajuste,
								compania_origen: compania.nombre
							});
						}
					}

					if (detalleCompleto.length > 0 || ajustesFiltrados.length > 0) {
						datosPorCompania.push({
							compania,
							detalle: detalleCompleto,
							ajustes: ajustesFiltrados
						});
					}

				} catch (error) {
					console.error(`Error procesando ${compania.nombre}:`, error);
				}
			}

			if (datosPorCompania.length === 0) {
				worksheet.mergeCells('A1:D1');
				worksheet.getCell('A1').value = `GRUPO: ${grupo ? grupo.nombre : 'Desconocido'}`;
				worksheet.getCell('A1').font = { name: "Calibri", size: 14, bold: true };
				worksheet.mergeCells('A2:D2');
				worksheet.getCell('A2').value = 'No hay datos disponibles para este grupo';
				return;
			}

			const numCompanias = datosPorCompania.length;
			let totalColumnsDetalle = 2 + numCompanias + 3;

			if (esCombinado) {
				totalColumnsDetalle += 2;
			}

			const endColDetalle = String.fromCharCode(65 + totalColumnsDetalle - 1);

			worksheet.mergeCells(`A1:${endColDetalle}1`);
			worksheet.getCell('A1').value = titulo;
			worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true };
			worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" };

			worksheet.mergeCells(`A2:${endColDetalle}2`);
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Grupo: ${grupo ? grupo.nombre : 'Desconocido'} | Empresas: ${datosPorCompania.length}`;
			worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true };
			worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" };

			worksheet.mergeCells(`A3:${endColDetalle}3`);
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`;
			worksheet.getCell('A3').font = { name: "Calibri", size: 11, bold: true };
			worksheet.getCell('A3').alignment = { horizontal: "center", vertical: "middle" };

			worksheet.addRow([]);

			let n_fila = 5;

			const companiasRow = ['COMPAÑÍAS', ''];

			datosPorCompania.forEach((datoCompania) => {
				companiasRow.push(datoCompania.compania.nombre);
			});

			companiasRow.push('SUMATORIA');
			companiasRow.push('AJUSTES');
			companiasRow.push('CONSOLIDADO');

			if (esCombinado) {
				companiasRow.push('COMBINADO');
				companiasRow.push('TOTAL COMBINADO');
			}

			worksheet.addRow(companiasRow);

			let companiaCell = worksheet.getCell(n_fila, 1);
			companiaCell.font = { name: "Calibri", size: 11, bold: true };
			companiaCell.alignment = { horizontal: "center", vertical: "middle" };
			companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
			worksheet.mergeCells(n_fila, 1, n_fila, 2);

			datosPorCompania.forEach((datoCompania, idx) => {
				let nombreCompaniaCell = worksheet.getCell(n_fila, idx + 3);
				nombreCompaniaCell.font = { name: "Calibri", size: 11, bold: true };
				nombreCompaniaCell.alignment = { horizontal: "center", vertical: "middle" };

				if (idx % 2 === 0) {
					nombreCompaniaCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FCE4D6" }
					};
				} else {
					nombreCompaniaCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "D9EAD3" }
					};
				}

				nombreCompaniaCell.border = {
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};
			});

			const sumatoriaCol = numCompanias + 3;
			const ajustesCol = sumatoriaCol + 1;
			const consolidadoCol = ajustesCol + 1;

			let sumatoriaCell = worksheet.getCell(n_fila, sumatoriaCol);
			sumatoriaCell.font = { name: "Calibri", size: 11, bold: true };
			sumatoriaCell.alignment = { horizontal: "center", vertical: "middle" };
			sumatoriaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

			let ajustesCell = worksheet.getCell(n_fila, ajustesCol);
			ajustesCell.font = { name: "Calibri", size: 11, bold: true };
			ajustesCell.alignment = { horizontal: "center", vertical: "middle" };
			ajustesCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

			let consolidadoCell = worksheet.getCell(n_fila, consolidadoCol);
			consolidadoCell.font = { name: "Calibri", size: 11, bold: true };
			consolidadoCell.alignment = { horizontal: "center", vertical: "middle" };
			consolidadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

			if (esCombinado) {
				const combinadoCol = consolidadoCol + 1;
				const totalCombinadoCol = combinadoCol + 1;

				let combinadoCell = worksheet.getCell(n_fila, combinadoCol);
				combinadoCell.font = { name: "Calibri", size: 11, bold: true };
				combinadoCell.alignment = { horizontal: "center", vertical: "middle" };
				combinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

				let totalCombinadoCell = worksheet.getCell(n_fila, totalCombinadoCol);
				totalCombinadoCell.font = { name: "Calibri", size: 11, bold: true };
				totalCombinadoCell.alignment = { horizontal: "center", vertical: "middle" };
				totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
			}

			n_fila++;

			const ajustesPorNiif = {};
			const ajustesPorNiifCuenta = {};

			datosPorCompania.forEach(datoCompania => {
				if (datoCompania.ajustes && datoCompania.ajustes.length > 0) {
					datoCompania.ajustes.forEach(ajuste => {
						const niif = ajuste.niif;
						const cuenta = ajuste.cuenta;
						const valor = parseFloat(
							ajuste.ajuste_funcional1 ||
							ajuste.ajuste_funcional1_rounded ||
							ajuste.ajuste_actual ||
							ajuste.ajuste_actual_rounded ||
							0
						);

						if (!ajustesPorNiif[niif]) {
							ajustesPorNiif[niif] = 0;
						}
						ajustesPorNiif[niif] += valor;

						if (!ajustesPorNiifCuenta[niif]) {
							ajustesPorNiifCuenta[niif] = {};
						}
						if (!ajustesPorNiifCuenta[niif][cuenta]) {
							ajustesPorNiifCuenta[niif][cuenta] = 0;
						}
						ajustesPorNiifCuenta[niif][cuenta] += valor;
					});
				}
			});

			let ajustesOrigenBExternos = [];
			try {
				if (typeof this.obtenerAjustesOrigenB === 'function') {
					ajustesOrigenBExternos = await this.obtenerAjustesOrigenB();
				}
			} catch (error) {
				console.error("Error obteniendo ajustes de origen B:", error);
			}

			const ajustesOrigenBPorCuenta = {};

			if (ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) {
				ajustesOrigenBExternos.forEach(ajuste => {
					const cuenta = ajuste.cuenta;
					if (!ajustesOrigenBPorCuenta[cuenta]) {
						ajustesOrigenBPorCuenta[cuenta] = 0;
					}
					const valorOrigenB = parseFloat(
						ajuste.ajuste_actual ||
						ajuste.ajuste_actual_rounded ||
						0
					);
					ajustesOrigenBPorCuenta[cuenta] += valorOrigenB;
				});
			}

			// AGREGAR AJUSTES DE ORIGEN B A TODOS LOS AJUSTES PARA LA TABLA FINAL
			if (esCombinado && ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) {
				ajustesOrigenBExternos.forEach(ajuste => {
					const compania = datosPorCompania.find(d => d.compania.id === ajuste.id_compania);

					const secuencia = ajuste.secuencia;
					const cuenta = ajuste.cuenta;
					const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || '';
					const clave = `${secuencia}|${cuenta}|${tipoAjuste}`;

					if (!combinacionesAgregadas.has(clave)) {
						combinacionesAgregadas.add(clave);

						todosAjustes.push({
							...ajuste,
							compania_origen: compania ? compania.compania.nombre : `ID: ${ajuste.id_compania}`,
							origen: 'B'
						});
					}
				});
			}

			const todasLasCuentas = {};

			datosPorCompania.forEach((datoCompania) => {
				const companiaId = datoCompania.compania.id;

				if (!datoCompania.detalle || datoCompania.detalle.length === 0) return;

				datoCompania.detalle.forEach(linea => {
					const niifKey = `${linea.niif}-${linea.linea}`;

					if (!todasLasCuentas[niifKey]) {
						todasLasCuentas[niifKey] = {
							niif: linea.niif,
							descripcionLinea: linea.linea,
							cuentas: new Map()
						};
					}

					if (!linea.cuentas || linea.cuentas.length === 0) return;

					linea.cuentas.forEach(cuenta => {
						if (cuenta.cuenta) {
							const cuentaKey = cuenta.cuenta;

							if (!todasLasCuentas[niifKey].cuentas.has(cuentaKey)) {
								todasLasCuentas[niifKey].cuentas.set(cuentaKey, {
									cuenta: cuenta.cuenta,
									descripcion: cuenta.descripcion || '',
									saldos: new Array(numCompanias).fill(0)
								});
							}

							const companiaIndex = datosPorCompania.findIndex(d => d.compania.id === companiaId);

							if (companiaIndex !== -1) {
								const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuentaKey);
								cuentaData.saldos[companiaIndex] = parseFloat(cuenta.funcional1) || 0;

								if (!cuentaData.descripcion && cuenta.descripcion) {
									cuentaData.descripcion = cuenta.descripcion;
								}

								todasLasCuentas[niifKey].cuentas.set(cuentaKey, cuentaData);
							}
						}
					});
				});
			});

			// Incluir cuentas de reclasificación (origen='R') aunque no existan en el detalle base por NIIF.
			// Esto permite mostrar en la tabla superior el paso de un NIIF a otro para la misma cuenta.
			const descripcionPorNiif = {};
			Object.keys(todasLasCuentas).forEach((niifKey) => {
				const niifData = todasLasCuentas[niifKey];
				if (!descripcionPorNiif[niifData.niif]) {
					descripcionPorNiif[niifData.niif] = niifData.descripcionLinea || 'AJUSTES';
				}
			});

				datosPorCompania.forEach((datoCompania) => {
					if (!datoCompania.ajustes || datoCompania.ajustes.length === 0) return;

					datoCompania.ajustes.forEach((ajuste) => {
						const cuentaStr = String(ajuste.cuenta || '').trim();
						const cuentaDigitos = cuentaStr.replace(/\D/g, '');
						const esCuenta99 = cuentaDigitos.endsWith('99');
						const esReclasificacion = ajuste.origen === 'R';
						const esAjusteAI = ajuste.origen === 'A' || ajuste.origen === 'I';
						const esAICon99 = esAjusteAI && esCuenta99;
						if (!esReclasificacion && !esAICon99) return;

					const niif = ajuste.niif;
					const cuenta = ajuste.cuenta;
					if (!niif || !cuenta) return;

						const descripcionLinea = descripcionPorNiif[niif] || 'AJUSTES';
						const niifKey = `${niif}-${descripcionLinea}`;
						const yaExisteCuenta = todasLasCuentas[niifKey]?.cuentas?.has(cuenta);

						if (!todasLasCuentas[niifKey]) {
							todasLasCuentas[niifKey] = {
								niif: niif,
								descripcionLinea: descripcionLinea,
							cuentas: new Map()
						};
					}

					if (!todasLasCuentas[niifKey].cuentas.has(cuenta)) {
						todasLasCuentas[niifKey].cuentas.set(cuenta, {
							cuenta: cuenta,
							descripcion: ajuste.descripcion || '',
								saldos: new Array(numCompanias).fill(0)
							});
						}

						const companiaAjuste = Number(ajuste.id_compania);
						const companiaIndex = datosPorCompania.findIndex(
							d => Number(d.compania.id) === companiaAjuste
						);

						if (companiaIndex !== -1) {
							const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuenta);
							const saldoActual = parseFloat(cuentaData.saldos[companiaIndex]) || 0;

							if (esReclasificacion) {
								const valorAjuste = parseFloat(
									ajuste.ajuste_funcional1 ||
									ajuste.ajuste_funcional1_rounded ||
									ajuste.ajuste_actual ||
									ajuste.ajuste_actual_rounded ||
									0
								) || 0;
								const saldoEspejo = -valorAjuste;

								// Para reclasificación, si la cuenta no estaba en el detalle base (o venía en cero),
								// reflejar el saldo opuesto al ajuste en la compañía real del movimiento.
								if (!yaExisteCuenta || saldoActual === 0) {
									cuentaData.saldos[companiaIndex] = saldoActual + saldoEspejo;
								}
							}

							if (!cuentaData.descripcion && ajuste.descripcion) {
								cuentaData.descripcion = ajuste.descripcion;
							}
							todasLasCuentas[niifKey].cuentas.set(cuenta, cuentaData);
						}
					});
				});

			Object.keys(todasLasCuentas).forEach(niifKey => {
				const dataNiif = todasLasCuentas[niifKey];

				worksheet.mergeCells(`A${n_fila}:B${n_fila}`);
				worksheet.getCell(`A${n_fila}`).value = `${dataNiif.niif} - ${dataNiif.descripcionLinea}`;
				worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 11, bold: true };
				worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" };
				worksheet.getCell(`A${n_fila}`).fill = {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "F2F2F2" }
				};
				worksheet.getCell(`A${n_fila}`).border = {
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};

				n_fila++;

				const headerRow = ['CUENTA', 'DESCRIPCIÓN'];

				for (let i = 0; i < datosPorCompania.length; i++) {
					headerRow.push('FUNCIONAL');
				}

				headerRow.push('SUMATORIA');
				headerRow.push('AJUSTES');
				headerRow.push('CONSOLIDADO');

				if (esCombinado) {
					headerRow.push('COMBINADO');
					headerRow.push('TOTAL COMBINADO');
				}

				worksheet.addRow(headerRow);

				for (let i = 1; i <= headerRow.length; i++) {
					let headerCell = worksheet.getCell(n_fila, i);
					headerCell.font = { name: "Calibri", size: 11, bold: true };
					headerCell.alignment = { horizontal: "center", vertical: "middle" };

					if (i <= 2) {
						headerCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					} else if (i <= numCompanias + 2) {
						const companiaIndex = i - 3;
						if (companiaIndex % 2 === 0) {
							headerCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
							headerCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
					} else {
						headerCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					}

					headerCell.border = {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}

				n_fila++;

				const cuentasArray = Array.from(dataNiif.cuentas.values())
					.sort((a, b) => a.cuenta.localeCompare(b.cuenta));

				cuentasArray.forEach((cuenta) => {
					const dataRow = [cuenta.cuenta, cuenta.descripcion];

					cuenta.saldos.forEach((saldo) => {
						dataRow.push(saldo);
					});

					let sumatoria = 0;
					cuenta.saldos.forEach(saldo => {
						sumatoria += saldo;
					});
					dataRow.push(sumatoria);

					const ajusteCuenta = ajustesPorNiifCuenta[dataNiif.niif]?.[cuenta.cuenta] || 0;
					dataRow.push(ajusteCuenta);

					const consolidado = sumatoria + ajusteCuenta;
					dataRow.push(consolidado);

					let combinadoValor = 0;
					if (esCombinado) {
						combinadoValor = ajustesOrigenBPorCuenta[cuenta.cuenta] || 0;
						dataRow.push(combinadoValor);
						dataRow.push(consolidado + combinadoValor);
					}

					worksheet.addRow(dataRow);

					let colCell = 1;

					let dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "left", vertical: "middle" };
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "left", vertical: "middle" };
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					cuenta.saldos.forEach((saldo, saldoIndex) => {
						dataCell = worksheet.getCell(n_fila, colCell);
						dataCell.value = saldo;
						dataCell.font = { name: "Calibri", size: 10 };
						dataCell.alignment = { horizontal: "right", vertical: "middle" };
						dataCell.numFmt = "#,##0";

						if (saldoIndex % 2 === 0) {
							dataCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCF8F3" }
							};
						} else {
							dataCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "F7FCF5" }
							};
						}

						dataCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;
					});

					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.value = sumatoria;
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "right", vertical: "middle" };
					dataCell.numFmt = "#,##0";
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.value = ajusteCuenta;
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "right", vertical: "middle" };
					dataCell.numFmt = "#,##0";
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.value = consolidado;
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "right", vertical: "middle" };
					dataCell.numFmt = "#,##0";
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					if (esCombinado) {
						dataCell = worksheet.getCell(n_fila, colCell);
						dataCell.value = combinadoValor;
						dataCell.font = { name: "Calibri", size: 10 };
						dataCell.alignment = { horizontal: "right", vertical: "middle" };
						dataCell.numFmt = "#,##0";
						dataCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;

						dataCell = worksheet.getCell(n_fila, colCell);
						dataCell.value = consolidado + combinadoValor;
						dataCell.font = { name: "Calibri", size: 10 };
						dataCell.alignment = { horizontal: "right", vertical: "middle" };
						dataCell.numFmt = "#,##0";
						dataCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}

					n_fila++;
				});

				const totalRow = ['', 'TOTAL ' + dataNiif.niif];

				const totalesPorCompania = new Array(numCompanias).fill(0);
				let totalSumatoria = 0;

				cuentasArray.forEach(cuenta => {
					cuenta.saldos.forEach((saldo, idx) => {
						totalesPorCompania[idx] += saldo;
					});
				});

				totalesPorCompania.forEach(total => {
					totalRow.push(total);
					totalSumatoria += total;
				});

				const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0;

				totalRow.push(totalSumatoria);
				totalRow.push(ajusteNiif);

				const consolidadoTotal = totalSumatoria + ajusteNiif;
				totalRow.push(consolidadoTotal);

				let totalCombinadoNiif = 0;
				if (esCombinado) {
					cuentasArray.forEach(cuenta => {
						totalCombinadoNiif += ajustesOrigenBPorCuenta[cuenta.cuenta] || 0;
					});
					totalRow.push(totalCombinadoNiif);
					totalRow.push(consolidadoTotal + totalCombinadoNiif);
				}

				worksheet.addRow(totalRow);

				let colTotal = 1;

				let totalCell = worksheet.getCell(n_fila, colTotal);
				totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
				colTotal++;

				totalCell = worksheet.getCell(n_fila, colTotal);
				totalCell.font = { name: "Calibri", size: 10, bold: true };
				totalCell.alignment = { horizontal: "right", vertical: "middle" };
				totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
				colTotal++;

				totalesPorCompania.forEach((total) => {
					let companiaCell = worksheet.getCell(n_fila, colTotal);
					companiaCell.value = total;
					companiaCell.font = { name: "Calibri", size: 10, bold: true };
					companiaCell.alignment = { horizontal: "right", vertical: "middle" };
					companiaCell.numFmt = "#,##0";
					companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
					companiaCell.border = {
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;
				});

				let sumatoriaCellTotal = worksheet.getCell(n_fila, colTotal);
				sumatoriaCellTotal.value = totalSumatoria;
				sumatoriaCellTotal.font = { name: "Calibri", size: 10, bold: true };
				sumatoriaCellTotal.alignment = { horizontal: "right", vertical: "middle" };
				sumatoriaCellTotal.numFmt = "#,##0";
				sumatoriaCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D9E1F2" } };
				sumatoriaCellTotal.border = {
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;

				let ajustesCellTotal = worksheet.getCell(n_fila, colTotal);
				ajustesCellTotal.value = ajusteNiif;
				ajustesCellTotal.font = { name: "Calibri", size: 10, bold: true };
				ajustesCellTotal.alignment = { horizontal: "right", vertical: "middle" };
				ajustesCellTotal.numFmt = "#,##0";
				ajustesCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2CC" } };
				ajustesCellTotal.border = {
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;

				let consolidadoCellTotal = worksheet.getCell(n_fila, colTotal);
				consolidadoCellTotal.value = consolidadoTotal;
				consolidadoCellTotal.font = { name: "Calibri", size: 10, bold: true };
				consolidadoCellTotal.alignment = { horizontal: "right", vertical: "middle" };
				consolidadoCellTotal.numFmt = "#,##0";
				consolidadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E2EFDA" } };
				consolidadoCellTotal.border = {
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;

				if (esCombinado) {
					let combinadoCellTotal = worksheet.getCell(n_fila, colTotal);
					combinadoCellTotal.value = totalCombinadoNiif;
					combinadoCellTotal.font = { name: "Calibri", size: 10, bold: true };
					combinadoCellTotal.alignment = { horizontal: "right", vertical: "middle" };
					combinadoCellTotal.numFmt = "#,##0";
					combinadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } };
					combinadoCellTotal.border = {
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;

					let totalCombinadoCell = worksheet.getCell(n_fila, colTotal);
					totalCombinadoCell.value = consolidadoTotal + totalCombinadoNiif;
					totalCombinadoCell.font = { name: "Calibri", size: 10, bold: true };
					totalCombinadoCell.alignment = { horizontal: "right", vertical: "middle" };
					totalCombinadoCell.numFmt = "#,##0";
					totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "B8CCE4" } };
					totalCombinadoCell.border = {
						top: { style: "thin" },
						bottom: { style: "double" }
					};
				}

				n_fila++;
			});

			const totalesEcuacionPorCompania = new Array(datosPorCompania.length).fill(0);
			const ajustesEcuacionPorCompania = new Array(datosPorCompania.length).fill(0);

			Object.keys(todasLasCuentas).forEach(niifKey => {
				const dataNiif = todasLasCuentas[niifKey];

				if (dataNiif.niif && dataNiif.niif.toString().startsWith('9000')) {
					return;
				}

				const cuentasArray = Array.from(dataNiif.cuentas.values());
				const totalesPorCompaniaNiif = new Array(datosPorCompania.length).fill(0);

				cuentasArray.forEach(cuenta => {
					cuenta.saldos.forEach((saldo, idx) => {
						totalesPorCompaniaNiif[idx] += saldo;
					});
				});

				totalesPorCompaniaNiif.forEach((total, idx) => {
					totalesEcuacionPorCompania[idx] += total;

					const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0;
					const totalNiif = totalesPorCompaniaNiif.reduce((a, b) => a + b, 0);
					const ajustePorCompania = total !== 0 && totalNiif !== 0 ? (ajusteNiif * total / totalNiif) : 0;

					ajustesEcuacionPorCompania[idx] += ajustePorCompania;
				});
			});

			const ecuacionRowData = ['ECUACIÓN PATRIMONIAL', ''];

			datosPorCompania.forEach((datoCompania, idx) => {
				const totalCompania = totalesEcuacionPorCompania[idx] || 0;
				ecuacionRowData.push(totalCompania);
			});

			let sumaTotalEcuacion = 0;
			let sumaAjustesEcuacion = 0;

			datosPorCompania.forEach((datoCompania, idx) => {
				const totalCompania = totalesEcuacionPorCompania[idx] || 0;
				const ajusteCompania = ajustesEcuacionPorCompania[idx] || 0;

				sumaTotalEcuacion += totalCompania;
				sumaAjustesEcuacion += ajusteCompania;
			});

			ecuacionRowData.push(sumaTotalEcuacion);
			ecuacionRowData.push(sumaAjustesEcuacion);

			const consolidadoEcuacion = sumaTotalEcuacion + sumaAjustesEcuacion;
			ecuacionRowData.push(consolidadoEcuacion);

			if (esCombinado) {
				let totalCombinadoEcuacion = 0;
				Object.values(ajustesOrigenBPorCuenta).forEach(valor => {
					totalCombinadoEcuacion += valor;
				});
				ecuacionRowData.push(totalCombinadoEcuacion);
				ecuacionRowData.push(consolidadoEcuacion + totalCombinadoEcuacion);
			}

			worksheet.addRow(ecuacionRowData);

			for (let i = 1; i <= ecuacionRowData.length; i++) {
				const ecuacionCell = worksheet.getCell(n_fila, i);

				if (i === 1) {
					ecuacionCell.font = { name: "Calibri", size: 11, bold: true };
					ecuacionCell.alignment = { horizontal: "left", vertical: "middle" };
					worksheet.mergeCells(n_fila, 1, n_fila, 2);
				} else if (i === 2) {
					continue;
				} else {
					ecuacionCell.font = { name: "Calibri", size: 11, bold: true };
					ecuacionCell.alignment = { horizontal: "right", vertical: "middle" };
					ecuacionCell.numFmt = "#,##0";

					if (i <= datosPorCompania.length + 2) {
						if ((i - 2) % 2 === 1) {
							ecuacionCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
							ecuacionCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
					} else if (i === datosPorCompania.length + 3) {
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "D9E1F2" }
						};
					} else if (i === datosPorCompania.length + 4) {
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFF2CC" }
						};
					} else if (i === datosPorCompania.length + 5) {
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E2EFDA" }
						};
					} else if (i === datosPorCompania.length + 6) {
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFE699" }
						};
					} else if (i === datosPorCompania.length + 7) {
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "B8CCE4" }
						};
					}
				}

				ecuacionCell.border = {
					top: { style: "medium" },
					left: { style: "thin" },
					right: { style: "thin" },
					bottom: { style: "double" }
				};
			}

			n_fila++;
			worksheet.addRow([]);
			n_fila++;

			if (todosAjustes.length > 0) {
				worksheet.addRow([]);
				n_fila++;

				const ajustesHeaders = [
					'COMPAÑIA',
					'NIIF',
					'SECUENCIA',
					'TIPO',
					'TIPO AJUSTE',
					'CUENTA',
					'SALDO ORIGINAL',
					'AJUSTE LOCAL',
					'AJUSTE FUNCIONAL',
					'DESCRIPCIÓN',
					'ORIGEN'
				];

				const totalColumnsAjustes = ajustesHeaders.length;
				const endColAjustes = String.fromCharCode(65 + totalColumnsAjustes - 1);

				worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`);
				worksheet.getCell(`A${n_fila}`).value = `AJUSTES DE CONSOLIDACIÓN - ${grupo ? grupo.nombre : 'GRUPO'}`;
				worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 12, bold: true };
				worksheet.getCell(`A${n_fila}`).fill = {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "FFF2CC" }
				};
				worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" };
				n_fila++;

				for (let i = 0; i < ajustesHeaders.length; i++) {
					worksheet.getCell(n_fila, i + 1).value = ajustesHeaders[i];
					worksheet.getCell(n_fila, i + 1).font = { name: "Calibri", size: 11, bold: true };
					worksheet.getCell(n_fila, i + 1).alignment = { horizontal: "center", vertical: "middle" };
					worksheet.getCell(n_fila, i + 1).fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "E6E6E6" }
					};
					worksheet.getCell(n_fila, i + 1).border = {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}
				n_fila++;

				todosAjustes.forEach((ajuste) => {
					let tipoAjusteTexto = ajuste.tipo_ajuste || '';
					if (tipoAjusteTexto === 'O') {
						tipoAjusteTexto = 'Origen';
					} else if (tipoAjusteTexto === 'D') {
						tipoAjusteTexto = 'Destino';
					}

					let niifConDescripcion = ajuste.niif || '';

					if (this.balance && this.balance.length > 0 && ajuste.niif) {
						const niifInfo = this.balance.find(item => item.niif === ajuste.niif);
						if (niifInfo && niifInfo.descripcion) {
							niifConDescripcion = `${ajuste.niif} - ${niifInfo.descripcion}`;
						}
					}

					worksheet.getCell(n_fila, 1).value = ajuste.compania_origen || '';
					worksheet.getCell(n_fila, 2).value = niifConDescripcion;
					worksheet.getCell(n_fila, 3).value = ajuste.secuencia || '';
					worksheet.getCell(n_fila, 4).value = ajuste.tipo_participante || '';
					worksheet.getCell(n_fila, 5).value = tipoAjusteTexto;
					worksheet.getCell(n_fila, 6).value = ajuste.cuenta || '';
					worksheet.getCell(n_fila, 7).value = ajuste.saldo_actual || 0;
					worksheet.getCell(n_fila, 8).value = ajuste.ajuste_actual || ajuste.ajuste_actual_rounded || 0;
					worksheet.getCell(n_fila, 9).value =
						ajuste.ajuste_funcional1 ||
						ajuste.ajuste_funcional1_rounded ||
						ajuste.ajuste_actual ||
						ajuste.ajuste_actual_rounded ||
						0;
					worksheet.getCell(n_fila, 10).value = ajuste.descripcion || '';
					worksheet.getCell(n_fila, 11).value = ajuste.origen || '';

					for (let i = 1; i <= ajustesHeaders.length; i++) {
						const ajusteCell = worksheet.getCell(n_fila, i);
						ajusteCell.font = { name: "Calibri", size: 10 };
						ajusteCell.alignment = { horizontal: "left", vertical: "middle" };

						if (i >= 7 && i <= 9) {
							ajusteCell.alignment = { horizontal: "right", vertical: "middle" };
							ajusteCell.numFmt = "#,##0";
						}

						ajusteCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "F5F5F5" }
						};

						ajusteCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
					n_fila++;
				});
			}

			const columnWidths = [
				{ width: 15 },
				{ width: 40 },
			];

			for (let i = 0; i < numCompanias; i++) {
				columnWidths.push({ width: 18 });
			}

			columnWidths.push({ width: 18 });
			columnWidths.push({ width: 18 });
			columnWidths.push({ width: 18 });

			if (esCombinado) {
				columnWidths.push({ width: 18 });
				columnWidths.push({ width: 18 });
			}

			worksheet.columns = columnWidths;

			worksheet.views = [
				{ state: 'frozen', ySplit: 4 }
			];
		},

		// MÉTODO AUXILIAR PARA SANITIZAR NOMBRES DE HOJAS
		sanitizeSheetName(name) {
			// Excel limita a 31 caracteres y no permite ciertos caracteres
			let sanitized = name.replace(/[\\/*?:[\]]/g, '_');
			return sanitized.substring(0, 31);
		},

		async descargarDetalleCompania(companiaId, companiaNombre, esCombinado = false) {
			this.showGeneratingModal = true;
			this.generatingMessage = 'Generando detalle...';
			this.generatingSubMessage = `Empresa: ${companiaNombre}`;
			this.generatingProgress = 25;

			try {
				this.$toast.info(`Generando detalle para ${companiaNombre}...`);

				const resultBalance = await Balance.getBalanceNiif(
					this.codReporte,
					companiaId,
					this.vigencia
				);

				const balanceCompania = resultBalance.data.balanceNiif;

				if (!balanceCompania || balanceCompania.length === 0) {
					this.$toast.warning(`La compañía ${companiaNombre} no tiene datos`);
					this.showGeneratingModal = false;
					return;
				}

				this.generatingProgress = 50;
				this.generatingMessage = 'Obteniendo detalles de cuentas...';

				const lineasConCuentas = [];

				for (const linea of balanceCompania) {
					if (linea.informacion === "I") {
						try {
							const resultCuentas = await Balance.getCuentasNiif(
								this.codReporte,
								companiaId,
								this.vigencia,
								linea.niif
							);

							if (resultCuentas.data.cuentas?.length > 0) {
								lineasConCuentas.push({
									linea: linea.descripcion,
									niif: linea.niif,
									cuentas: resultCuentas.data.cuentas
								});
							}
						} catch (error) {
							console.warn(`Error obteniendo cuentas para ${linea.niif}:`, error);
						}
					}
				}

				const ajustes = await this.obtenerAjustesPorEmpresa(companiaId, this.vigencia, []);

				this.generatingProgress = 75;
				this.generatingMessage = 'Organizando datos...';

				const datos = {
					titulo: `DETALLE COMPLETO - ${companiaNombre}`,
					compania: companiaNombre,
					vigencia: this.vigencia,
					reporte: this.reportes?.find(r => r.codigo === this.codReporte)?.nombre || 'Balance',
					informacion: lineasConCuentas,
					ajustes: ajustes || [],
					userName: this.$store.state.userName,
					esCombinado: esCombinado,
					esDescargaIndividual: true
				};

				this.generatingProgress = 90;
				this.generatingMessage = 'Generando Excel...';

				await this.hojaExcelDetalleCompleto(datos, companiaId, esCombinado);

				this.generatingProgress = 100;
				setTimeout(() => {
					this.showGeneratingModal = false;
				}, 500);

			} catch (error) {
				console.error('Error descargando detalle:', error);
				this.$toast.error(`Error al generar detalle para ${companiaNombre}`);
				this.showGeneratingModal = false;
			}
		},

		// Método auxiliar para descargar detalle de múltiples compañías
		async descargarDetalleMultipleCompanias(companias, esCombinado = false) {
			this.showGeneratingModal = true;
			this.generatingMessage = 'Recopilando información...';
			this.generatingSubMessage = `Procesando ${companias.length} compañía(s)`;
			this.generatingProgress = 0;

			try {
				this.$toast.info(`Generando detalle completo para ${companias.length} compañía(s)...`);

				// CORRECCIÓN: Crear workbook correctamente con ExcelJS
				const ExcelJS = require('exceljs');
				const workbook = new ExcelJS.Workbook();
				const worksheet = workbook.addWorksheet("Detalle Todas Empresas");

				const combinacionesAgregadas = new Set();

				const datosPorCompania = [];
				const totalCompanias = companias.length;

				for (let i = 0; i < companias.length; i++) {
					const compania = companias[i];

					this.generatingProgress = Math.round((i / totalCompanias) * 50);
					this.generatingMessage = `Procesando compañía ${i + 1} de ${totalCompanias}`;
					this.generatingSubMessage = `Empresa: ${compania.nombre}`;

					try {
						const resultBalance = await Balance.getBalanceNiif(
							this.codReporte,
							compania.id,
							this.vigencia
						);

						const balanceCompania = resultBalance.data.balanceNiif;
						if (!balanceCompania || balanceCompania.length === 0) continue;

						const detalleCompleto = [];

						for (const linea of balanceCompania) {
							if (linea.informacion === "I") {
								try {
									const resultCuentas = await Balance.getCuentasNiif(
										this.codReporte,
										compania.id,
										this.vigencia,
										linea.niif
									);

									if (resultCuentas.data.cuentas?.length > 0) {
										detalleCompleto.push({
											linea: linea.descripcion,
											niif: linea.niif,
											cuentas: resultCuentas.data.cuentas
										});
									}
								} catch (error) {
									console.warn(`Error obteniendo cuentas ${linea.niif}`, error);
								}
							}
						}

						// 🔹 Obtener ajustes
						const ajustesRaw = await this.obtenerAjustesPorEmpresa(
							compania.id,
							this.vigencia,
							this.EmpresasConsolida || []
						);

						// 🔹 FILTRO FINO
						const ajustesFiltrados = [];

						for (const ajuste of ajustesRaw) {
							const secuencia = ajuste.secuencia;
							const cuenta = ajuste.cuenta;
							const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || '';

							const clave = `${secuencia}|${cuenta}|${tipoAjuste}`;

							if (!combinacionesAgregadas.has(clave)) {
								combinacionesAgregadas.add(clave);
								ajustesFiltrados.push(ajuste);
							}
						}

						if (detalleCompleto.length > 0 || ajustesFiltrados.length > 0) {
							datosPorCompania.push({
								compania,
								detalle: detalleCompleto,
								ajustes: ajustesFiltrados
							});
						}

					} catch (error) {
						console.error(`Error procesando ${compania.nombre}:`, error);
					}
				}

				if (datosPorCompania.length === 0) {
					this.showGeneratingModal = false;
					this.$toast.warning("No se pudo generar detalle para ninguna compañía");
					return;
				}

				this.generatingProgress = 75;
				this.generatingMessage = 'Generando archivo Excel...';
				this.generatingSubMessage = 'Organizando datos';

				// Asegurarse de que this.obtenerAjustesOrigenB existe
				if (typeof this.obtenerAjustesOrigenB !== 'function') {
					console.warn("Método obtenerAjustesOrigenB no encontrado, creando método temporal");
					this.obtenerAjustesOrigenB = async function () {
						try {
							const response = await Balance.getAjustesOrigenB(this.codReporte, this.vigencia);
							return response.data.ajustesOrigenB || [];
						} catch (error) {
							console.error("Error en obtenerAjustesOrigenB:", error);
							return [];
						}
					};
				}

				// Llamar al método llenarHojaCombinada
				await this.llenarHojaCombinada(worksheet, datosPorCompania, "", esCombinado);

				this.generatingProgress = 95;
				this.generatingMessage = 'Finalizando archivo...';

				// CORRECCIÓN: Usar el método correcto de ExcelJS para obtener el buffer
				const buffer = await workbook.xlsx.writeBuffer();

				this.generatingProgress = 100;
				this.generatingMessage = '¡Completado!';

				const nombreArchivo = esCombinado
					? `Detalle_Completo_Combinado_${this.vigencia}.xlsx`
					: `Detalle_Completo_${this.vigencia}.xlsx`;

				setTimeout(() => {
					this.showGeneratingModal = false;
					this.descargarArchivo(buffer, nombreArchivo);
					this.$toast.success("Detalle completo generado exitosamente");
				}, 500);

			} catch (error) {
				this.showGeneratingModal = false;
				console.error('Error generando detalle múltiple:', error);
				this.$toast.error("Error al generar el detalle completo");
			}
		},

		async llenarHojaCombinada(worksheet, datosPorCompania, grupoNombre = "", esCombinado = false) {

			const titulo = `DETALLE COMPLETO - TODAS LAS EMPRESAS (CONSOLIDADO)`;

			let tituloConGrupo = titulo;
			if (grupoNombre) {
				tituloConGrupo = `DETALLE COMPLETO - ${grupoNombre} (CONSOLIDADO)`;
			}

			const vigencia = this.vigencia;
			const userName = this.$store.state.userName;
			const reporte = this.reportes.find(r => r.codigo === this.codReporte)?.nombre || 'Balance';

			// Obtener ajustes de origen B (esto es adicional, no debe afectar el Excel)
			let ajustesOrigenBExternos = [];
			try {
				if (typeof this.obtenerAjustesOrigenB === 'function') {
					ajustesOrigenBExternos = await this.obtenerAjustesOrigenB();
				} else {
					console.warn("Método obtenerAjustesOrigenB no disponible");
				}
			} catch (error) {
				console.error("Error obteniendo ajustes de origen B:", error);
				// Continuamos con el Excel aunque fallen los ajustes
			}

			const combinacionesAgregadas = new Set();

			let createdAt1 = new Date();
			let anio = createdAt1.getFullYear();
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0');
			let dia = String(createdAt1.getDate()).padStart(2, '0');
			let createdAt = anio + "-" + mes + "-" + dia;

			// ENCABEZADO PRINCIPAL - Calcular dinámicamente el rango de columnas
			let totalColumnsDetalle = 2 + datosPorCompania.length + 3; // CUENTA + DESCRIPCIÓN + N compañías + SUMATORIA + AJUSTES + CONSOLIDADO

			if (esCombinado) {
				totalColumnsDetalle += 2; // Agregar COMBINADO y TOTAL COMBINADO
			}

			console.log("totalColumnsDetalle:", totalColumnsDetalle);

			const endColDetalle = String.fromCharCode(65 + totalColumnsDetalle - 1);

			worksheet.mergeCells(`A1:${endColDetalle}1`);

			worksheet.getCell('A1').value = tituloConGrupo;
			worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true };
			worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" };

			worksheet.mergeCells(`A2:${endColDetalle}2`);
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Empresas: ${datosPorCompania.map(d => d.compania.nombre).join(', ')}`;
			worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true };
			worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" };

			worksheet.mergeCells(`A3:${endColDetalle}3`);
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`;
			worksheet.getCell('A3').font = { name: "Calibri", size: 11, bold: true };
			worksheet.getCell('A3').alignment = { horizontal: "center", vertical: "middle" };

			worksheet.addRow([]);

			let n_fila = 5;
			const numCompanias = datosPorCompania.length;
			console.log("numCompanias:", numCompanias);

			const companiasRow = ['COMPAÑÍAS', ''];

			// Agregar nombres de compañías en la fila de "Compañías"
			datosPorCompania.forEach((datoCompania, idx) => {
				console.log(`Compañía ${idx + 1}:`, datoCompania.compania?.nombre);
				companiasRow.push(datoCompania.compania.nombre);
			});

			// Agregar las nuevas columnas al final
			companiasRow.push('SUMATORIA');
			companiasRow.push('AJUSTES');
			companiasRow.push('CONSOLIDADO');

			if (esCombinado) {
				companiasRow.push('COMBINADO');
				companiasRow.push('TOTAL COMBINADO');
			}

			console.log("companiasRow:", companiasRow);
			worksheet.addRow(companiasRow);

			// Aplicar estilos a la fila de Compañías
			// Primera columna "COMPAÑÍAS"
			let companiaCell = worksheet.getCell(n_fila, 1);
			companiaCell.font = { name: "Calibri", size: 11, bold: true };
			companiaCell.alignment = { horizontal: "center", vertical: "middle" };
			companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
			worksheet.mergeCells(n_fila, 1, n_fila, 2);

			// Nombres de compañías en sus columnas correspondientes
			datosPorCompania.forEach((datoCompania, idx) => {
				let nombreCompaniaCell = worksheet.getCell(n_fila, idx + 3);
				nombreCompaniaCell.font = { name: "Calibri", size: 11, bold: true };
				nombreCompaniaCell.alignment = { horizontal: "center", vertical: "middle" };

				if (idx % 2 === 0) {
					nombreCompaniaCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FCE4D6" }
					};
				} else {
					nombreCompaniaCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "D9EAD3" }
					};
				}

				nombreCompaniaCell.border = {
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};
			});

			// Estilos para las nuevas columnas
			const sumatoriaCol = numCompanias + 3;
			const ajustesCol = sumatoriaCol + 1;
			const consolidadoCol = ajustesCol + 1;

			console.log("Posiciones columnas - sumatoriaCol:", sumatoriaCol, "ajustesCol:", ajustesCol, "consolidadoCol:", consolidadoCol);

			// SUMATORIA
			let sumatoriaCell = worksheet.getCell(n_fila, sumatoriaCol);
			sumatoriaCell.font = { name: "Calibri", size: 11, bold: true };
			sumatoriaCell.alignment = { horizontal: "center", vertical: "middle" };
			sumatoriaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

			// AJUSTES
			let ajustesCell = worksheet.getCell(n_fila, ajustesCol);
			ajustesCell.font = { name: "Calibri", size: 11, bold: true };
			ajustesCell.alignment = { horizontal: "center", vertical: "middle" };
			ajustesCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

			// CONSOLIDADO
			let consolidadoCell = worksheet.getCell(n_fila, consolidadoCol);
			consolidadoCell.font = { name: "Calibri", size: 11, bold: true };
			consolidadoCell.alignment = { horizontal: "center", vertical: "middle" };
			consolidadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

			// AGREGAR ESTILOS PARA COMBINADO Y TOTAL COMBINADO
			if (esCombinado) {
				const combinadoCol = consolidadoCol + 1;
				const totalCombinadoCol = combinadoCol + 1;

				// COMBINADO
				let combinadoCell = worksheet.getCell(n_fila, combinadoCol);
				combinadoCell.font = { name: "Calibri", size: 11, bold: true };
				combinadoCell.alignment = { horizontal: "center", vertical: "middle" };
				combinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };

				// TOTAL COMBINADO
				let totalCombinadoCell = worksheet.getCell(n_fila, totalCombinadoCol);
				totalCombinadoCell.font = { name: "Calibri", size: 11, bold: true };
				totalCombinadoCell.alignment = { horizontal: "center", vertical: "middle" };
				totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
			}

			n_fila++;
			console.log("Fila actual después de encabezados:", n_fila);

			// ===== MAPAS DE AJUSTES =====
			const ajustesPorNiif = {};
			const ajustesPorNiifCuenta = {};
			const ajustesOrigenBPorCuenta = {}; // Para COMBINADO (solo origen B)

			// PROCESAR AJUSTES EXISTENTES (los que ya vienen en datosPorCompania)
			console.log("=== PROCESANDO AJUSTES EXISTENTES ===");
			datosPorCompania.forEach((datoCompania, idxCompania) => {
				console.log(`Procesando ajustes de compañía ${idxCompania + 1}: ${datoCompania.compania?.nombre}`);

				if (datoCompania.ajustes && datoCompania.ajustes.length > 0) {
					console.log(`  Cantidad ajustes: ${datoCompania.ajustes.length}`);

					datoCompania.ajustes.forEach((ajuste, idxAjuste) => {
						const niif = ajuste.niif;
						const cuenta = ajuste.cuenta;
						const valor = parseFloat(
							ajuste.ajuste_funcional1 ||
							ajuste.ajuste_funcional1_rounded ||
							ajuste.ajuste_actual ||
							ajuste.ajuste_actual_rounded ||
							0
						);

						if (idxAjuste < 3) { // Log solo primeros 3 ajustes para no saturar
							console.log(`  Ajuste ${idxAjuste + 1}: niif=${niif}, cuenta=${cuenta}, valor=${valor}`);
						}

						// TOTAL POR NIIF (para la fila TOTAL)
						if (!ajustesPorNiif[niif]) {
							ajustesPorNiif[niif] = 0;
						}
						ajustesPorNiif[niif] += valor;

						// TOTAL POR NIIF + CUENTA (para filas de cuentas)
						if (!ajustesPorNiifCuenta[niif]) {
							ajustesPorNiifCuenta[niif] = {};
						}
						if (!ajustesPorNiifCuenta[niif][cuenta]) {
							ajustesPorNiifCuenta[niif][cuenta] = 0;
						}
						ajustesPorNiifCuenta[niif][cuenta] += valor;
					});
				} else {
					console.log(`  No hay ajustes para esta compañía`);
				}
			});

			// PROCESAR AJUSTES DE ORIGEN B EXTERNOS (sin modificar datosPorCompania)
			console.log("=== PROCESANDO AJUSTES ORIGEN B EXTERNOS ===");
			if (ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) {
				console.log(`Total ajustes origen B externos: ${ajustesOrigenBExternos.length}`);

				ajustesOrigenBExternos.forEach((ajuste, idx) => {
					const cuenta = ajuste.cuenta;

					if (!ajustesOrigenBPorCuenta[cuenta]) {
						ajustesOrigenBPorCuenta[cuenta] = 0;
					}

					const valorOrigenB = parseFloat(
						ajuste.ajuste_actual ||
						ajuste.ajuste_actual_rounded ||
						0
					);

					ajustesOrigenBPorCuenta[cuenta] += valorOrigenB;

					console.log(`  Ajuste ${idx + 1}: cuenta=${cuenta}, valor=${valorOrigenB}, total acumulado=${ajustesOrigenBPorCuenta[cuenta]}`);
				});
			} else {
				console.log("No hay ajustes origen B externos");
			}

			console.log("AJUSTES ORIGEN B POR CUENTA FINAL:", ajustesOrigenBPorCuenta);

			// Primero, recopilar todas las cuentas únicas de todas las compañías y NIIFs
			console.log("=== RECOPILANDO CUENTAS ===");
			const todasLasCuentas = {};

			// Recorrer todas las compañías y sus líneas NIIF
			datosPorCompania.forEach((datoCompania, idxCompania) => {
				const companiaId = datoCompania.compania.id;
				console.log(`Procesando detalle de compañía ${idxCompania + 1} (ID: ${companiaId})`);

				if (!datoCompania.detalle || datoCompania.detalle.length === 0) {
					console.log(`  Compañía ${idxCompania + 1} no tiene detalle!`);
					return;
				}

				console.log(`  Detalle length: ${datoCompania.detalle.length}`);

				datoCompania.detalle.forEach((linea, idxLinea) => {
					const niifKey = `${linea.niif}-${linea.linea}`;

					if (!todasLasCuentas[niifKey]) {
						todasLasCuentas[niifKey] = {
							niif: linea.niif,
							descripcionLinea: linea.linea,
							cuentas: new Map() // Usar Map para evitar duplicados por cuenta
						};
						console.log(`  Creando NIIF key: ${niifKey}`);
					}

					// Procesar cada cuenta de esta línea
					if (!linea.cuentas || linea.cuentas.length === 0) {
						console.log(`    Línea ${idxLinea + 1} no tiene cuentas!`);
						return;
					}

					linea.cuentas.forEach((cuenta, idxCuenta) => {
						if (cuenta.cuenta) {
							const cuentaKey = cuenta.cuenta;

							if (!todasLasCuentas[niifKey].cuentas.has(cuentaKey)) {
								// Si la cuenta no existe, crearla
								todasLasCuentas[niifKey].cuentas.set(cuentaKey, {
									cuenta: cuenta.cuenta,
									descripcion: cuenta.descripcion || '',
									saldos: new Array(numCompanias).fill(0)
								});
								if (idxCuenta < 5) { // Log solo primeras 5 cuentas
									console.log(`    Creando cuenta: ${cuentaKey} - ${cuenta.descripcion || ''}`);
								}
							}

							// Obtener el índice de esta compañía
							const companiaIndex = datosPorCompania.findIndex(d => d.compania.id === companiaId);

							if (companiaIndex !== -1) {
								// Actualizar el saldo en la posición correspondiente a esta compañía
								const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuentaKey);
								const saldoAnterior = cuentaData.saldos[companiaIndex];
								cuentaData.saldos[companiaIndex] = parseFloat(cuenta.funcional1) || 0;

								if (idxCuenta < 5 && Math.abs(cuentaData.saldos[companiaIndex]) > 0) {
									console.log(`    Actualizando cuenta ${cuentaKey} para compañía ${companiaIndex + 1}: ${saldoAnterior} -> ${cuentaData.saldos[companiaIndex]}`);
								}

								// Si la descripción está vacía y esta compañía tiene una, usarla
								if (!cuentaData.descripcion && cuenta.descripcion) {
									cuentaData.descripcion = cuenta.descripcion;
								}

								todasLasCuentas[niifKey].cuentas.set(cuentaKey, cuentaData);
							}
						}
					});
				});
			});

			// Incluir cuentas de reclasificación (origen='R') aunque no existan en el detalle base por NIIF.
			// Esto permite mostrar en la tabla superior el paso de un NIIF a otro para la misma cuenta.
			const descripcionPorNiif = {};
			Object.keys(todasLasCuentas).forEach((niifKey) => {
				const niifData = todasLasCuentas[niifKey];
				if (!descripcionPorNiif[niifData.niif]) {
					descripcionPorNiif[niifData.niif] = niifData.descripcionLinea || 'AJUSTES';
				}
			});

				datosPorCompania.forEach((datoCompania) => {
					if (!datoCompania.ajustes || datoCompania.ajustes.length === 0) return;

					datoCompania.ajustes.forEach((ajuste) => {
						const cuentaStr = String(ajuste.cuenta || '').trim();
						const cuentaDigitos = cuentaStr.replace(/\D/g, '');
						const esCuenta99 = cuentaDigitos.endsWith('99');
						const esReclasificacion = ajuste.origen === 'R';
						const esAjusteAI = ajuste.origen === 'A' || ajuste.origen === 'I';
						const esAICon99 = esAjusteAI && esCuenta99;
						if (!esReclasificacion && !esAICon99) return;

					const niif = ajuste.niif;
					const cuenta = ajuste.cuenta;
					if (!niif || !cuenta) return;

						const descripcionLinea = descripcionPorNiif[niif] || 'AJUSTES';
						const niifKey = `${niif}-${descripcionLinea}`;
						const yaExisteCuenta = todasLasCuentas[niifKey]?.cuentas?.has(cuenta);

						if (!todasLasCuentas[niifKey]) {
							todasLasCuentas[niifKey] = {
								niif: niif,
								descripcionLinea: descripcionLinea,
							cuentas: new Map()
						};
					}

					if (!todasLasCuentas[niifKey].cuentas.has(cuenta)) {
						todasLasCuentas[niifKey].cuentas.set(cuenta, {
							cuenta: cuenta,
							descripcion: ajuste.descripcion || '',
								saldos: new Array(numCompanias).fill(0)
							});
						}

						const companiaAjuste = Number(ajuste.id_compania);
						const companiaIndex = datosPorCompania.findIndex(
							d => Number(d.compania.id) === companiaAjuste
						);

						if (companiaIndex !== -1) {
							const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuenta);
							const saldoActual = parseFloat(cuentaData.saldos[companiaIndex]) || 0;

							if (esReclasificacion) {
								const valorAjuste = parseFloat(
									ajuste.ajuste_funcional1 ||
									ajuste.ajuste_funcional1_rounded ||
									ajuste.ajuste_actual ||
									ajuste.ajuste_actual_rounded ||
									0
								) || 0;
								const saldoEspejo = -valorAjuste;

								// Para reclasificación, si la cuenta no estaba en el detalle base (o venía en cero),
								// reflejar el saldo opuesto al ajuste en la compañía real del movimiento.
								if (!yaExisteCuenta || saldoActual === 0) {
									cuentaData.saldos[companiaIndex] = saldoActual + saldoEspejo;
								}
							}

							if (!cuentaData.descripcion && ajuste.descripcion) {
								cuentaData.descripcion = ajuste.descripcion;
							}
							todasLasCuentas[niifKey].cuentas.set(cuenta, cuentaData);
						}
					});
				});

			console.log("Total NIIFs procesados:", Object.keys(todasLasCuentas).length);

			// Ahora, para cada NIIF, crear la sección en el Excel
			console.log("=== CREANDO SECCIONES EN EXCEL ===");
			const niifKeys = Object.keys(todasLasCuentas);
			console.log("NIIFs a procesar:", niifKeys);

			niifKeys.forEach((niifKey, idxNiif) => {
				const dataNiif = todasLasCuentas[niifKey];
				console.log(`Procesando NIIF ${idxNiif + 1}: ${dataNiif.niif} - ${dataNiif.descripcionLinea}`);

				// FILA DE NIIF (solo en las primeras dos columnas)
				worksheet.mergeCells(`A${n_fila}:B${n_fila}`);
				worksheet.getCell(`A${n_fila}`).value = `${dataNiif.niif} - ${dataNiif.descripcionLinea}`;
				worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 11, bold: true };
				worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" };
				worksheet.getCell(`A${n_fila}`).fill = {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "F2F2F2" } // Gris muy claro
				};
				worksheet.getCell(`A${n_fila}`).border = {
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};

				n_fila++;

				// ENCABEZADO DE COLUMNAS DE DATOS
				const headerRow = ['CUENTA', 'DESCRIPCIÓN'];

				// Agregar "FUNCIONAL" repetido para cada compañía
				for (let i = 0; i < datosPorCompania.length; i++) {
					headerRow.push('FUNCIONAL');
				}

				// Agregar las nuevas columnas al final
				headerRow.push('SUMATORIA');
				headerRow.push('AJUSTES');
				headerRow.push('CONSOLIDADO');

				if (esCombinado) {
					headerRow.push('COMBINADO');
					headerRow.push('TOTAL COMBINADO');
				}

				console.log(`  headerRow length: ${headerRow.length}`);
				worksheet.addRow(headerRow);

				for (let i = 1; i <= headerRow.length; i++) {
					let headerCell = worksheet.getCell(n_fila, i);
					headerCell.font = { name: "Calibri", size: 11, bold: true };
					headerCell.alignment = { horizontal: "center", vertical: "middle" };

					if (i <= 2) {
						// CUENTA y DESCRIPCIÓN - Gris claro
						headerCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					} else if (i <= numCompanias + 2) {
						// FUNCIONAL por compañía
						const companiaIndex = i - 3;
						if (companiaIndex % 2 === 0) {
							headerCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
							headerCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
					} else {
						// Todas las demás columnas (SUMATORIA, AJUSTES, CONSOLIDADO, COMBINADO, TOTAL COMBINADO)
						headerCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					}

					headerCell.border = {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}

				// IMPORTANTE: Incrementar n_fila DESPUÉS de aplicar estilos
				n_fila++;

				// Convertir Map a Array y ordenar por cuenta
				const cuentasArray = Array.from(dataNiif.cuentas.values())
					.sort((a, b) => a.cuenta.localeCompare(b.cuenta));

				console.log(`  Total cuentas en este NIIF: ${cuentasArray.length}`);

				// DATOS DE CUENTAS
				cuentasArray.forEach((cuenta) => {
					const dataRow = [cuenta.cuenta, cuenta.descripcion];

					// Agregar saldos para cada compañía
					cuenta.saldos.forEach(saldo => {
						dataRow.push(saldo);
					});

					// Calcular sumatoria horizontal para esta fila
					let sumatoria = 0;
					cuenta.saldos.forEach(saldo => {
						sumatoria += saldo;
					});
					dataRow.push(sumatoria);

					// AJUSTES por cuenta y NIIF
					const ajusteCuenta = ajustesPorNiifCuenta[dataNiif.niif]?.[cuenta.cuenta] || 0;
					dataRow.push(ajusteCuenta);

					// CONSOLIDADO (sumatoria + ajuste)
					const consolidado = sumatoria + ajusteCuenta;
					dataRow.push(consolidado);

					// COMBINADO (solo origen B)
					let combinadoValor = 0;
					if (esCombinado) {
						combinadoValor = ajustesOrigenBPorCuenta[cuenta.cuenta] || 0;
						dataRow.push(combinadoValor);

						// TOTAL COMBINADO (consolidado + combinado)
						dataRow.push(consolidado + combinadoValor);
					}

					worksheet.addRow(dataRow);

					// Aplicar estilos a la fila
					let colCell = 1;

					// CUENTA
					let dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "left", vertical: "middle" };
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					// DESCRIPCIÓN
					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "left", vertical: "middle" };
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					// SALDOS por compañía
					cuenta.saldos.forEach((saldo, saldoIndex) => {
						dataCell = worksheet.getCell(n_fila, colCell);
						dataCell.value = saldo;
						dataCell.font = { name: "Calibri", size: 10 };
						dataCell.alignment = { horizontal: "right", vertical: "middle" };
						dataCell.numFmt = "#,##0";

						// Color de fondo alternado según compañía
						if (saldoIndex % 2 === 0) {
							dataCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCF8F3" }
							};
						} else {
							dataCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "F7FCF5" }
							};
						}

						dataCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;
					});

					// SUMATORIA
					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.value = sumatoria;
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "right", vertical: "middle" };
					dataCell.numFmt = "#,##0";
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					// AJUSTES
					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.value = ajusteCuenta;
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "right", vertical: "middle" };
					dataCell.numFmt = "#,##0";
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					// CONSOLIDADO
					dataCell = worksheet.getCell(n_fila, colCell);
					dataCell.value = consolidado;
					dataCell.font = { name: "Calibri", size: 10 };
					dataCell.alignment = { horizontal: "right", vertical: "middle" };
					dataCell.numFmt = "#,##0";
					dataCell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;

					if (esCombinado) {
						// COMBINADO
						dataCell = worksheet.getCell(n_fila, colCell);
						dataCell.value = combinadoValor;
						dataCell.font = { name: "Calibri", size: 10 };
						dataCell.alignment = { horizontal: "right", vertical: "middle" };
						dataCell.numFmt = "#,##0";
						dataCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;

						// TOTAL COMBINADO
						dataCell = worksheet.getCell(n_fila, colCell);
						dataCell.value = consolidado + combinadoValor;
						dataCell.font = { name: "Calibri", size: 10 };
						dataCell.alignment = { horizontal: "right", vertical: "middle" };
						dataCell.numFmt = "#,##0";
						dataCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}

					n_fila++;
				});

				// FILA DE TOTAL POR NIIF Y POR COMPAÑÍA
				const totalRow = ['', 'TOTAL ' + dataNiif.niif];

				// Calcular totales por compañía para esta NIIF
				const totalesPorCompania = new Array(numCompanias).fill(0);
				let totalSumatoria = 0;

				cuentasArray.forEach(cuenta => {
					cuenta.saldos.forEach((saldo, idx) => {
						totalesPorCompania[idx] += saldo;
					});
				});

				// Agregar totales a la fila
				totalesPorCompania.forEach(total => {
					totalRow.push(total);
					totalSumatoria += total;
				});

				// Obtener ajustes para este NIIF
				const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0;

				// SUMATORIA (suma de todas las compañías)
				totalRow.push(totalSumatoria);

				// AJUSTES (total de ajustes para este NIIF)
				totalRow.push(ajusteNiif);

				// CONSOLIDADO (sumatoria + ajustes)
				const consolidadoTotal = totalSumatoria + ajusteNiif;
				totalRow.push(consolidadoTotal);

				if (esCombinado) {
					// Calcular total combinado para este NIIF
					let totalCombinado = 0;
					cuentasArray.forEach(cuenta => {
						totalCombinado += ajustesOrigenBPorCuenta[cuenta.cuenta] || 0;
					});
					totalRow.push(totalCombinado);
					totalRow.push(consolidadoTotal + totalCombinado);

					console.log(`  TOTAL NIIF ${dataNiif.niif} - sumatoria: ${totalSumatoria}, ajustes: ${ajusteNiif}, consolidado: ${consolidadoTotal}, combinado: ${totalCombinado}`);
				}

				worksheet.addRow(totalRow);

				// Aplicar estilos a la fila de total
				let colTotal = 1;

				// Celda vacía (columna cuenta)
				let totalCell = worksheet.getCell(n_fila, colTotal);
				totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
				colTotal++;

				// TOTAL descripción
				totalCell = worksheet.getCell(n_fila, colTotal);
				totalCell.font = { name: "Calibri", size: 10, bold: true };
				totalCell.alignment = { horizontal: "right", vertical: "middle" };
				totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
				colTotal++;

				// TOTALES numéricos por compañía
				totalesPorCompania.forEach((total) => {
					let companiaCell = worksheet.getCell(n_fila, colTotal);
					companiaCell.value = total;
					companiaCell.font = { name: "Calibri", size: 10, bold: true };
					companiaCell.alignment = { horizontal: "right", vertical: "middle" };
					companiaCell.numFmt = "#,##0";
					companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } };
					companiaCell.border = {
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;
				});

				// SUMATORIA total
				let sumatoriaCellTotal = worksheet.getCell(n_fila, colTotal);
				sumatoriaCellTotal.value = totalSumatoria;
				sumatoriaCellTotal.font = { name: "Calibri", size: 10, bold: true };
				sumatoriaCellTotal.alignment = { horizontal: "right", vertical: "middle" };
				sumatoriaCellTotal.numFmt = "#,##0";
				sumatoriaCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D9E1F2" } };
				sumatoriaCellTotal.border = {
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;

				// AJUSTES total
				let ajustesCellTotal = worksheet.getCell(n_fila, colTotal);
				ajustesCellTotal.value = ajusteNiif;
				ajustesCellTotal.font = { name: "Calibri", size: 10, bold: true };
				ajustesCellTotal.alignment = { horizontal: "right", vertical: "middle" };
				ajustesCellTotal.numFmt = "#,##0";
				ajustesCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2CC" } };
				ajustesCellTotal.border = {
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;

				// CONSOLIDADO total
				let consolidadoCellTotal = worksheet.getCell(n_fila, colTotal);
				consolidadoCellTotal.value = consolidadoTotal;
				consolidadoCellTotal.font = { name: "Calibri", size: 10, bold: true };
				consolidadoCellTotal.alignment = { horizontal: "right", vertical: "middle" };
				consolidadoCellTotal.numFmt = "#,##0";
				consolidadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E2EFDA" } };
				consolidadoCellTotal.border = {
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;

				if (esCombinado) {
					// COMBINADO total
					let totalCombinado = 0;
					cuentasArray.forEach(cuenta => {
						totalCombinado += ajustesOrigenBPorCuenta[cuenta.cuenta] || 0;
					});

					let combinadoCellTotal = worksheet.getCell(n_fila, colTotal);
					combinadoCellTotal.value = totalCombinado;
					combinadoCellTotal.font = { name: "Calibri", size: 10, bold: true };
					combinadoCellTotal.alignment = { horizontal: "right", vertical: "middle" };
					combinadoCellTotal.numFmt = "#,##0";
					combinadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } };
					combinadoCellTotal.border = {
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;

					// TOTAL COMBINADO
					let totalCombinadoCell = worksheet.getCell(n_fila, colTotal);
					totalCombinadoCell.value = consolidadoTotal + totalCombinado;
					totalCombinadoCell.font = { name: "Calibri", size: 10, bold: true };
					totalCombinadoCell.alignment = { horizontal: "right", vertical: "middle" };
					totalCombinadoCell.numFmt = "#,##0";
					totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "B8CCE4" } };
					totalCombinadoCell.border = {
						top: { style: "thin" },
						bottom: { style: "double" }
					};
				}

				n_fila++;
			});

			// AGREGAR TODOS LOS AJUSTES (incluyendo los de origen B si existen)
			console.log("=== AGREGANDO TABLA DE AJUSTES ===");
			const todosAjustes = [];

			// Ajustes existentes - USAR EL NOMBRE DE COMPAÑÍA QUE VIENE DEL BACKEND
			datosPorCompania.forEach(datoCompania => {
				if (datoCompania.ajustes && datoCompania.ajustes.length > 0) {
					todosAjustes.push(...datoCompania.ajustes.map(ajuste => ({
						...ajuste,
						// Usar el nombre_compania que viene del backend si existe
						compania_origen: ajuste.nombre_compania || datoCompania.compania.nombre
					})));
				}
			});

			// Agregar ajustes de origen B externos si existen - USAR EL NOMBRE DE COMPAÑÍA DEL BACKEND
			if (esCombinado && ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) {
				ajustesOrigenBExternos.forEach(ajuste => {
					const compania = datosPorCompania.find(d => d.compania.id === ajuste.id_compania);

					const secuencia = ajuste.secuencia;
					const cuenta = ajuste.cuenta;
					const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || '';
					const clave = `${secuencia}|${cuenta}|${tipoAjuste}`;

					if (!combinacionesAgregadas.has(clave)) {
						combinacionesAgregadas.add(clave);

						todosAjustes.push({
							...ajuste,
							// Usar el nombre_compania que viene del backend si existe, si no, usar el de la compañía encontrada o el ID
							compania_origen: ajuste.nombre_compania ||
								(compania ? compania.compania.nombre : `ID: ${ajuste.id_compania}`),
							origen: 'B'
						});
					}
				});
			}

			console.log(`Total ajustes para tabla final: ${todosAjustes.length}`);

			worksheet.addRow([]);
			n_fila++;

			// Calcular totales por compañía (excluyendo NIIF 9000)
			console.log("=== CALCULANDO ECUACIÓN PATRIMONIAL ===");
			const totalesEcuacionPorCompania = new Array(datosPorCompania.length).fill(0);
			const ajustesEcuacionPorCompania = new Array(datosPorCompania.length).fill(0);

			// Recorrer todos los NIIF y sumar (excluyendo 9000)
			Object.keys(todasLasCuentas).forEach(niifKey => {
				const dataNiif = todasLasCuentas[niifKey];

				// Excluir NIIF 9000
				if (dataNiif.niif && dataNiif.niif.toString().startsWith('9000')) {
					console.log(`Excluyendo NIIF 9000: ${dataNiif.niif}`);
					return; // Saltar NIIF 9000
				}

				// Calcular totales para este NIIF
				const cuentasArray = Array.from(dataNiif.cuentas.values());
				const totalesPorCompaniaNiif = new Array(datosPorCompania.length).fill(0);

				cuentasArray.forEach(cuenta => {
					cuenta.saldos.forEach((saldo, idx) => {
						totalesPorCompaniaNiif[idx] += saldo;
					});
				});

				// Sumar a los totales generales
				totalesPorCompaniaNiif.forEach((total, idx) => {
					totalesEcuacionPorCompania[idx] += total;

					// Obtener ajustes para este NIIF
					const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0;
					// Distribuir ajustes proporcionalmente entre compañías
					const totalNiif = totalesPorCompaniaNiif.reduce((a, b) => a + b, 0);
					const ajustePorCompania = total !== 0 && totalNiif !== 0 ? (ajusteNiif * total / totalNiif) : 0;

					ajustesEcuacionPorCompania[idx] += ajustePorCompania;
				});
			});

			console.log("Totales ecuación por compañía:", totalesEcuacionPorCompania);
			console.log("Ajustes ecuación por compañía:", ajustesEcuacionPorCompania);

			// Crear fila de Ecuación Patrimonial
			const ecuacionRowData = ['ECUACIÓN PATRIMONIAL', ''];

			// Agregar totales por compañía (suma de NIIF, excluyendo 9000)
			datosPorCompania.forEach((datoCompania, idx) => {
				const totalCompania = totalesEcuacionPorCompania[idx] || 0;
				ecuacionRowData.push(totalCompania);
			});

			// Agregar columnas de ajustes y consolidado
			let sumaTotalEcuacion = 0;
			let sumaAjustesEcuacion = 0;

			// Calcular sumatorias
			datosPorCompania.forEach((datoCompania, idx) => {
				const totalCompania = totalesEcuacionPorCompania[idx] || 0;
				const ajusteCompania = ajustesEcuacionPorCompania[idx] || 0;

				sumaTotalEcuacion += totalCompania;
				sumaAjustesEcuacion += ajusteCompania;
			});

			// Agregar columnas de SUMATORIA y AJUSTES
			ecuacionRowData.push(sumaTotalEcuacion); // SUMATORIA
			ecuacionRowData.push(sumaAjustesEcuacion); // AJUSTES

			// CONSOLIDADO (Sumatoria + Ajustes)
			const consolidadoEcuacion = sumaTotalEcuacion + sumaAjustesEcuacion;
			ecuacionRowData.push(consolidadoEcuacion);

			if (esCombinado) {
				// Calcular total combinado para ecuación patrimonial (suma de todos los origen B)
				let totalCombinadoEcuacion = 0;
				Object.values(ajustesOrigenBPorCuenta).forEach(valor => {
					totalCombinadoEcuacion += valor;
				});
				ecuacionRowData.push(totalCombinadoEcuacion);
				ecuacionRowData.push(consolidadoEcuacion + totalCombinadoEcuacion);

				console.log("Ecuación patrimonial - totalCombinado:", totalCombinadoEcuacion);
			}

			console.log("Fila ecuación patrimonial:", ecuacionRowData);

			// Agregar fila de Ecuación Patrimonial
			worksheet.addRow(ecuacionRowData);

			// Aplicar estilos a la fila de Ecuación Patrimonial
			for (let i = 1; i <= ecuacionRowData.length; i++) {
				const ecuacionCell = worksheet.getCell(n_fila, i);

				if (i === 1) {
					// Columna A: "ECUACIÓN PATRIMONIAL"
					ecuacionCell.font = { name: "Calibri", size: 11, bold: true };
					ecuacionCell.alignment = { horizontal: "left", vertical: "middle" };
					// Fusionar A y B
					worksheet.mergeCells(n_fila, 1, n_fila, 2);
				} else if (i === 2) {
					// Columna B: vacía (fusionada con A)
					continue;
				} else {
					// Columnas numéricas
					ecuacionCell.font = { name: "Calibri", size: 11, bold: true };
					ecuacionCell.alignment = { horizontal: "right", vertical: "middle" };
					ecuacionCell.numFmt = "#,##0";

					// Color de fondo diferenciado
					if (i <= datosPorCompania.length + 2) { // Columnas de compañías
						if ((i - 2) % 2 === 1) {
							ecuacionCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
							ecuacionCell.fill = {
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
					} else if (i === datosPorCompania.length + 3) { // SUMATORIA
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "D9E1F2" }
						};
					} else if (i === datosPorCompania.length + 4) { // AJUSTES
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFF2CC" }
						};
					} else if (i === datosPorCompania.length + 5) { // CONSOLIDADO
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E2EFDA" }
						};
					} else if (i === datosPorCompania.length + 6) { // COMBINADO
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFE699" }
						};
					} else if (i === datosPorCompania.length + 7) { // TOTAL COMBINADO
						ecuacionCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "B8CCE4" }
						};
					}
				}

				// Bordes
				ecuacionCell.border = {
					top: { style: "medium" },
					left: { style: "thin" },
					right: { style: "thin" },
					bottom: { style: "double" }
				};
			}

			n_fila++;
			worksheet.addRow([]);
			n_fila++;

			if (todosAjustes.length > 0) {
				console.log("Creando tabla de ajustes con", todosAjustes.length, "registros");

				// Espacio antes de ajustes
				worksheet.addRow([]);
				n_fila++;

				const ajustesHeaders = [
					'COMPAÑIA',
					'NIIF',
					'SECUENCIA',
					'TIPO',
					'TIPO AJUSTE',
					'CUENTA',
					'SALDO ORIGINAL',
					'AJUSTE LOCAL',
					'AJUSTE FUNCIONAL',
					'DESCRIPCIÓN',
					'ORIGEN'
				];

				const totalColumnsAjustes = ajustesHeaders.length;
				const endColAjustes = String.fromCharCode(65 + totalColumnsAjustes - 1);

				worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`);
				worksheet.getCell(`A${n_fila}`).value = `AJUSTES DE CONSOLIDACIÓN - TODAS LAS EMPRESAS`;
				worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 12, bold: true };
				worksheet.getCell(`A${n_fila}`).fill = {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "FFF2CC" }
				};
				worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" };
				n_fila++;

				// Crear encabezados de ajustes
				for (let i = 0; i < ajustesHeaders.length; i++) {
					worksheet.getCell(n_fila, i + 1).value = ajustesHeaders[i];
					worksheet.getCell(n_fila, i + 1).font = { name: "Calibri", size: 11, bold: true };
					worksheet.getCell(n_fila, i + 1).alignment = { horizontal: "center", vertical: "middle" };
					worksheet.getCell(n_fila, i + 1).fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "E6E6E6" }
					};
					worksheet.getCell(n_fila, i + 1).border = {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}
				n_fila++;

				// DATOS DE AJUSTES - USAR EL NOMBRE DE COMPAÑÍA QUE VIENE DEL BACKEND
				todosAjustes.forEach((ajuste, idx) => {
					if (idx < 5) {
						console.log(`Ajuste ${idx + 1}:`, ajuste);
					}

					let tipoAjusteTexto = ajuste.tipo_ajuste || '';
					if (tipoAjusteTexto === 'O') {
						tipoAjusteTexto = 'Origen';
					} else if (tipoAjusteTexto === 'D') {
						tipoAjusteTexto = 'Destino';
					}

					let niifConDescripcion = ajuste.niif || '';

					if (this.balance && this.balance.length > 0 && ajuste.niif) {
						const niifInfo = this.balance.find(item => item.niif === ajuste.niif);
						if (niifInfo && niifInfo.descripcion) {
							niifConDescripcion = `${ajuste.niif} - ${niifInfo.descripcion}`;
						}
					}

					// USAR EL NOMBRE DE COMPAÑÍA DEL AJUSTE (nombre_compania) QUE VIENE DEL BACKEND
					worksheet.getCell(n_fila, 1).value = ajuste.nombre_compania || ajuste.compania_origen || '';
					worksheet.getCell(n_fila, 2).value = niifConDescripcion;
					worksheet.getCell(n_fila, 3).value = ajuste.secuencia || '';
					worksheet.getCell(n_fila, 4).value = ajuste.tipo_participante || '';
					worksheet.getCell(n_fila, 5).value = tipoAjusteTexto;
					worksheet.getCell(n_fila, 6).value = ajuste.cuenta || '';
					worksheet.getCell(n_fila, 7).value = ajuste.saldo_actual || 0;
					worksheet.getCell(n_fila, 8).value = ajuste.ajuste_actual || ajuste.ajuste_actual_rounded || 0;
					worksheet.getCell(n_fila, 9).value =
						ajuste.ajuste_funcional1 ||
						ajuste.ajuste_funcional1_rounded ||
						ajuste.ajuste_actual ||
						ajuste.ajuste_actual_rounded ||
						0;
					worksheet.getCell(n_fila, 10).value = ajuste.descripcion || '';
					worksheet.getCell(n_fila, 11).value = ajuste.origen || '';

					// Aplicar estilos
					for (let i = 1; i <= ajustesHeaders.length; i++) {
						const ajusteCell = worksheet.getCell(n_fila, i);
						ajusteCell.font = { name: "Calibri", size: 10 };
						ajusteCell.alignment = { horizontal: "left", vertical: "middle" };

						if (i >= 7 && i <= 9) {
							ajusteCell.alignment = { horizontal: "right", vertical: "middle" };
							ajusteCell.numFmt = "#,##0";
						}

						ajusteCell.fill = {
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "F5F5F5" }
						};

						ajusteCell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
					n_fila++;
				});
			} else {
				console.log("No hay ajustes para mostrar en la tabla final");
			}

			// AJUSTAR ANCHO DE COLUMNAS dinámicamente
			console.log("=== AJUSTANDO ANCHO DE COLUMNAS ===");
			const columnWidths = [
				{ width: 15 }, // CUENTA
				{ width: 40 }, // DESCRIPCIÓN
			];

			// Agregar anchos para cada columna FUNCIONAL
			for (let i = 0; i < numCompanias; i++) {
				columnWidths.push({ width: 18 }); // FUNCIONAL [Compañía]
			}

			// Agregar anchos para las nuevas columnas
			columnWidths.push({ width: 18 }); // SUMATORIA
			columnWidths.push({ width: 18 }); // AJUSTES
			columnWidths.push({ width: 18 }); // CONSOLIDADO

			if (esCombinado) {
				columnWidths.push({ width: 18 }); // COMBINADO
				columnWidths.push({ width: 18 }); // TOTAL COMBINADO
			}

			console.log("columnWidths length:", columnWidths.length);
			worksheet.columns = columnWidths;

			worksheet.views = [
				{ state: 'frozen', ySplit: 4 }
			];

			console.log("=== FIN llenarHojaCombinada ===");
		},

		async obtenerAjustesOrigenB() {
			try {
				const response = await Balance.getAjustesOrigenB(this.codReporte, this.vigencia);
				return response.data.ajustesOrigenB || [];
			} catch (error) {
				console.error("Error en obtenerAjustesOrigenB:", error);
				return [];
			}
		},
		descargarArchivo(buffer, nombreArchivo) {
			const downloadLink = document.createElement("a");
			downloadLink.download = nombreArchivo;
			downloadLink.href = window.URL.createObjectURL(
				new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			);
			downloadLink.style.display = "none";
			document.body.appendChild(downloadLink);
			downloadLink.click();
			downloadLink.remove();
		},

		cambiarVista(vista) {
			this.vistaActiva = vista;

			// Resetear todas las columnas
			this.mostrarColumnas = {
				saldo: false,
				funcional: false,
				alterna: false
			};

			// Configurar columnas según la vista seleccionada
			switch (vista) {
				case 'balance':
					this.mostrarColumnas.saldo = true;
					this.mostrarColumnas.funcional = true;
					this.mostrarColumnas.alterna = true;
					break;
				case 'funcional':
					this.mostrarColumnas.funcional = true;
					break;
				case 'alterna':
					this.mostrarColumnas.alterna = true;
					break;
			}

			// Forzar actualización de los labels
			this.$forceUpdate();
		},
		toggleConsolidationSection() {
			this.showConsolidationSection = !this.showConsolidationSection;
			this.Empresas = this.showConsolidationSection;
		},

		grabeNotaParrafo() {
			// Obtener el HTML del editor
			let texto_html = '';
			let texto_plano = '';

			if (this.$refs.textEditor && this.$refs.textEditor.getHTML) {
				texto_html = this.$refs.textEditor.getHTML();
			}

			if (this.$refs.textEditor && this.$refs.textEditor.getText) {
				texto_plano = this.$refs.textEditor.getText();
			}

			// Preparar datos para enviar
			this.formParrafo.numero = this.formNotas.numero;
			this.formParrafo.vigencia = this.dialogFechas;
			this.formParrafo.idCompania = this.dialogCompanias;
			this.formParrafo.idUser = this.$store.state.userId;

			// Agregar el texto HTML y plano
			this.formParrafo.texto_html = texto_html;
			this.formParrafo.texto = texto_plano;

			Balance.grabeNotaParrafo(this.formParrafo)
				.then(() => {
					this.$toast.success("Párrafo Modificado");
					this.showDialog = false;
					this.Informacion = true;

					// Recargar datos
					Balance.getNotas(this.codReporte, this.dialogCompanias, this.dialogFechas, this.formNotas.numero)
						.then((result) => {
							// Actualizar arrays con datos nuevos
							this.a_detalle = result.data.a_detalle;
							this.a_detalle_texto = result.data.a_detalle_texto;
							this.a_informacion_txfg = result.data.a_informacion_txfg;
							this.a_informacion_txfc = result.data.a_informacion_txfc;
							this.a_informacion_txvg = result.data.a_informacion_txvg;
							this.a_informacion_txvc = result.data.a_informacion_txvc;
							this.a_informacion_tblm = result.data.a_informacion_tblm;
						})
						.catch(() => {
							this.error = true;
						});

					setTimeout(() => {
						this.Modifica = true;
					}, 1000);
				})
				.catch(() => {
					this.$toast.error("Error al Actualizar el Párrafo");
				});
		},
		seleccionaCompania() {
			this.isEmpty = true;
			let buscaMoneda = this.companias.filter((item) =>
				item.id == this.dialogCompanias)
			this.moneda = buscaMoneda[0].acronimo;

			// SOLO resetear showConsolidationSection, pero NO forzar Empresas = true
			this.showConsolidationSection = false; // Mantener oculta
			// this.Empresas = true; // ELIMINAR esta línea
		},
		seleccionaEmpresa() {
			this.isEmpty = true;
		},
		toggleAllCompanies() {
			if (this.selectAllCompanies) {
				// Seleccionar todas las compañías
				this.EmpresasConsolida = this.companiasFiltradas.map(compania => compania.id);
			} else {
				// Deseleccionar todas
				this.EmpresasConsolida = [];
			}
		},
		f_titulo() {
			let titulo = ""
			let tituloEN = ""
			let tituloConsolidado = ""
			switch (this.$route.name) {
				case "balanceNiif":
					titulo = "BALANCE"
					tituloEN = "BALANCE"
					break;
				case "reporteEsf":
					titulo = "ESTADO DE LA SITUACION FINANCIERA-ESF"
					tituloEN = "FINANCIAL POSITION STATEMENT-ESF"
					break;
				case "reporteEri":
					titulo = "ESTADO DE RESULTADO INTEGRAL-ERI"
					tituloEN = "COMPREHENSIVE INCOME STATEMENT-ERI"
					break;
				case "reporteEfe":
					titulo = "ESTADO DEL FLUJO DE EFECTIVO-EFE"
					tituloEN = "CASH FLOW STATEMENT-EFE"
					break;
				case "reporteEcp":
					titulo = "ESTADO DE LA CONSOLIDACION PATRIMONIAL-ECP"
					tituloEN = "EQUITY CONSOLIDATION STATEMENT-ECP"
					break;
			}
			let grupoNombre = "";
			if (this.selectedGrupo && !this.Grupos ) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
					grupoNombre = grupo.nombre.toUpperCase();
				}
			} else 	if	(this.Grupos) {
					grupoNombre = "GRUPOS";
			} else	{
				if	(this.grupos && this.grupos.length > 1) {
					grupoNombre = "VARIAS EMPRESAS";
				}
			}
			if (this.$store.state._language == "es-ES") {
				tituloConsolidado = titulo
			} else {
				tituloConsolidado = tituloEN
			}

			if (this.Consolidado) {
				if (this.$store.state._language == "es-ES") {
					if (this.$route.name == "reporteEsf") {
						tituloConsolidado = tituloConsolidado.concat(" CONSOLIDADA")
					} else {
						tituloConsolidado = tituloConsolidado.concat(" CONSOLIDADO")
					}

					if (grupoNombre) {
						tituloConsolidado = tituloConsolidado + " " + grupoNombre;
					}
				} else {
					tituloConsolidado = "CONSOLIDATED " + tituloConsolidado
					if (grupoNombre) {
						tituloConsolidado = tituloConsolidado + " " + grupoNombre;
					}
				}
				let buscaMoneda = this.currency.filter((moneda) =>
					moneda.isFuncional == 1)
				this.moneda = buscaMoneda[0].acronimo;
			} else {
				if (grupoNombre) {
					tituloConsolidado = tituloConsolidado + " " + grupoNombre;
				}
			}

			if (this.Comparativo) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = titulo.concat(" COMPARATIVO")
					if (grupoNombre) {
						tituloConsolidado = tituloConsolidado + " " + grupoNombre;
					}
				} else {
					tituloConsolidado = "COMPARATIVE " + tituloEN
					if (grupoNombre) {
						tituloConsolidado = tituloConsolidado + " " + grupoNombre;
					}
				}
			}
			if (this.Comparativo) {
				if (this.$store.state._language == "es-ES") {
					if (this.$route.name == "reporteEsf") {
						tituloConsolidado = titulo.concat(" COMPARATIVO")
					} else {
						tituloConsolidado = titulo.concat(" COMPARATIVO")
					}
				} else {
					tituloConsolidado = "COMPARATIVE"
					tituloConsolidado = tituloConsolidado.concat(" ", tituloEN)
				}
			}
			if (this.Notas) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = "NOTAS ESTADOS FINANCIEROS"
				} else {
					tituloConsolidado = "FINANCIAL STATEMENT NOTES"
				}
			}
			if (this.Informacion) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = "INFORMACION DE NOTAS ESTADOS FINANCIEROS"
				} else {
					tituloConsolidado = "FINANCIAL STATEMENT NOTES INFORMATION"
				}
			}
			tituloConsolidado = tituloConsolidado.concat(" ", this.vigencia.toUpperCase());
			if (this.moneda) {
				tituloConsolidado = tituloConsolidado.concat(" ", this.labels.moneda, " ", this.moneda);
			}
			return tituloConsolidado.trim();
		},
		f1_titulo() {
			let v_titulo = ""
			if (this.Notas) {
				v_titulo = "NOTAS A LOS ESTADOS FINANCIEROS"
			} else {
				v_titulo = "PARRAFOS NOTA "
			}
			let titulo = v_titulo + " " + this.formCuentas.descripcion
			return titulo
		},
		f2_titulo() {
			let v_titulo = ""
			if (this.Notas) {
				v_titulo = "NOTAS A LOS ESTADOS FINANCIEROS"
			} else {
				v_titulo = "CUENTAS CONTABLES "
			}
			let titulo = v_titulo + " " + this.formCuentas.descripcion
			return titulo
		},
		obtenerTitulosColumnas() {
			let titulos = [];

			for (let i = 0; i < this.columnas; i++) {
				titulos.push(this.titulo_columna[i] || `Compañía ${i + 1}`);
			}

			titulos.push(this.labels.ajustes || 'Ajustes');

			if (this.vistaConsolidado === 'normal') {
				titulos.push(this.labels.consolidado || 'Consolidado');
			} else {
				titulos.push(this.labels.consolidado || 'Consolidado');
				titulos.push('Combinado');
				titulos.push('Total Combinado');
			}

			return titulos;
		},
		getNombreGrupo(grupoId) {
			const grupo = this.grupos.find(g => g.id == grupoId);
			return grupo ? grupo.nombre : 'Grupo';
		},
		procesarConsolidacionPorGrupos(datos) {
			console.log('🔧 Procesando consolidación por grupos...');
			console.log('📊 Datos recibidos:', datos);

			if (!datos || datos.length === 0) return datos;
			return datos.map(item => {
				// Resetear todas las columnas existentes
				for (let i = 1; i <= 10; i++) {
					item['c' + i] = 0;
				}
				if (this.GruposConsolida.length >= 1) {
					item.c1 = item.total;
				}
				item.total = 0;
				item.ajustes = 0;

				console.log('📈 Item procesado:', {
					descripcion: item.descripcion,
					c1: item.c1,
					total_original: item.total
				});

				return item;
			});
		},
		generar() {
			var checkbox1 = document.getElementById("Balance");
			var checkbox2 = document.getElementById("Consolidado");
			var checkbox3 = document.getElementById("Comparativo");
			var checkbox4 = document.getElementById("Notas");
			var checkbox5 = document.getElementById("Informacion");

			this.Balance = checkbox1 ? checkbox1.checked : this.Balance;
			this.Comparativo = checkbox3 ? checkbox3.checked : this.Comparativo;
			this.Consolidado = checkbox2 ? checkbox2.checked : this.Consolidado;

			if (this.Consolidado) {
				this.vistaConsolidado = 'normal';
			}

			if (this.Consolidado) {
				var chkEmpresas = document.getElementById("Empresas");
				this.Empresas = chkEmpresas ? chkEmpresas.checked : this.Empresas;

				if (chkEmpresas && chkEmpresas.checked) {
					setTimeout(() => {
						chkEmpresas.checked = false;
						this.Empresas = false;
						this.showConsolidationSection = false;
					}, 100);
				}
			}

			if (this.Consolidado) {
				var chkGrupos = document.getElementById("Grupos");
				this.Grupos = chkGrupos ? chkGrupos.checked : this.Grupos;

				if (chkGrupos && chkGrupos.checked) {
					setTimeout(() => {
						chkGrupos.checked = false;
						this.Grupos = false;
						this.showGroupConsolidationSection = false;
					}, 100);
				}
			}

			this.Notas = checkbox4 ? checkbox4.checked : this.Notas;
			this.Informacion = checkbox5 ? checkbox5.checked : this.Informacion;

			this.Modifica = false;
			this.showDialog = false;
			this.showDialogCuenta = false;
			if ((this.dialogCompanias || this.EmpresasConsolida) && this.dialogFechas && this.dialogReportes) {
				this.idCompania = this.dialogCompanias
				this.vigencia = this.dialogFechas
				this.codReporte = this.dialogReportes
				this.isEmpty = true
				this.generado = false
				switch (this.$route.name) {
					case "balanceNiif":
						if (this.Balance) {
							Balance.getBalanceNiif(this.codReporte, this.idCompania, this.vigencia)
								.then((result) => {
									this.balance = result.data.balanceNiif;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Consolidado && this.Grupos && this.GruposConsolida.length > 0) {
							console.log('Consolidando por grupos:', this.GruposConsolida);

							const promesasGrupos = this.GruposConsolida.map(grupoId => {
								const empresasDelGrupo = this.getEmpresasFromGrupos([grupoId]);
								console.log(`Grupo ${grupoId} - Empresas:`, empresasDelGrupo);

								if (empresasDelGrupo && empresasDelGrupo.length > 0) {
									switch (this.$route.name) {
										case "balanceNiif":
											return Balance.getBalanceNiifGrupos(this.codReporte, this.vigencia, grupoId)
												.then(result => ({
													grupoId,
													data: result.data.balanceNiif
												}));
										case "reporteEsf":
											return Balance.getReporteEsfGrupos(this.codReporte, grupoId, this.vigencia)
												.then(result => ({ grupoId, data: result.data.reporteEsf }));
										case "reporteEri":
											return Balance.getReporteEriGrupos(this.codReporte, grupoId, this.vigencia)
												.then(result => ({ grupoId, data: result.data.reporteEri }));
										default:
											return Promise.resolve({ grupoId, data: [] });
									}
								} else {
									console.log(`Grupo ${grupoId} no tiene empresas`);
									return Promise.resolve({ grupoId, data: [] });
								}
							});

							// Filtrar promesas válidas (no nulas)
							const promesasValidas = promesasGrupos.filter(p => p !== undefined);

							if (promesasValidas.length > 0) {
								Promise.all(promesasValidas)
									.then(resultados => {
										const gruposConDatos = resultados.filter(r => r.data && r.data.length > 0);

										if (gruposConDatos.length > 0) {
											this.procesarMultiplesGrupos(gruposConDatos);
										} else {
											this.balance = [];
											this.isEmpty = true;
											this.$toast.warning("Los grupos seleccionados no tienen empresas para consolidar");
										}
									})
									.catch((error) => {
										console.error('Error en consolidación por grupos:', error);
										this.error = true;
										this.$toast.error("Error al consolidar los grupos");
									});
							} else {
								this.balance = [];
								this.isEmpty = true;
								this.$toast.warning("No hay empresas en los grupos seleccionados");
							}
						}
						// En el método generar(), dentro de cada caso de Consolidado, buscar y reemplazar:

						// BLOQUE 1: Consolidación Individual (sin checkbox Empresas)
						if (this.Consolidado && !this.Empresas && !this.Grupos) {
							this.EmpresasConsolida = []
							this.EmpresasConsolida.push(this.idCompania)
							Balance.getBalanceNiifConsol(this.codReporte, this.vigencia, this.EmpresasConsolida)
								.then((result) => {
									this.balance = result.data.balanceNiif;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
										this.columnas = this.balance[0].columnas
										// ELIMINAR: Configuración de moneda local
										// SIEMPRE usar Moneda Funcional
										const monedaFuncional = this.currency.find((moneda) => moneda.isFuncional == 1)
										this.cmoneda = monedaFuncional ? monedaFuncional.id : 0
										this.amoneda = monedaFuncional ? monedaFuncional.id : 0
										this.tasa_cambio = 1
										this.f_columnas()
									}
								})
								.catch(() => {
									this.error = true;
								});
						}

						// BLOQUE 2: Consolidación por Empresas seleccionadas  
						if (this.Consolidado && this.Empresas && !this.Grupos) {
							Balance.getBalanceNiifConsol(this.codReporte, this.vigencia, this.EmpresasConsolida)
								.then((result) => {
									this.balance = result.data.balanceNiif;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
										this.columnas = this.balance[0].columnas

										if (result.data.nombres_companias) {
											this.titulo_columna = this.EmpresasConsolida.map(id => {
												const comp = this.companias.find(c => c.id == id);
												return comp ? comp.acronym : `CIA${id}`;
											});
										} else {
											this.titulo_columna = this.EmpresasConsolida.map(id => {
												const comp = this.companias.find(c => c.id == id);
												return comp ? comp.acronym : `CIA${id}`;
											});
										}
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Comparativo) {
							Balance.getBalanceNiifCompar(this.codReporte, this.idCompania, this.vigencia)
								.then((result) => {
									this.balance = result.data.balanceNiif;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Notas) {
							Balance.getNotasEF(this.codReporte, this.idCompania, this.vigencia, "BAL")
								.then((result) => {
									this.notasEF = result.data.notasEF[0]
									this.searched = this.notasEF
									if (this.notasEF.length != 0) {
										this.isEmpty = false
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true
								});
						}
						if (this.Informacion) {
							Balance.getNotasEF(this.codReporte, this.idCompania, this.vigencia, "BAL")
								.then((result) => {
									this.notasEF = result.data.notasEF[0]
									this.searched = this.notasEF
									if (this.notasEF.length != 0) {
										this.isEmpty = false
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true
								});
						}
						break;
					case "reporteEsf":
						if (this.Balance) {
							Balance.getReporteEsf(this.codReporte, this.idCompania, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEsf;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Consolidado && !this.Empresas) {
							this.EmpresasConsolida = []
							this.EmpresasConsolida.push(this.idCompania)
							Balance.getReporteEsfConsol(this.codReporte, this.EmpresasConsolida, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEsf;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
										this.columnas = this.balance[0].columnas
										// CAMBIO: Por defecto mostrar Moneda Local
										const monedaLocal = this.currency.find((moneda) => moneda.isFuncional == 2)
										this.cmoneda = monedaLocal ? monedaLocal.id : 0
										this.amoneda = monedaLocal ? monedaLocal.id : 0
										this.tasa_cambio = 1
										this.f_columnas()
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Consolidado && this.Empresas) {
							Balance.getReporteEsfConsol(this.codReporte, this.EmpresasConsolida, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEsf;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
										this.columnas = this.balance[0].columnas
										// CAMBIO: Por defecto mostrar Moneda Local
										const monedaLocal = this.currency.find((moneda) => moneda.isFuncional == 2)
										this.cmoneda = monedaLocal ? monedaLocal.id : 0
										this.amoneda = monedaLocal ? monedaLocal.id : 0
										this.tasa_cambio = 1
										this.f_columnas()
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Comparativo) {
							Balance.getReporteEsfCompar(this.codReporte, this.idCompania, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEsf;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Notas) {
							Balance.getNotasEF(this.codReporte, this.idCompania, this.vigencia, "ESF")
								.then((result) => {
									this.notasEF = result.data.notasEF[0]
									this.searched = this.notasEF
									if (this.notasEF.length != 0) {
										this.isEmpty = false
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true
								});
						}
						break;
					case "reporteEri":
						if (this.Balance) {
							Balance.getReporteEri(this.codReporte, this.idCompania, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEri;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Consolidado && !this.Empresas) {
							this.EmpresasConsolida = []
							this.EmpresasConsolida.push(this.idCompania)
							Balance.getReporteEriConsol(this.codReporte, this.EmpresasConsolida, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEri;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
										this.columnas = this.balance[0].columnas
										// CAMBIO: Por defecto mostrar Moneda Local
										const monedaLocal = this.currency.find((moneda) => moneda.isFuncional == 2)
										this.cmoneda = monedaLocal ? monedaLocal.id : 0
										this.amoneda = monedaLocal ? monedaLocal.id : 0
										this.tasa_cambio = 1
										this.f_columnas()
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Consolidado && this.Empresas) {
							Balance.getReporteEriConsol(this.codReporte, this.EmpresasConsolida, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEri;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
										this.columnas = this.balance[0].columnas
										// CAMBIO: Por defecto mostrar Moneda Local
										const monedaLocal = this.currency.find((moneda) => moneda.isFuncional == 2)
										this.cmoneda = monedaLocal ? monedaLocal.id : 0
										this.amoneda = monedaLocal ? monedaLocal.id : 0
										this.tasa_cambio = 1
										this.f_columnas()
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Comparativo) {
							Balance.getReporteEriCompar(this.codReporte, this.idCompania, this.vigencia)
								.then((result) => {
									this.balance = result.data.reporteEri;
									this.searched = this.balance;
									if (this.balance.length != 0) {
										this.isEmpty = false;
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true;
								});
						}
						if (this.Notas) {
							Balance.getNotasEF(this.codReporte, this.idCompania, this.vigencia, "ERI")
								.then((result) => {
									this.notasEF = result.data.notasEF[0]
									this.searched = this.notasEF
									if (this.notasEF.length != 0) {
										this.isEmpty = false
										this.generado = true
									}
								})
								.catch(() => {
									this.error = true
								});
						}
						break;
				}
			}
		},	
		fc_columna(opcion) {
			if (opcion == 1) {
				const v_moneda = this.labels.ajustes
				return v_moneda
			}
			if (opcion == 2) {
				const v_moneda = this.labels.consolidado
				return v_moneda
			}
		},
		f_columnas() {
			this.titulo_columna = [];

			// Si es consolidación por grupos, usar los nombres de los grupos
			if (this.Grupos && this.GruposConsolida.length > 0) {
				for (let idx = 0; idx < this.GruposConsolida.length; idx++) {
					const grupoId = this.GruposConsolida[idx];
					this.titulo_columna[idx] = this.getNombreGrupo(grupoId);
				}
				// Asegurarnos de que tenemos al menos una columna
				this.columnas = Math.max(1, this.GruposConsolida.length);
			} else {
				// Lógica original para empresas individuales
				for (let idx = 0; idx < this.columnas; idx++) {
					const colKey = 'e' + (idx + 1);
					if (this.balance[0] && this.balance[0][colKey] !== undefined) {
						this.titulo_columna[idx] = this.balance[0][colKey];
					} else {
						this.titulo_columna[idx] = 'Compañía ' + (idx + 1);
					}
				}
			}

			console.log('Títulos de columnas:', this.titulo_columna);
			console.log('Número de columnas:', this.columnas);
		},
		titulo(opcion) {
			let periodo_anterior = this.vigencia.substring(0, 4) - 1;
			let v_periodo_anterior = ""
			v_periodo_anterior = v_periodo_anterior.concat(periodo_anterior, "12")
			if (opcion == -1) {
				return "DIF-" + this.moneda
			}
			if (opcion == 0) {
				return this.moneda + " " + v_periodo_anterior;
			}
			if (opcion == 1) {
				return this.moneda + " " + this.vigencia;
			}
			let moneda = this.currency.find((moneda) => moneda.isFuncional == 1)
			if (opcion == 2) {
				if (moneda) {
					return moneda.acronimo + " " + v_periodo_anterior;
				}
				return this.labels.funcional1 + " " + v_periodo_anterior;
			}
			if (opcion == 3) {
				if (moneda) {
					return moneda.acronimo + " " + this.vigencia;
				}
				return this.labels.funcional1 + " " + this.vigencia;
			}
			if (opcion == -2) {
				if (moneda) {
					return "DIF-" + moneda.acronimo
				}
				return this.labels.funcional_dif
			}

			moneda = this.currency.find((moneda) => moneda.isFuncional == 2)
			if (opcion == 4) {
				if (moneda) {
					return moneda.acronimo + " " + v_periodo_anterior;
				}
				return this.labels.alterna1 + " " + v_periodo_anterior;
			}
			if (opcion == 5) {
				if (moneda) {
					return moneda.acronimo + " " + this.vigencia;
				}
				return this.labels.alterna1 + " " + this.vigencia;
			}
		},
		f_escribe_renglon(v_informacion) {
			if (v_informacion == "E") return false;
			return true;
		},
		f_escribe_renglon1(v_informacion) {
			if (v_informacion == "E") return false;
			return true;
		},
		uncheck(opcion) {
			// Resetear todos los checkboxes principales (excepto los de Consolidado)
			this.Balance = false;
			this.Comparativo = false;
			this.Notas = false;
			this.Informacion = false;
			this.Modifica = false;
			this.showDialog = false;
			this.showDialogCuenta = false;

			// NO resetear ConsolidadoGe cuando se trata de opciones del grupo Consolidado
			if (opcion !== 2 && opcion !== 21 && opcion !== 22) {
				this.ConsolidadoGe = false;
				this.Consolidado = false;
				this.Empresas = false;
				this.Grupos = false;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = false;
			}

			// Manejar cada opción individualmente
			if (opcion === 1) {
				this.Balance = true;
			}
			else if (opcion === 3) {
				this.Comparativo = true;
			}
			else if (opcion === 20) {
				this.ConsolidadoGe = true;
				// Al seleccionar Consolidado, mantener Individual marcado por defecto
				this.Consolidado = true;
				this.Empresas = false;
				this.Grupos = false;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = false;

				// AGREGAR: Incluir automáticamente la compañía seleccionada
				if (this.dialogCompanias) {
					this.EmpresasConsolida = [this.dialogCompanias];
				}
			}
			else if (opcion === 4) {
				this.Notas = true;
			}
			else if (opcion === 5) {
				this.Informacion = true;
			}
			else if (opcion === 2) {
				// Individual - mantener ConsolidadoGe marcado
				this.ConsolidadoGe = true;
				this.Consolidado = true;
				this.Empresas = false;
				this.Grupos = false;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = false;

				// AGREGAR: Incluir automáticamente la compañía seleccionada
				if (this.dialogCompanias) {
					this.EmpresasConsolida = [this.dialogCompanias];
				}
			}
			else if (opcion === 21) {
				// Empresas - mantener ConsolidadoGe e Individual marcados
				this.ConsolidadoGe = true;
				this.Consolidado = true;
				this.Empresas = true;
				this.Grupos = false;
				this.showConsolidationSection = true;
				this.showGroupConsolidationSection = false;
			}
			else if (opcion === 22) {
				// Grupos - mantener ConsolidadoGe e Individual marcados
				this.ConsolidadoGe = true;
				this.Consolidado = true;
				this.Empresas = false;
				this.Grupos = true;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = true;
			}

			this.isEmpty = true;
			this.generado = false;
		},
		excel(opcion) {
			let datos = {}
			const v_reporte = this.reportes.find((reporte) => reporte.codigo === this.codReporte)
			datos.reporte = v_reporte.nombre
			datos.idCompania = this.idCompania
			const v_compania = this.companias.find((compania) => compania.id === this.idCompania)

			if (v_compania) {
				datos.compania = v_compania.nombre
			} else {
				datos.compania = "Consolidado General"
				datos.idCompania = 0
			}

			datos.grupoNombre = "";
			if (this.selectedGrupo) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
					datos.grupoNombre = grupo.nombre;
				}
			} else if (this.gruposFiltrados && this.gruposFiltrados.length > 1) {
				datos.grupoNombre = "VARIOS GRUPOS";
			}

			datos.vigencia = this.vigencia
			datos.opcion = opcion
			datos.userId = this.$store.state.userId
			datos.userName = this.$store.state.userName

			// NUEVO: Agregar la vista activa a los datos
			datos.vistaActiva = this.vistaActiva

			if (opcion === 1) {
				datos.titulo = this.f_titulo()
				datos.informacion = this.balance
				this.hojaExcelBalance(datos)
			}
			if (opcion === 2) {
				datos.titulo = this.f_titulo()
				datos.informacion = this.balance
				datos.columnas = [
					this.titulo(0),
					this.titulo(1),
					this.labels.diferencia,
					this.titulo(2),
					this.titulo(3),
					this.labels.funcional_dif
				]
				this.hojaExcelComparativo(datos)
			}
			if (opcion === 3) {
				datos.titulo = this.f_titulo()
				datos.informacion = this.balance
				datos.columnas = []

				datos.idCompania = 0
				datos.compania = "Consolidado General"

				let i = 0
				for (i = 0; i < this.titulo_columna.length; i++) {
					datos.columnas[i] = this.titulo_columna[i]
				}

				datos.columnas[i] = "Ajustes"
				i = i + 1
				datos.columnas[i] = "Consolidado"

				datos.nombreArchivo = this.generarNombreArchivoExcel();

				this.hojaExcelConsolidadoConDisenioDetalle(datos)
			}
			if (opcion === 4) {
				datos.titulo = this.f1_titulo()
				datos.informacion = this.cuentas
				this.hojaExcelCuentas(datos)
			}
		},
		generarNombreArchivoExcel() {
			let nombre = "Balance_Consolidado";

			if (this.selectedGrupo) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
					nombre += `_${grupo.nombre.replace(/\s+/g, '_')}`;
				}
			} else if (this.grupos && this.grupos.length > 1) {
				nombre += "_VARIOS_GRUPOS";
			}

			nombre += `_${this.vigencia}`;

			const fecha = new Date();
			const fechaStr = fecha.toISOString().split('T')[0];
			nombre += `_${fechaStr}`;

			return nombre;
		},
		async hojaExcelConsolidadoConDisenioDetalle(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const balance = datos.informacion
			const columnas = datos.columnas

			const { Workbook } = XLSX
			const workbook = new Workbook()

			let nombreHoja = "Consolidado";
			if (this.selectedGrupo) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
					nombreHoja = `Consolidado_${grupo.nombre.substring(0, 25)}`;
				}
			} else if (this.grupos && this.grupos.length > 1) {
				nombreHoja = "Consolidado_Varios_Grupos";
			}

			nombreHoja = nombreHoja.substring(0, 31);
			const worksheet = workbook.addWorksheet(nombreHoja)

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezadoColumnas: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				datoDescripcion: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "left", vertical: "middle" },
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				},
				datoNumerico: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				}
			}

			// Determinar si estamos en vista combinado
			const esCombinado = this.vistaConsolidado === 'combinado'

			// Construir array de columnas final
			let columnasFinales = [...columnas]

			if (esCombinado) {
				columnasFinales.push('Combinado')
				columnasFinales.push('Total Combinado')
			}

			const totalColumnas = columnasFinales.length + 1
			const endCol = String.fromCharCode(65 + totalColumnas - 1)

			// Título
			worksheet.mergeCells(`A1:${endCol}1`)
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			// Subtítulo 1
			worksheet.mergeCells(`A2:${endCol}2`)
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			// Subtítulo 2
			worksheet.mergeCells(`A3:${endCol}3`)
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			// Encabezado de columnas
			const headerRow = worksheet.addRow(['DESCRIPCIÓN', ...columnasFinales])
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezadoColumnas)
			})

			// Datos del balance
			balance.forEach((item) => {
				if (this.f_escribe_renglon(item.informacion)) {
					const rowData = [item.descripcion]

					for (let i = 0; i < this.titulo_columna.length; i++) {
						const valorColumna = item['c' + (i + 1)] || 0
						rowData.push(parseFloat(valorColumna) || 0)
					}

					rowData.push(parseFloat(item.ajustes) || 0)

					rowData.push(parseFloat(item.total) || 0)

					if (esCombinado) {
						rowData.push(parseFloat(item.combinado) || 0)
						rowData.push(parseFloat(item.total_combinado) || 0)
					}

					const currentRow = worksheet.addRow(rowData)

					currentRow.eachCell((cell, colNumber) => {
						if (colNumber === 1) {
							Object.assign(cell, styles.datoDescripcion)
						} else {
							Object.assign(cell, styles.datoNumerico)
						}
					})
				}
			})

			// Ajustar ancho de columnas
			const columnWidths = [
				{ width: 40 }, // Descripción
				...columnasFinales.map(() => ({ width: 15 }))
			]
			worksheet.columns = columnWidths

			worksheet.views = [
				{ state: 'frozen', ySplit: 5 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")

			let nombreArchivo = datos.nombreArchivo || `Consolidado_${compania}_${vigencia}_${createdAt}.xlsx`;
			if (esCombinado) {
				nombreArchivo = `Consolidado_Combinado_${compania}_${vigencia}_${createdAt}.xlsx`;
			}

			downloadLink.download = nombreArchivo
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			downloadLink.remove()
		},

		async hojaExcelBalance(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const filas = datos.informacion

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("Balance")
			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				nivel1: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						bottom: { style: "thin" }
					}
				},
				nivel2: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
					indent: 1
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" }
					},
					indent: 2
				},
				total: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				},
				descripcionTotal: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				}
			}

			// ENCABEZADO PRINCIPAL
			worksheet.mergeCells('A1:D1')
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells('A2:D2')
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells('A3:D3')
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			// ESPACIO
			worksheet.addRow([])

			// ENCABEZADO DE COLUMNAS
			const HEADER_ROW = [
				'DESCRIPCIÓN',
				'LOCAL',
				'FUNCIONAL USD',
				'INTERNA USD'
			]

			const headerRow = worksheet.addRow(HEADER_ROW)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			// PROCESAR FILAS
			let n_fila = 6 // Empezamos después del encabezado

			filas.forEach((fila) => {
				if (fila.informacion === "E") {
					// ENCABEZADO DE SECCIÓN (Nivel 1) - Con fondo gris claro y borde inferior
					worksheet.addRow([fila.descripcion, '', '', ''])
					worksheet.mergeCells(`A${n_fila}:D${n_fila}`)
					Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)
					n_fila++

				} else if (this.f_escribe_renglon(fila.informacion)) {
					const v_fila = [
						fila.descripcion,
						(fila.saldo_actual === null) ? fila.saldo_actual : parseFloat(fila.saldo_actual),
						(fila.funcional1 === null) ? fila.funcional1 : parseFloat(fila.funcional1),
						(fila.interna1 === null) ? fila.interna1 : parseFloat(fila.interna1)
					]

					const currentRow = worksheet.addRow(v_fila)

					// APLICAR ESTILOS SEGÚN EL TIPO DE FILA
					if (fila.informacion === "T" || (fila.informacion === "S" && fila.segundo_nivel === 999)) {
						// TOTALES (T) o SUBTOTALES (S) fuera de niveles - fondo gris y bordes destacados
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								Object.assign(cell, styles.descripcionTotal)
							} else {
								Object.assign(cell, styles.total)
							}
						})
					} else {
						// FILAS NORMALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								// Columna descripción - diferenciar niveles
								if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
									Object.assign(cell, styles.nivel2)
								} else {
									// Datos normales en descripción
									cell.font = { name: "Calibri", size: 10 }
									cell.alignment = { horizontal: "right", vertical: "middle" }
									cell.indent = 2
								}
							} else {
								// Columnas numéricas
								Object.assign(cell, styles.datoNormal)
							}
						})
					}
					n_fila++
				}
			})

			// AJUSTAR ANCHO DE COLUMNAS
			worksheet.columns = [
				{ width: 45 }, // Descripción - más ancho para mejor legibilidad
				{ width: 18 }, // Local
				{ width: 18 }, // Funcional USD
				{ width: 18 }  // Interna USD
			]

			// AGREGAR BORDES VERTICALES PARA MEJOR LEGIBILIDAD
			const lastRow = n_fila - 1;
			for (let row = 6; row <= lastRow; row++) {
				for (let col = 1; col <= 4; col++) {
					const cell = worksheet.getCell(row, col);
					if (!cell.border) {
						cell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							top: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
				}
			}

			// CONGELAR PANELES (encabezados siempre visibles)
			worksheet.views = [
				{ state: 'frozen', ySplit: 5 } // Congela hasta la fila 5
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")

			downloadLink.download = `Balance_${compania}_${vigencia}_${createdAt}.xlsx`
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			downloadLink.remove()
		},
		async hojaExcelComparativo(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = createdAt1.getMonth() + 1
			let dia = createdAt1.getDate()
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let columnas = datos.columnas
			let userName = datos.userName
			const filas = datos.informacion

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("Comparativo")

			const ENCABEZADO1 = [
				titulo
			]
			worksheet.addRow(ENCABEZADO1)
			const ENCABEZADO2 = [
				"Vigencia " + vigencia,
			]
			worksheet.addRow(ENCABEZADO2)
			const ENCABEZADO3 = [
				"Creado " + createdAt + " por " + userName,
			]
			worksheet.addRow(ENCABEZADO3)
			const ENCABEZADO4 = [
				"Compañia " + compania,
			]
			worksheet.addRow(ENCABEZADO4)
			const ENCABEZADO5 = [
			]
			worksheet.addRow(ENCABEZADO5)

			const HEADER_ROW = [
				'DESCRIPCION/NIIF (IFRS) ' + reporte.toUpperCase(),
				columnas[0],
				columnas[1],
				columnas[2],
				columnas[3],
				columnas[4],
				columnas[5],
			]
			worksheet.addRow(HEADER_ROW)
			for (let fila = 1; fila < 7; fila++) {
				worksheet.getRow(fila).font = {
					name: "Arial Black",
					family: 2,
					size: 14,
					bold: true,
					italic: true,
				}
			}

			for (let columna = 1; columna < 7; columna++) {
				const v_columna = String.fromCharCode(columna + 65) + "6"
				worksheet.getCell(v_columna).alignment = {
					horizontal: "center",
				}
			}

			var n_fila = 7
			filas.forEach((fila) => {
				if (fila.informacion === "E") {
					const v_salto = [""]
					worksheet.addRow(v_salto)
					n_fila++
					return;
				}
				const v_fila = [
					fila.descripcion,
					(fila.anterior === null) ? fila.anterior : parseFloat(fila.anterior),
					(fila.actual === null) ? fila.actual : parseFloat(fila.actual),
					(fila.diferencia === null) ? fila.diferencia : parseFloat(fila.diferencia),
					(fila.funcional_ant === null) ? fila.funcional_ant : parseFloat(fila.funcional_ant),
					(fila.funcional_act === null) ? fila.funcional_act : parseFloat(fila.funcional_act),
					(fila.funcional_dif === null) ? fila.funcional_dif : parseFloat(fila.funcional_dif),
				]
				worksheet.addRow(v_fila)
				for (let columna = 0; columna < 7; columna++) {
					const v_columna = String.fromCharCode(columna + 65) + n_fila.toString()
					if (columna === 0) {
						worksheet.getCell(v_columna).font = {
							name: "Arial Black",
							family: 2,
							size: 13,
							bold: (fila.informacion === "E" || fila.informacion === "T") ? true : false,
							italic: (fila.informacion === "E" || fila.informacion === "T") ? true : false,
						}
						worksheet.getCell(v_columna).alignment = {
							horizontal: (fila.informacion === "I" || (fila.informacion === 'T' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999) || (fila.informacion = 'E' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999)) ? 'right' : 'left',
						}
					} else {
						worksheet.getCell(v_columna).font = {
							size: 13,
						}
						worksheet.getCell(v_columna).numFmt = "#,0"
					}
				}
				n_fila++

			})

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = "Comparativo" + vigencia + ".xlsx"
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none";

			document.body.appendChild(downloadLink);
			downloadLink.click();

			downloadLink.remove();

		},
		async hojaExcelConsolidado(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = createdAt1.getMonth() + 1
			let dia = createdAt1.getDate()
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let columnas = datos.columnas
			let userName = datos.userName
			const filas = datos.informacion

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("Consolidado")

			const ENCABEZADO1 = [
				titulo
			]
			worksheet.addRow(ENCABEZADO1)
			const ENCABEZADO2 = [
				"Vigencia " + vigencia,
			]
			worksheet.addRow(ENCABEZADO2)
			const ENCABEZADO3 = [
				"Creado " + createdAt + " por " + userName,
			]
			worksheet.addRow(ENCABEZADO3)
			const ENCABEZADO4 = [
				"Compañia " + compania,
			]
			worksheet.addRow(ENCABEZADO4)
			const ENCABEZADO5 = [
			]
			worksheet.addRow(ENCABEZADO5)

			const HEADER_ROW = [
				'DESCRIPCION/NIIF (IFRS) ' + reporte.toUpperCase(),
			]
			for (let k = 0; k < (filas[0].columnas - 1) + 2; k++) {
				const v_celda = columnas[k]
				HEADER_ROW.push(v_celda)
			}
			worksheet.addRow(HEADER_ROW)
			for (let fila = 1; fila < 7; fila++) {
				worksheet.getRow(fila).font = {
					name: "Arial Black",
					family: 2,
					size: 14,
					bold: true,
					italic: true,
				}
			}

			for (let columna = 1; columna < filas[0].columnas + 2; columna++) {
				const v_columna = String.fromCharCode(columna + 65) + "6"
				worksheet.getCell(v_columna).alignment = {
					horizontal: "center",
				}
			}

			var n_fila = 7
			filas.forEach((fila) => {
				const v_informacion = fila.informacion
				if (fila.informacion === "E") {
					const v_salto = [""]
					worksheet.addRow(v_salto)
					n_fila++
					return;
				}
				const v_fila = [
					fila.descripcion,
				]
				for (let k = 0; k < filas[0].columnas - 1; k++) {
					const v_celda = this.f_val_fila(v_informacion, fila, k)
					v_fila.push(v_celda)
				}
				const v_ajustes = this.f_valor(v_informacion, fila.ajustes)
				v_fila.push(v_ajustes)
				const v_total = this.f_valor(v_informacion, fila.total)
				v_fila.push(v_total)

				worksheet.addRow(v_fila)
				for (let columna = 0; columna <= filas[0].columnas + 2; columna++) {
					const v_columna = String.fromCharCode(columna + 65) + n_fila.toString()
					if (columna === 0) {
						worksheet.getCell(v_columna).font = {
							name: "Arial Black",
							family: 2,
							size: 13,
							bold: (fila.informacion === "E" || fila.informacion === "T") ? true : false,
							italic: (fila.informacion === "E" || fila.informacion === "T") ? true : false,
						}
						worksheet.getCell(v_columna).alignment = {
							horizontal: (fila.informacion === "I" || (fila.informacion === 'T' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999) || (fila.informacion = 'E' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999)) ? 'right' : 'left',
						}
					} else {
						worksheet.getCell(v_columna).font = {
							size: 13,
						}
						worksheet.getCell(v_columna).numFmt = "#,0"
					}
				}
				n_fila++
			})

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = "Consolidado" + vigencia + ".xlsx"
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none";

			document.body.appendChild(downloadLink);
			downloadLink.click();

			downloadLink.remove();

		},
		async obtenerAjustesPorEmpresa(companiaId, vigencia, empresasRelacionadas) {
			try {

				let empresasValidas = [];

				if (this.EmpresasConsolida && this.EmpresasConsolida.length > 0) {
					empresasValidas = [...this.EmpresasConsolida];
					console.log('Usando EmpresasConsolida:', empresasValidas);

				} else if (empresasRelacionadas && empresasRelacionadas.length > 0) {
					empresasValidas = [...empresasRelacionadas];
					console.log('Usando empresasRelacionadas:', empresasValidas);

				} else if (this.idCompania) {
					empresasValidas = [this.idCompania];
					console.log('Consolidado individual:', empresasValidas);

				} else {
					console.warn('No hay empresas válidas');
					return [];
				}

				const response = await Balance.getAjustesDetallados(
					this.codReporte,
					vigencia,
					empresasValidas
				);

				let ajustes = response.data.ajustes || [];

				if (ajustes.length === 0) {
					return [];
				}

				console.log('Ajustes recibidos:', ajustes.length);

				ajustes = ajustes.filter(ajuste => {

					if (!empresasValidas.includes(Number(ajuste.id_compania))) {
						return false;
					}

					const ajusteValor =
						ajuste.ajuste_funcional1 ??
						ajuste.ajuste_funcional1_rounded ??
						ajuste.ajuste_actual ??
						ajuste.ajuste_actual_rounded ??
						0;

					if (Math.abs(parseFloat(ajusteValor) || 0) < 0.01) {
						return false;
					}

					return true;
				});

				ajustes.sort((a, b) => {
					const aEsPropia = a.id_compania == companiaId;
					const bEsPropia = b.id_compania == companiaId;

					if (aEsPropia && !bEsPropia) return -1;
					if (!aEsPropia && bEsPropia) return 1;

					return (a.secuencia || 0) - (b.secuencia || 0);
				});

				console.log(`Ajustes finales empresa ${companiaId}:`, ajustes.length);

				return ajustes;

			} catch (error) {
				console.warn(`Error obteniendo ajustes detallados para empresa ${companiaId}:`, error);
				return [];
			}
		},

		f_val_fila(p_informacion, fila, k) {
			let v_valor = ''
			switch (k) {
				case 0: v_valor = fila.c1; break;
				case 1: v_valor = fila.c2; break;
				case 2: v_valor = fila.c3; break;
				case 3: v_valor = fila.c4; break;
				case 4: v_valor = fila.c5; break;
				case 5: v_valor = fila.c6; break;
				case 6: v_valor = fila.c7; break;
				case 7: v_valor = fila.c8; break;
				case 8: v_valor = fila.c9; break;
				case 9: v_valor = fila.c10; break;
				case 10: v_valor = fila.c11; break;
				case 11: v_valor = fila.c12; break;
				case 12: v_valor = fila.c13; break;
				case 13: v_valor = fila.c14; break;
				case 14: v_valor = fila.c15; break;
				case 15: v_valor = fila.c16; break;
				case 16: v_valor = fila.c17; break;
				case 17: v_valor = fila.c18; break;
				case 18: v_valor = fila.c19; break;
				case 19: v_valor = fila.c20; break;
				case 20: v_valor = fila.c21; break;
				case 21: v_valor = fila.c22; break;
				case 22: v_valor = fila.c23; break;
				case 23: v_valor = fila.c24; break;
				case 24: v_valor = fila.c25; break;
				case 25: v_valor = fila.c26; break;
				case 26: v_valor = fila.c27; break;
				case 27: v_valor = fila.c28; break;
				case 28: v_valor = fila.c29; break;
				case 29: v_valor = fila.c30; break;
				case 30: v_valor = fila.c31; break;
				case 31: v_valor = fila.c32; break;
				case 32: v_valor = fila.c33; break;
				case 33: v_valor = fila.c34; break;
				case 34: v_valor = fila.c35; break;
				case 35: v_valor = fila.c36; break;
				case 36: v_valor = fila.c37; break;
				case 37: v_valor = fila.c38; break;
				case 38: v_valor = fila.c39; break;
				case 39: v_valor = fila.c40; break;
				case 40: v_valor = fila.c41; break;
				case 41: v_valor = fila.c42; break;
				case 42: v_valor = fila.c43; break;
				case 43: v_valor = fila.c44; break;
				case 44: v_valor = fila.c45; break;
				case 45: v_valor = fila.c46; break;
				case 46: v_valor = fila.c47; break;
				case 47: v_valor = fila.c48; break;
				case 48: v_valor = fila.c49; break;
				case 49: v_valor = fila.c50; break;
				case 50: v_valor = fila.c51; break;
				case 51: v_valor = fila.c52; break;
				case 52: v_valor = fila.c53; break;
				case 53: v_valor = fila.c54; break;
				case 54: v_valor = fila.c55; break;
				case 55: v_valor = fila.c56; break;
				case 56: v_valor = fila.c57; break;
				case 57: v_valor = fila.c58; break;
				case 58: v_valor = fila.c59; break;
				case 59: v_valor = fila.c60; break;
				case 70: v_valor = fila.c61; break;
				case 61: v_valor = fila.c62; break;
				case 62: v_valor = fila.c63; break;
				case 63: v_valor = fila.c64; break;
				case 64: v_valor = fila.c65; break;
				case 65: v_valor = fila.c66; break;
				case 66: v_valor = fila.c67; break;
				case 67: v_valor = fila.c68; break;
				case 68: v_valor = fila.c69; break;
				case 69: v_valor = fila.c70; break;
			}
			if (p_informacion === "E") {
				v_valor = null
			}
			const valor = (v_valor === null) ? v_valor : parseFloat(v_valor)
			return valor
		},
		f_valor(p_informacion, p_valor) {
			let v_valor = p_valor
			if (p_informacion === "E") {
				v_valor = null
			}
			const valor = (v_valor === null) ? v_valor : parseFloat(v_valor)
			return valor
		},

		async hojaExcelCuentas(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = createdAt1.getMonth() + 1
			let dia = createdAt1.getDate()
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte.toUpperCase()
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo.toUpperCase()
			let userName = datos.userName
			const filas = datos.informacion

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("Cuentas")

			const ENCABEZADO0 = [reporte]
			worksheet.addRow(ENCABEZADO0)
			const ENCABEZADO1 = [titulo]
			worksheet.addRow(ENCABEZADO1)
			const ENCABEZADO2 = ["Vigencia " + vigencia]
			worksheet.addRow(ENCABEZADO2)
			const ENCABEZADO3 = ["Creado " + createdAt + " por " + userName]
			worksheet.addRow(ENCABEZADO3)
			const ENCABEZADO4 = ["Compañia " + compania]
			worksheet.addRow(ENCABEZADO4)

			const HEADER_ROW = [
				"CUENTA",
				"DESCRIPCION",
				"SALDO",
				"FUNCIONAL",
				"PROMEDIO",
				"ALTERNA",
				"PROMEDIO",
			]
			worksheet.addRow(HEADER_ROW)
			for (let fila = 1; fila < 7; fila++) {
				worksheet.getRow(fila).font = {
					name: "Arial Black",
					family: 2,
					size: 14,
					bold: true,
					italic: true,
				}
			}

			for (let columna = 2; columna < 7; columna++) {
				const v_columna = String.fromCharCode(columna + 65) + "6"
				worksheet.getCell(v_columna).alignment = {
					horizontal: "center",
				}
			}

			var n_fila = 7
			filas.forEach((fila) => {
				if (fila.informacion === "E") {
					const v_salto = [""]
					worksheet.addRow(v_salto)
					n_fila++
					return;
				}
				const v_fila = [
					fila.cuenta,
					fila.descripcion,
					(fila.saldo_actual === null) ? fila.saldo_actual : parseFloat(fila.saldo_actual),
					(fila.funcional1 === null) ? fila.funcional1 : parseFloat(fila.funcional1),
					(fila.promedio1 === null) ? fila.promedio1 : parseFloat(fila.promedio1),
					(fila.funcional2 === null) ? fila.funcional2 : parseFloat(fila.funcional2),
					(fila.promedio2 === null) ? fila.promedio2 : parseFloat(fila.promedio2),
				]
				worksheet.addRow(v_fila)
				for (let columna = 0; columna < 7; columna++) {
					const v_columna = String.fromCharCode(columna + 65) + n_fila.toString()
					if (columna < 2) {
						worksheet.getCell(v_columna).font = {
							name: "Arial Black",
							family: 2,
							size: 13,
							bold: true,
							italic: true,
						}
						worksheet.getCell(v_columna).alignment = {
							horizontal: "left",
						}
					} else {
						worksheet.getCell(v_columna).font = {
							size: 13,
						}
						worksheet.getCell(v_columna).numFmt = "#,0"
					}
				}
				n_fila++

			})

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = "Cuentas" + vigencia + ".xlsx"
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none";

			document.body.appendChild(downloadLink);
			downloadLink.click();

			downloadLink.remove();

		},

		formato(valor) {
			if (valor === null || valor === undefined || valor === '') {
				return ''
			}
			const valorStr = valor.toString().trim()
			const numero = parseFloat(valorStr)

			if (isNaN(numero)) {
				return valorStr
			}
			return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero)
		},
		formato_consol(valor) {
			if (valor === null || valor === undefined || valor === '') {
				return ''
			}
			const valorStr = valor.toString().trim()

			let numero = parseFloat(valorStr)

			if (isNaN(numero)) {
				return valorStr
			}
			const funcional = this.currency.find((funcional) => funcional.isFuncional == 1);
			if (funcional && funcional.id != this.cmoneda) {
				this.tasa_cambio = 1;
				const cmoneda = this.tasasCambio.find((tasas) => tasas.id_moneda == this.cmoneda);
				if (cmoneda) {
					this.tasa_cambio = this.tasa_cambio * cmoneda.tasa_cierre;
				}
				this.amoneda = this.cmoneda;
			}
			numero = numero * this.tasa_cambio;

			// Aplicar formato con separadores de miles
			return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero);
		},
		f_muestra(r_origen) {
			if (r_origen.informacion != "I") {
				return
			}
			this.formCuentas = r_origen
			Balance.getCuentasNiif(this.codReporte, this.idCompania, this.vigencia, r_origen.niif)
				.then((result) => {
					this.cuentas = result.data.cuentas
					this.showDialogCuenta = true
				})
				.catch(() => {
					this.error = true
				});

			setTimeout(() => {
				this.t_saldo = 0;
				this.t_funcional = 0;
				this.t_promedio = 0;
				this.t_interna1 = 0;
				this.t_alterna = 0;
				this.t_prom_alterna = 0;
				this.t_interna2 = 0;

				this.cuentas.forEach((cuenta) => {
					this.t_saldo = this.t_saldo + parseFloat(cuenta.saldo_actual || 0)
					this.t_funcional = this.t_funcional + parseFloat(cuenta.funcional1 || 0)
					this.t_promedio = this.t_promedio + parseFloat(cuenta.promedio1 || 0)
					this.t_interna1 = this.t_interna1 + parseFloat(cuenta.interna1 || 0)
					this.t_alterna = this.t_alterna + parseFloat(cuenta.funcional2 || 0)
					this.t_prom_alterna = this.t_prom_alterna + parseFloat(cuenta.promedio2 || 0)
					this.t_interna2 = this.t_interna2 + parseFloat(cuenta.interna2 || 0)
				})

				let r_cuenta = {}
				r_cuenta.cuenta = ''
				r_cuenta.descripcion = 'TOTAL CONSULTA'
				r_cuenta.saldo_actual = this.t_saldo
				r_cuenta.funcional1 = this.t_funcional
				r_cuenta.promedio1 = this.t_promedio
				r_cuenta.interna1 = this.t_interna1
				r_cuenta.funcional2 = this.t_alterna
				r_cuenta.promedio2 = this.t_prom_alterna
				r_cuenta.interna2 = this.t_interna2

				this.cuentas.push(r_cuenta)
			}, 1000)
		},
		async f_todas_notas() {
			this.showGeneratingWordModal = true;
			this.generatingWordMessage = 'Generando todas las notas...';
			this.generatingWordSubMessage = 'Recopilando información de las notas financieras';
			this.generatingWordProgress = 20;
			this.codReporte = this.dialogReportes

			try {
				this.a_Paragraph = [];
				this.a_titulos = [];
				this.a_informacion = [];

				this.generatingWordProgress = 40;
				this.generatingWordMessage = 'Obteniendo datos de las notas...';

				await Balance.getTodasNotas(this.codReporte, this.idCompania, this.vigencia)
					.then((result) => {
						this.generatingWordProgress = 60;
						this.generatingWordMessage = 'Procesando información...';

						this.a_detalle = result.data.a_detalle;
						this.a_detalle_columnas = result.data.a_detalle_columnas;
						this.a_detalle_cuentas = result.data.a_detalle_cuentas;
						this.a_detalle_niif = result.data.a_detalle_niif;
						this.a_detalle_filas = result.data.a_detalle_filas;
						this.a_detalle_tabla = result.data.a_detalle_tabla;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_tblm = result.data.a_informacion_tblm;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;

						this.generatingWordProgress = 80;
						this.generatingWordMessage = 'Preparando documento...';

						this.$toast.info('Procesando todas las notas...');
					})
					.catch(() => {
						this.error = true;
						this.$toast.error('Error al obtener las notas');
					});

				this.generatingWordProgress = 90;
				this.generatingWordMessage = 'Generando Word...';
				this.generatingWordSubMessage = 'Espere un momento por favor';

				setTimeout(() => {
					this.crea_word_todas();
				}, 500);

			} catch (error) {
				console.error('Error generando todas las notas:', error);
				this.$toast.error('Error al generar las notas');
				this.showGeneratingWordModal = false;
			}
		},
		async f_muestra_nota(r_nota) {
			this.showGeneratingWordModal = true;
			this.generatingWordMessage = 'Generando nota...';
			this.generatingWordSubMessage = `Nota ${r_nota.numero}: ${r_nota.descripcion}`;
			this.generatingWordProgress = 20;

			try {
				this.a_Paragraph = [];
				this.a_titulos = [];
				this.a_informacion = [];
				this.formNotas = r_nota;
				this.formCuentas = r_nota;

				if (r_nota.numero) {
					this.generatingWordProgress = 40;
					this.generatingWordMessage = 'Obteniendo datos de la nota...';
					this.codReporte = this.dialogReportes

					await Balance.getNotas(this.codReporte, this.idCompania, this.vigencia, r_nota.numero)
						.then((result) => {
							this.generatingWordProgress = 60;
							this.generatingWordMessage = 'Procesando información...';

							this.a_detalle = result.data.a_detalle;
							this.a_detalle_columnas = result.data.a_detalle_columnas;
							this.a_detalle_cuentas = result.data.a_detalle_cuentas;
							this.a_detalle_niif = result.data.a_detalle_niif;
							this.a_detalle_filas = result.data.a_detalle_filas;
							this.a_detalle_tabla = result.data.a_detalle_tabla;
							this.a_detalle_texto = result.data.a_detalle_texto;
							this.a_informacion_tblm = result.data.a_informacion_tblm;
							this.a_informacion_txfc = result.data.a_informacion_txfc;
							this.a_informacion_txfg = result.data.a_informacion_txfg;
							this.a_informacion_txvc = result.data.a_informacion_txvc;
							this.a_informacion_txvg = result.data.a_informacion_txvg;

							this.generatingWordProgress = 80;
							this.generatingWordMessage = 'Preparando documento...';

							this.$toast.info(`Procesando nota ${r_nota.numero}...`);
						})
						.catch(() => {
							this.error = true;
							this.$toast.error('Error al obtener la nota');
						});

					this.generatingWordProgress = 90;
					this.generatingWordMessage = 'Generando Word...';

					setTimeout(() => {
						this.crea_word();
					}, 500);
				}
			} catch (error) {
				console.error('Error generando nota:', error);
				this.$toast.error('Error al generar la nota');
				this.showGeneratingWordModal = false;
			}
		},

		async crea_word() {
			try {
				this.generatingWordProgress = 95;
				this.generatingWordMessage = 'Finalizando documento...';
				this.a_Paragraph = []
				this.a_titulos = []
				this.a_informacion = []

				for (const detalle of this.a_detalle) {
					this.a_titulos.push({
						titulo: detalle.titulo,
						id: detalle.id
					})

					let variable = null

					if (detalle.tipo === "TFG") {
						const txfg = this.a_informacion_txfg.find(tx => tx.parrafo === detalle.parrafo)
						if (txfg) {
							variable = {
								texto: txfg.texto,
								texto_html: txfg.texto_html,
								id: detalle.id,
								numero: detalle.numero,
								parrafo: detalle.parrafo,
								tablatype: "TTT"
							}
						}
					}

					if (detalle.tipo === "TFC") {
						const txfc = this.a_informacion_txfc.find(tx => tx.parrafo === detalle.parrafo)
						if (txfc) {
							variable = {
								texto: txfc.texto,
								texto_html: txfc.texto_html,
								id: detalle.id,
								numero: detalle.numero,
								parrafo: detalle.parrafo,
								tablatype: "TTT"
							}
						}
					}

					if (detalle.tipo === "TVG" || detalle.tipo === "TVC") {
						let origen = detalle.tipo === "TVG"
							? this.a_informacion_txvg
							: this.a_informacion_txvc

						let tx = origen.find(tx =>
							tx.parrafo === detalle.parrafo &&
							tx.numero === detalle.numero
						)

						if (tx) {
							if (tx.valor_campo0 && tx.valor_campo0.trim() !== '') {
								variable = {
									texto: tx.valor_campo0,
									texto_html: tx.valor_campo0,
									id: detalle.id,
									numero: detalle.numero,
									parrafo: detalle.parrafo,
									tablatype: "TTT"
								}
							} else {
								let textoBase = this.a_detalle_texto.find(t =>
									t.parrafo === detalle.parrafo &&
									t.numero === detalle.numero
								)

								if (textoBase) {
									let texto = textoBase.texto
									let texto_html = textoBase.texto_html || textoBase.texto || ""

									for (let i = 0; i <= 9; i++) {
										if (tx[`valor_campo${i}`]) {
											texto = texto.replace(`%valor_campo${i}%`, tx[`valor_campo${i}`])
											texto_html = texto_html.replace(`%valor_campo${i}%`, tx[`valor_campo${i}`])
										}
									}

									variable = {
										texto: texto,
										texto_html: texto_html,
										id: detalle.id,
										numero: detalle.numero,
										parrafo: detalle.parrafo,
										tablatype: "TTT"
									}
								}
							}
						} else {
							let textoBase = this.a_detalle_texto.find(t =>
								t.parrafo === detalle.parrafo &&
								t.numero === detalle.numero
							)
							if (textoBase) {
								variable = {
									texto: textoBase.texto,
									texto_html: textoBase.texto_html || textoBase.texto || "",
									id: detalle.id,
									numero: detalle.numero,
									parrafo: detalle.parrafo,
									tablatype: "TTT"
								}
							}
						}
					}

					if (["TBA", "TBT", "TBC", "TBM", "TNA", "TNT", "TNC"].includes(detalle.tipo)) {
						variable = {
							texto: detalle.tipo,
							id: detalle.id,
							numero: detalle.numero,
							parrafo: detalle.parrafo,
							tablatype: detalle.tipo
						}
					}

					if (variable) {
						this.a_informacion.push(variable)
					}
				}

				this.agregarTexto("Notas a los Estados Financieros", true)
				this.agregarSalto()
				this.agregarTexto(`${this.formNotas.numero}-\t${this.formNotas.descripcion}`, true)
				this.agregarSalto()

				for (const info of this.a_informacion) {
					const titulo = this.a_titulos.find(t => t.id === info.id)

					if (titulo && info.tablatype === "TTT") {
						this.agregarTexto(titulo.titulo, true)
						this.agregarSalto()

						if (info.texto_html) {
							this.agregarTexto(info.texto_html, false, true)
						} else {
							this.agregarTexto(info.texto)
						}
						this.agregarSalto()
						continue
					}

					// VERIFICAR SI HAY DATOS PARA LAS TABLAS TBM
					if (info.tablatype === "TBM") {
						// Buscar si existen datos en a_informacion_tblm para este párrafo y nota
						const tieneDatosTBM = this.tieneDatosTablaTBM(info.numero, info.parrafo);

						if (!tieneDatosTBM) {
							console.log(`Tabla TBM ${info.numero}-${info.parrafo} sin datos, omitiendo...`);
							continue;
						}
					}

					// VERIFICAR SI HAY DATOS PARA OTRAS TABLAS
					if (["TBA", "TBT", "TBC", "TNA", "TNT", "TNC"].includes(info.tablatype)) {
						const tieneDatos = await this.verificarDatosTabla(info.tablatype, info.numero, info.parrafo);

						if (!tieneDatos) {
							console.log(`Tabla ${info.tablatype} ${info.numero}-${info.parrafo} sin datos, omitiendo...`);
							continue;
						}
					}

					switch (info.tablatype) {
						case "TBA": {
							await this.procesarTBA(info);
							break;
						}

						case "TBT": {
							await this.procesarTBT(info);
							break;
						}

						case "TBC": {
							await this.procesarTBC(info);
							break;
						}

						case "TBM": {
							await this.procesarTBM(info);
							break;
						}

						case "TNA": {
							await this.procesarTNA(info);
							break;
						}

						case "TNT": {
							await this.procesarTNT(info);
							break;
						}

						case "TNC": {
							await this.procesarTNC(info);
							break;
						}
					}
				}

				this.generatingWordProgress = 100;
				this.generatingWordMessage = '¡Completado!';

				setTimeout(() => {
					this.showGeneratingWordModal = false;
					this.generarWord();
				}, 500);

			} catch (error) {
				console.error('Error en crea_word:', error);
				this.showGeneratingWordModal = false;
				this.$toast.error('Error al crear el documento');
			}
		},

		// Nuevo método para verificar si hay datos en tabla TBM
		tieneDatosTablaTBM(numero, parrafo) {
			if (!this.a_informacion_tblm || !Array.isArray(this.a_informacion_tblm)) {
				return false;
			}

			// Filtrar datos por número y párrafo - USANDO LOS PARÁMETROS
			const datosFiltrados = this.a_informacion_tblm.filter(item => {
				// Convertir a números para comparación estricta
				const itemNumero = parseInt(item.numero);
				const itemParrafo = parseInt(item.parrafo);
				const paramNumero = parseInt(numero);
				const paramParrafo = parseInt(parrafo);

				return itemNumero === paramNumero && itemParrafo === paramParrafo;
			});

			// Verificar si hay al menos un dato con valor no vacío
			return datosFiltrados.some(item =>
				item.valor && item.valor.toString().trim() !== ''
			);
		},

		async verificarDatosTabla(tipo, numero, parrafo) {
			try {
				// Si ya tenemos datos en memoria, verificar
				switch (tipo) {
					case "TBA":
						return this.saldosTBA && this.saldosTBA.length > 0 &&
							this.saldosTBA.some(item => item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01);

					case "TBT":
						return this.saldosTBT && this.saldosTBT.length > 0 &&
							this.saldosTBT.some(item => item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01);

					case "TBC":
						return this.saldosTBC && this.saldosTBC.length > 0 &&
							this.saldosTBC.some(item =>
								(item.saldo_anterior !== null && Math.abs(item.saldo_anterior) > 0.01) ||
								(item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01)
							);

					case "TNA":
						if (this.saldosNiifTNA && this.saldosNiifTNA.length > 0) {
							const tieneDatos = this.saldosNiifTNA.some(item =>
								item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01
							);
							if (tieneDatos) return true;
						}

						console.log(`Consultando datos TNA para nota ${numero}, párrafo ${parrafo}`);

						try {
							const result = await Balance.getTNA(
								this.codReporte,
								this.idCompania,
								this.vigencia,
								numero,
								parrafo
							);

							this.saldosNiifTNA = result.data.saldosNiifTNA || [];

							const tieneDatos = this.saldosNiifTNA.some(item =>
								item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01
							);

							console.log(`Resultado consulta TNA: ${this.saldosNiifTNA.length} registros, tiene datos: ${tieneDatos}`);
							return tieneDatos;

						} catch (error) {
							console.error(`Error consultando TNA:`, error);
							return false;
						}

					case "TNT":
						// PRIMERO: Verificar si ya tenemos datos en memoria
						if (this.saldosNiifTNT && this.saldosNiifTNT.length > 0) {
							const tieneDatos = this.saldosNiifTNT.some(item =>
								item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01
							);
							if (tieneDatos) return true;
						}

						// SEGUNDO: Si no hay datos en memoria, consultar al servidor
						console.log(`Consultando datos TNT para nota ${numero}, párrafo ${parrafo}`);

						try {
							const result = await Balance.getTNT(
								this.codReporte,
								this.idCompania,
								this.vigencia,
								numero,
								parrafo
							);

							this.saldosNiifTNT = result.data.saldosNiifTNT || [];

							// Verificar si hay datos válidos
							const tieneDatos = this.saldosNiifTNT.some(item =>
								item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01
							);

							console.log(`Resultado consulta TNT: ${this.saldosNiifTNT.length} registros, tiene datos: ${tieneDatos}`);
							return tieneDatos;

						} catch (error) {
							console.error(`Error consultando TNT:`, error);
							return false;
						}

					case "TNC":
						// PRIMERO: Verificar si ya tenemos datos en memoria
						if (this.saldosNiifTNC && this.saldosNiifTNC.length > 0) {
							const tieneDatos = this.saldosNiifTNC.some(item =>
								(item.saldo_anterior !== null && Math.abs(item.saldo_anterior) > 0.01) ||
								(item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01)
							);
							if (tieneDatos) return true;
						}

						// SEGUNDO: Si no hay datos en memoria, consultar al servidor
						console.log(`Consultando datos TNC para nota ${numero}, párrafo ${parrafo}`);

						try {
							const result = await Balance.getTNC(
								this.codReporte,
								this.idCompania,
								this.vigencia,
								numero,
								parrafo
							);

							this.saldosNiifTNC = result.data.saldosNiifTNC || [];

							// Verificar si hay datos válidos
							const tieneDatos = this.saldosNiifTNC.some(item =>
								(item.saldo_anterior !== null && Math.abs(item.saldo_anterior) > 0.01) ||
								(item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01)
							);

							console.log(`Resultado consulta TNC: ${this.saldosNiifTNC.length} registros, tiene datos: ${tieneDatos}`);
							return tieneDatos;

						} catch (error) {
							console.error(`Error consultando TNC:`, error);
							return false;
						}

					default:
						return false;
				}

			} catch (error) {
				console.error(`Error verificando datos tabla ${tipo}:`, error);
				return false;
			}
		},
		convertirHtmlADocx(html) {
			try {
				if (!html || html.trim() === '' || html.trim() === '<p></p>') {
					return [new Paragraph({ children: [new TextRun("")] })];
				}

				const decodeHtmlEntities = (text) => {
					const txt = document.createElement("textarea");
					txt.innerHTML = text;
					return txt.value;
				};

				html = decodeHtmlEntities(html);

				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const paragraphs = [];

				const extraerTextoConEstilos = (node, estiloAcumulado = {}) => {
					const runs = [];

					if (node.nodeType === Node.TEXT_NODE) {
						let text = node.textContent.replace(/\u00A0/g, ' ');
						if (text !== '') {
							runs.push(new TextRun({
								text,
								size: estiloAcumulado.size || 28,
								...estiloAcumulado
							}));
						}
					}

					if (node.nodeType === Node.ELEMENT_NODE) {
						const estilo = { ...estiloAcumulado };
						const tag = node.tagName.toUpperCase();

						if (['B', 'STRONG'].includes(tag)) estilo.bold = true;
						if (['I', 'EM'].includes(tag)) estilo.italic = true;
						if (tag === 'U') estilo.underline = {};
						if (['S', 'STRIKE'].includes(tag)) estilo.strike = true;

						if (tag.match(/^H[1-6]$/)) {
							estilo.bold = true;
							estilo.size = 32;
						}

						const styleAttr = node.getAttribute('style');
						if (styleAttr) {
							styleAttr.split(';').forEach(s => {
								const [k, v] = s.split(':').map(x => x && x.trim());
								if (!k || !v) return;

								if (k === 'font-size') {
									const n = parseFloat(v);
									if (!isNaN(n)) estilo.size = Math.round(n * 2);
								}
								if (k === 'font-weight' && v === 'bold') estilo.bold = true;
								if (k === 'color') estilo.color = this.convertirColorWord(v);
							});
						}

						node.childNodes.forEach(child => {
							runs.push(...extraerTextoConEstilos(child, estilo));
						});
					}

					return runs;
				};

				const procesarNodo = (node) => {
					if (node.nodeType !== Node.ELEMENT_NODE) return;

					const tag = node.tagName.toUpperCase();

					// SALTO DE LÍNEA
					if (tag === 'BR') {
						paragraphs.push(new Paragraph({}));
						return;
					}

					// LISTAS CON VIÑETAS
					if (tag === 'UL') {
						Array.from(node.children).forEach(li => {
							if (li.tagName === 'LI') {
								const runs = extraerTextoConEstilos(li);
								paragraphs.push(new Paragraph({
									children: runs,
									bullet: { level: 0 },
									style: "ListParagraph"
								}));
							}
						});
						return;
					}

					// PÁRRAFOS, TÍTULOS, DIV
					if (['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(tag)) {
						const runs = extraerTextoConEstilos(node);
						paragraphs.push(new Paragraph({ children: runs }));
						return;
					}

					// RECURSIVO
					node.childNodes.forEach(procesarNodo);
				};

				Array.from(doc.body.childNodes).forEach(procesarNodo);

				if (paragraphs.length === 0) {
					paragraphs.push(new Paragraph({
						children: [new TextRun(doc.body.textContent || '')]
					}));
				}

				return paragraphs;

			} catch (error) {
				console.error(error);
				return [
					new Paragraph({
						children: [new TextRun(html.replace(/<[^>]+>/g, ' '))]
					})
				];
			}
		}
		,

		// Método auxiliar para convertir colores
		convertirColorWord(colorHtml) {
			// Colores básicos
			const coloresBasicos = {
				'black': '000000',
				'white': 'FFFFFF',
				'red': 'FF0000',
				'green': '00FF00',
				'blue': '0000FF',
				'yellow': 'FFFF00',
				'cyan': '00FFFF',
				'magenta': 'FF00FF',
				'gray': '808080',
				'grey': '808080'
			};

			let colorHex = colorHtml.toLowerCase().trim();

			// Si es un nombre de color básico
			if (coloresBasicos[colorHex]) {
				return coloresBasicos[colorHex];
			}

			// Si ya es hexadecimal
			if (colorHex.startsWith('#')) {
				colorHex = colorHex.substring(1);

				// Expandir formato corto (#FFF -> #FFFFFF)
				if (colorHex.length === 3) {
					colorHex = colorHex.split('').map(c => c + c).join('');
				}

				return colorHex.toUpperCase();
			}

			// Si es rgb() o rgba()
			const rgbMatch = colorHtml.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/i);
			if (rgbMatch) {
				const r = parseInt(rgbMatch[1]).toString(16).padStart(2, '0');
				const g = parseInt(rgbMatch[2]).toString(16).padStart(2, '0');
				const b = parseInt(rgbMatch[3]).toString(16).padStart(2, '0');
				return (r + g + b).toUpperCase();
			}

			// Por defecto, negro
			return '000000';
		},

		// Método auxiliar para procesar nodos HTML
		procesarNodoHtml(node, textRuns) {
			console.log('Procesando nodo:', node.nodeType === Node.TEXT_NODE ? 'TEXTO' : node.tagName);

			if (node.nodeType === Node.TEXT_NODE) {
				// Texto plano
				const text = node.textContent.trim();
				if (text) {
					console.log('Texto encontrado:', text.substring(0, 50) + '...');
					textRuns.push(new TextRun({ text }));
				}
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				// Elementos HTML
				const children = Array.from(node.childNodes);
				console.log(`Nodo ${node.tagName} tiene ${children.length} hijos`);

				// Procesar cada hijo
				children.forEach((child, index) => {
					console.log(`  Hijo ${index}:`, child.nodeType === Node.TEXT_NODE ? 'TEXTO' : child.tagName);
					if (child.nodeType === Node.TEXT_NODE) {
						const text = child.textContent.trim();
						if (text) {
							console.log(`  Texto del hijo ${index}:`, text.substring(0, 50) + '...');
							textRuns.push(new TextRun({
								text,
								bold: node.tagName === 'STRONG' || node.tagName === 'B',
								italic: node.tagName === 'EM' || node.tagName === 'I',
								underline: node.tagName === 'U'
							}));
						}
					} else if (child.nodeType === Node.ELEMENT_NODE) {
						// Llamada recursiva para elementos anidados
						this.procesarNodoHtml(child, textRuns);
					}
				});
			}
		},
		async crea_word_todas() {
			try {
				this.generatingWordProgress = 95;
				this.generatingWordMessage = 'Finalizando documento...';
				this.a_Paragraph = [];

				this.agregarTexto("NOTAS A LOS ESTADOS FINANCIEROS", true);
				this.agregarSalto();

				// Ordenar notas por número
				const notasOrdenadas = [...this.notasEF].sort((a, b) => a.numero - b.numero);

				for (const nota of notasOrdenadas) {
					this.agregarTexto(
						`${nota.numero}-\t${nota.descripcion}`,
						true
					);
					this.agregarSalto();

					// Filtrar detalles por número de nota y ordenar por párrafo
					const detallesNota = this.a_detalle
						.filter(d => d.numero === nota.numero)
						.sort((a, b) => {
							// Primero por párrafo
							if (a.parrafo !== b.parrafo) {
								return a.parrafo - b.parrafo;
							}
							// Si mismo párrafo, por orden
							return (a.orden || 1) - (b.orden || 1);
						});

					for (const detalle of detallesNota) {
						let texto = null;
						let texto_html = null;

						// 1. TITULO (si existe)
						if (detalle.titulo && detalle.titulo.trim() !== '') {
							this.agregarTexto(detalle.titulo.trim(), true);
							this.agregarSalto();
						}

						// 2. CONTENIDO según tipo
						if (detalle.tipo === "TFG") {
							const txfg = this.a_informacion_txfg.find(t =>
								t.parrafo === detalle.parrafo &&
								t.numero === detalle.numero
							);
							if (txfg) {
								texto = txfg.texto;
								texto_html = txfg.texto_html;
							}
						}
						else if (detalle.tipo === "TFC") {
							const txfc = this.a_informacion_txfc.find(t =>
								t.parrafo === detalle.parrafo &&
								t.numero === detalle.numero
							);
							if (txfc) {
								texto = txfc.texto;
								texto_html = txfc.texto_html;
							}
						}
						else if (detalle.tipo === "TVG") {
							const txvg = this.a_informacion_txvg.find(t =>
								t.parrafo === detalle.parrafo &&
								t.numero === detalle.numero
							);

							if (txvg) {
								// Usar valor_campo0 si existe y no está vacío
								if (txvg.valor_campo0 && txvg.valor_campo0.trim() !== '') {
									texto = txvg.valor_campo0;
									texto_html = txvg.valor_campo0;
								} else {
									// Solo si valor_campo0 está vacío, usar texto base con reemplazos
									const textoBase = this.a_detalle_texto.find(t =>
										t.parrafo === detalle.parrafo &&
										t.numero === detalle.numero
									);
									if (textoBase) {
										texto = textoBase.texto;
										texto_html = textoBase.texto_html || textoBase.texto || "";

										// Aplicar reemplazos
										for (let i = 0; i <= 9; i++) {
											if (txvg[`valor_campo${i}`]) {
												texto = texto.replace(
													`%valor_campo${i}%`,
													txvg[`valor_campo${i}`]
												);
												if (texto_html) {
													texto_html = texto_html.replace(
														`%valor_campo${i}%`,
														txvg[`valor_campo${i}`]
													);
												}
											}
										}
									}
								}
							} else {
								// Si no existe txvg, usar solo texto base
								const textoBase = this.a_detalle_texto.find(t =>
									t.parrafo === detalle.parrafo &&
									t.numero === detalle.numero
								);
								if (textoBase) {
									texto = textoBase.texto;
									texto_html = textoBase.texto_html || textoBase.texto || "";
								}
							}
						}
						else if (detalle.tipo === "TVC") {
							const txvc = this.a_informacion_txvc.find(t =>
								t.parrafo === detalle.parrafo &&
								t.numero === detalle.numero
							);

							if (txvc) {
								// Usar valor_campo0 directamente si existe y no está vacío
								if (txvc.valor_campo0 && txvc.valor_campo0.trim() !== '') {
									texto = txvc.valor_campo0;
									texto_html = txvc.valor_campo0;
								} else {
									// Solo si valor_campo0 está vacío, usar plantilla con reemplazos
									const textoBase = this.a_detalle_texto.find(t =>
										t.parrafo === detalle.parrafo &&
										t.numero === detalle.numero
									);

									if (textoBase) {
										texto = textoBase.texto;
										texto_html = textoBase.texto_html || textoBase.texto || "";

										// Aplicar reemplazos a la plantilla
										for (let i = 0; i <= 9; i++) {
											if (txvc[`valor_campo${i}`]) {
												texto = texto.replace(
													`%valor_campo${i}%`,
													txvc[`valor_campo${i}`]
												);
												if (texto_html) {
													texto_html = texto_html.replace(
														`%valor_campo${i}%`,
														txvc[`valor_campo${i}`]
													);
												}
											}
										}
									}
								}
							} else {
								// Si no existe txvc, usar solo texto base
								const textoBase = this.a_detalle_texto.find(t =>
									t.parrafo === detalle.parrafo &&
									t.numero === detalle.numero
								);
								if (textoBase) {
									texto = textoBase.texto;
									texto_html = textoBase.texto_html || textoBase.texto || "";
								}
							}
						}
						else {
							// Para otros tipos, buscar texto base
							const textoBase = this.a_detalle_texto.find(t =>
								t.parrafo === detalle.parrafo &&
								t.numero === detalle.numero
							);
							if (textoBase) {
								texto = textoBase.texto;
								texto_html = textoBase.texto_html || "";
							}
						}

						// 3. AGREGAR TEXTO AL DOCUMENTO
						if (texto_html && texto_html.trim() !== '') {
							// Usar HTML si existe y no está vacío
							this.agregarTexto(texto_html, false, true);
							this.agregarSalto();
						} else if (texto && texto.trim() !== '') {
							// Usar texto plano si no hay HTML
							this.agregarTexto(texto);
							this.agregarSalto();
						}

						// 4. PROCESAR TABLAS
						switch (detalle.tipo) {
							case "TBA": {
								const tieneDatosTBA = await this.verificarDatosTabla("TBA", detalle.numero, detalle.parrafo);
								if (tieneDatosTBA) await this.procesarTBA(detalle);
								break;
							}

							case "TBT": {
								const tieneDatosTBT = await this.verificarDatosTabla("TBT", detalle.numero, detalle.parrafo);
								if (tieneDatosTBT) await this.procesarTBT(detalle);
								break;
							}

							case "TBC": {
								const tieneDatosTBC = await this.verificarDatosTabla("TBC", detalle.numero, detalle.parrafo);
								if (tieneDatosTBC) await this.procesarTBC(detalle);
								break;
							}

							case "TBM": {
								const tieneDatosTBM = this.tieneDatosTablaTBM(detalle.numero, detalle.parrafo);
								if (tieneDatosTBM) await this.procesarTBM(detalle);
								break;
							}

							case "TNA": {
								const tieneDatosTNA = await this.verificarDatosTabla("TNA", detalle.numero, detalle.parrafo);
								if (tieneDatosTNA) await this.procesarTNA(detalle);
								break;
							}

							case "TNT": {
								const tieneDatosTNT = await this.verificarDatosTabla("TNT", detalle.numero, detalle.parrafo);
								if (tieneDatosTNT) await this.procesarTNT(detalle);
								break;
							}

							case "TNC": {
								const tieneDatosTNC = await this.verificarDatosTabla("TNC", detalle.numero, detalle.parrafo);
								if (tieneDatosTNC) await this.procesarTNC(detalle);
								break;
							}
						}
					}

					// Espacio entre notas
					this.agregarSalto();
					this.agregarSalto();
				}

				this.generatingWordProgress = 100;
				this.generatingWordMessage = '¡Completado!';

				setTimeout(() => {
					this.showGeneratingWordModal = false;
					this.generarWord();
				}, 500);

			} catch (error) {
				console.error('Error en crea_word_todas:', error);
				this.showGeneratingWordModal = false;
				this.$toast.error('Error al crear el documento');
			}
		},
		// Método para asegurar que el Word guarde con codificación correcta
		generarWord() {
			try {
				const doc = new Document({
					sections: [{
						properties: {
							// IMPORTANTE: Especificar codificación UTF-8
						},
						children: this.a_Paragraph
					}]
				});

				Packer.toBuffer(doc).then(buffer => {
					// Crear Blob con tipo MIME correcto
					const blob = new Blob([buffer], {
						type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8'
					});

					// Crear URL y descargar
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;

					// Nombre del archivo con fecha
					const fecha = new Date().toISOString().split('T')[0];
					link.download = `Notas_Financieras_${fecha}.docx`;

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					// Liberar memoria
					window.URL.revokeObjectURL(url);

					this.$toast.success('Documento Word generado exitosamente');
				});

			} catch (error) {
				console.error('Error generando Word:', error);
				this.$toast.error('Error al generar el documento');
			}
		},
		obtenerTextoDetalle(detalle) {
			let origen = null

			if (detalle.tipo === "TFG") origen = this.a_informacion_txfg
			if (detalle.tipo === "TFC") origen = this.a_informacion_txfc
			if (detalle.tipo === "TVG") origen = this.a_informacion_txvg
			if (detalle.tipo === "TVC") origen = this.a_informacion_txvc

			const tx = origen?.find(t => t.parrafo === detalle.parrafo)
			const base = this.a_detalle_texto.find(t => t.parrafo === detalle.parrafo)

			if (!tx || !base) return null

			let texto = base.texto
			for (let i = 0; i <= 9; i++) {
				if (tx[`valor_campo${i}`]) {
					texto = texto.replace(
						`%valor_campo${i}%`,
						tx[`valor_campo${i}`]
					)
				}
			}

			return texto
		},
		async procesarTBA(r) {
			const result = await Balance.getTBA(
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)

			this.saldosTBA = result.data.saldosTBA

			this.a_Paragraph.push(new Table({
				columnWidths: [1, 3],
				rows: this.f_crea_arreglo("TBA"),
			}))
			this.agregarSalto()
		},

		async procesarTBT(r) {
			const result = await Balance.getTBT(
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)

			this.saldosTBT = result.data.saldosTBT

			this.a_Paragraph.push(new Table({
				columnWidths: [1, 3],
				rows: this.f_crea_arreglo("TBT"),
			}))
			this.agregarSalto()
		},

		async procesarTBC(r) {
			const result = await Balance.getTBC(
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)

			this.saldosTBC = result.data.saldosTBC

			this.a_Paragraph.push(new Table({
				columnWidths: [1, 3],
				rows: this.f_crea_arreglo_tbc(),
			}))
			this.agregarSalto()
		},

		async procesarTBM(info) {
			const numero = info.numero;
			const parrafo = info.parrafo;

			// Verificar si hay datos antes de procesar
			const tieneDatos = this.tieneDatosTablaTBM(numero, parrafo);

			if (!tieneDatos) {
				console.log(`Tabla TBM ${numero}-${parrafo} sin datos, omitiendo...`);
				return;
			}

			// Solo procesar si hay datos
			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300],
				rows: this.f_crea_arreglo_tbm(numero, parrafo),
			}))
			this.agregarSalto()
		},

		async procesarTNA(r) {
			const result = await Balance.getTNA(
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)

			this.saldosNiifTNA = result.data.saldosNiifTNA

			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300],
				rows: this.f_crea_arreglo_niif("TNA"),
			}))
			this.agregarSalto()
		},

		async procesarTNT(r) {
			const result = await Balance.getTNT(
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)

			this.saldosNiifTNT = result.data.saldosNiifTNT

			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300],
				rows: this.f_crea_arreglo_niif("TNT"),
			}))
			this.agregarSalto()
		},



		async procesarTNC(r) {
			const result = await Balance.getTNC(
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)

			this.saldosNiifTNC = result.data.saldosNiifTNC

			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300, 4300, 4300],
				rows: this.f_crea_arreglo_niifc(),
			}))
			this.agregarSalto()
		},
		async obtenerReporteNota() {
			try {
				const response = await Balance.getReporteNota(this.codReporte);
				return response.data.reporte_nota || this.codReporte;
			} catch (error) {
				console.error('Error obteniendo reporte_nota:', error);
				return this.codReporte;
			}
		},
		agregarTexto(texto, esTitulo = false, esHtml = false) {
			if (!texto || texto.toString().trim() === '') return;

			try {
				if (esHtml) {
					const paragraphs = this.convertirHtmlADocx(texto.toString());
					if (paragraphs && paragraphs.length > 0) {
						this.a_Paragraph.push(...paragraphs);
					} else {
						// Fallback: texto plano
						const paragraph = new Paragraph({
							children: [new TextRun({
								text: texto.toString(),
								bold: esTitulo,
								size: esTitulo ? 28 : 24
							})]
						});
						this.a_Paragraph.push(paragraph);
					}
				} else {
					// Texto plano normal
					const paragraph = new Paragraph({
						children: [new TextRun({
							text: texto.toString(),
							bold: esTitulo,
							size: esTitulo ? 28 : 24
						})]
					});
					this.a_Paragraph.push(paragraph);
				}
			} catch (error) {
				console.error('Error en agregarTexto:', error);
				// Fallback a texto simple
				const paragraph = new Paragraph({
					children: [new TextRun({
						text: texto.toString().substring(0, 200),
						bold: esTitulo
					})]
				});
				this.a_Paragraph.push(paragraph);
			}
		},

		agregarSalto() {
			this.a_Paragraph.push(new Paragraph({ children: [new TextRun("")] }))
		},

		f_crea_arreglo(opcion) {

			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []

			a_children = [
				new Paragraph({
					text: "Cuenta",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			a_children = [
				new Paragraph({
					text: "Descripcion",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			if (opcion == "TBA") {
				a_children = [
					new Paragraph({
						text: "Saldo A " + this.vigencia,
					}),
				]
			}
			if (opcion == "TBT") {
				let yy = parseInt(this.vigencia.substring(0, 4)) - 1
				let fecha_vigencia = String(yy) + "12"
				a_children = [
					new Paragraph({
						text: "Saldo A " + fecha_vigencia,
					}),
				]
			}
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			v_tableRow = new TableRow({ children: a_tableCell })
			a_tableRow.push(v_tableRow)
			a_tableCell = []
			if (opcion == "TBA") {
				this.saldosTBA.forEach((cuenta) => {
					a_children = [
						new Paragraph({
							text: cuenta.cuenta,
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
					a_children = [
						new Paragraph({
							text: cuenta.descripcion,
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
					a_children = [
						new Paragraph({
							text: this.formato(cuenta.saldo_actual),
							alignment: AlignmentType.RIGTH,
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
					v_tableRow = new TableRow({ children: a_tableCell })
					a_tableRow.push(v_tableRow)
					a_tableCell = []
				})
				return a_tableRow
			}
			if (opcion == "TBT") {
				this.saldosTBT.forEach((cuenta) => {
					a_children = [
						new Paragraph({
							text: cuenta.cuenta,
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
					a_children = [
						new Paragraph({
							text: cuenta.descripcion,
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
					a_children = [
						new Paragraph({
							text: this.formato(cuenta.saldo_actual),
							alignment: AlignmentType.RIGTH,

						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
					v_tableRow = new TableRow({ children: a_tableCell })
					a_tableRow.push(v_tableRow)
					a_tableCell = []
				})
				return a_tableRow
			}

		},
		f_crea_arreglo_niif(opcion) {
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []

			// Variable para acumular total
			let total = 0
			let saldosFiltrados = []

			// FILTRAR DATOS SEGÚN LA OPCIÓN
			if (opcion === "TNA") {

				saldosFiltrados = this.saldosNiifTNA.filter(niif => {
					const saldo = parseFloat(niif.saldo_actual) || 0
					return Math.abs(saldo) >= 0.01
				})
			} else if (opcion === "TNT") {
				saldosFiltrados = this.saldosNiifTNT.filter(niif => {
					const saldo = parseFloat(niif.saldo_actual) || 0
					return Math.abs(saldo) >= 0.01
				})
			}

			a_children = [
				new Paragraph({
					text: "Concepto",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			if (opcion === "TNA") {
				a_children = [
					new Paragraph({
						text: "Saldo A " + this.vigencia,
					}),
				]
			} else if (opcion === "TNT") {
				let yy = parseInt(this.vigencia.substring(0, 4)) - 1
				let fecha_vigencia = String(yy) + "12"
				a_children = [
					new Paragraph({
						text: "Saldo A " + fecha_vigencia,
					}),
				]
			}

			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			v_tableRow = new TableRow({ children: a_tableCell })
			a_tableRow.push(v_tableRow)
			a_tableCell = []

			saldosFiltrados.forEach((niif) => {
				const saldo = parseFloat(niif.saldo_actual) || 0
				total += saldo

				a_children = [
					new Paragraph({
						text: niif.descripcion,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(niif.saldo_actual),
						alignment: AlignmentType.RIGHT,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				v_tableRow = new TableRow({ children: a_tableCell })
				a_tableRow.push(v_tableRow)
				a_tableCell = []
			})
			if (saldosFiltrados.length > 0) {
				a_children = [
					new Paragraph({
						text: "Total",
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(total),
						alignment: AlignmentType.RIGHT,
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				v_tableRow = new TableRow({ children: a_tableCell })
				a_tableRow.push(v_tableRow)
			}

			return a_tableRow
		},
		f_crea_arreglo_tbc() {

			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []

			a_children = [
				new Paragraph({
					text: "Cuenta",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			a_children = [
				new Paragraph({
					text: "Descripcion",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			let yy = parseInt(this.vigencia.substring(0, 4)) - 1
			let fecha_vigencia = String(yy) + "12"
			a_children = [
				new Paragraph({
					text: "Saldo A " + fecha_vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			a_children = [
				new Paragraph({
					text: "Saldo A " + this.vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			a_children = [
				new Paragraph({
					text: "Diferencia",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)
			v_tableRow = new TableRow({ children: a_tableCell })
			a_tableRow.push(v_tableRow)
			a_tableCell = []
			this.saldosTBC.forEach((cuenta) => {
				a_children = [
					new Paragraph({
						text: cuenta.cuenta,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)
				a_children = [
					new Paragraph({
						text: cuenta.descripcion,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)
				a_children = [
					new Paragraph({
						text: this.formato(cuenta.saldo_anterior),
						alignment: AlignmentType.RIGTH,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)
				a_children = [
					new Paragraph({
						text: this.formato(cuenta.saldo_actual),
						alignment: AlignmentType.RIGTH,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)
				a_children = [
					new Paragraph({
						text: this.formato(cuenta.diferencia),
						alignment: AlignmentType.RIGTH,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)
				v_tableRow = new TableRow({ children: a_tableCell })
				a_tableRow.push(v_tableRow)
				a_tableCell = []
			})
			return a_tableRow

		},
		f_crea_arreglo_niifc() {
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []

			// Variables para acumular totales
			let totalAnterior = 0
			let totalActual = 0
			let totalDiferencia = 0

			// ENCABEZADOS
			a_children = [
				new Paragraph({
					text: "Concepto",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			let yy = parseInt(this.vigencia.substring(0, 4)) - 1
			let fecha_vigencia = String(yy) + "12"

			a_children = [
				new Paragraph({
					text: "Saldo A " + fecha_vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			a_children = [
				new Paragraph({
					text: "Saldo A " + this.vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			a_children = [
				new Paragraph({
					text: "Diferencia",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			v_tableRow = new TableRow({ children: a_tableCell })
			a_tableRow.push(v_tableRow)
			a_tableCell = []

			// DATOS - FILTRANDO Y ACUMULANDO
			this.saldosNiifTNC.forEach((niif) => {
				// Verificar si la diferencia es 0 (o muy cercana a 0)
				const diferencia = parseFloat(niif.diferencia) || 0
				if (Math.abs(diferencia) < 0.01) {
					return // Saltar esta fila
				}

				// Acumular totales
				const anterior = parseFloat(niif.saldo_anterior) || 0
				const actual = parseFloat(niif.saldo_actual) || 0

				totalAnterior += anterior
				totalActual += actual
				totalDiferencia += diferencia

				// Crear fila
				a_children = [
					new Paragraph({
						text: niif.descripcion,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(niif.saldo_anterior),
						alignment: AlignmentType.RIGHT,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(niif.saldo_actual),
						alignment: AlignmentType.RIGHT,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(niif.diferencia),
						alignment: AlignmentType.RIGHT,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				v_tableRow = new TableRow({ children: a_tableCell })
				a_tableRow.push(v_tableRow)
				a_tableCell = []
			})

			// FILA DE TOTAL SOLO SI HAY DATOS
			if (this.saldosNiifTNC.length > 0) {
				a_children = [
					new Paragraph({
						text: "Total",
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(totalAnterior),
						alignment: AlignmentType.RIGHT,
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(totalActual),
						alignment: AlignmentType.RIGHT,
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				a_children = [
					new Paragraph({
						text: this.formato(totalDiferencia),
						alignment: AlignmentType.RIGHT,
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				v_tableRow = new TableRow({ children: a_tableCell })
				a_tableRow.push(v_tableRow)
			}

			return a_tableRow
		},
		f_crea_arreglo_tbm(numero, parrafo) {
			// Primero: Filtrar columnas por el numero y parrafo específicos
			const columnasFiltradas = this.a_detalle_columnas.filter(columna =>
				columna.numero === numero && columna.parrafo === parrafo
			).sort((a, b) => a.columna - b.columna); // Ordenar por columna

			// Segundo: Filtrar filas por el numero y parrafo específicos
			const filasFiltradas = this.a_detalle_filas.filter(fila =>
				fila.numero === numero && fila.parrafo === parrafo
			).sort((a, b) => a.fila - b.fila); // Ordenar por fila

			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []

			// ENCABEZADO: Primera celda vacía para la esquina
			a_children = [
				new Paragraph({
					text: "Descripcion",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
			a_tableCell.push(v_tableCell)

			// AGREGAR NOMBRES DE COLUMNAS FILTRADAS
			columnasFiltradas.forEach((columna) => {
				a_children = [
					new Paragraph({
						text: columna.descripcion,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)
			})
			v_tableRow = new TableRow({ children: a_tableCell })
			a_tableRow.push(v_tableRow)
			a_tableCell = []

			// DATOS DE FILAS FILTRADAS
			filasFiltradas.forEach((fila) => {
				a_children = [
					new Paragraph({
						text: fila.descripcion,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
				a_tableCell.push(v_tableCell)

				// PARA CADA COLUMNA, BUSCAR EL VALOR CORRESPONDIENTE
				columnasFiltradas.forEach((columna) => {
					// FILTRAR TBLM por numero, parrafo, columna y fila específicos
					const c_valor = this.a_informacion_tblm.find((r_valor) =>
						r_valor.numero === numero &&
						r_valor.parrafo === parrafo &&
						r_valor.columna == columna.columna &&
						r_valor.fila == fila.fila
					)
					let v_valor = 0
					if (c_valor) {
						v_valor = c_valor.valor
					}
					a_children = [
						new Paragraph({
							text: this.formato(v_valor),
							alignment: AlignmentType.RIGHT, // CORREGIDO: "RIGTH" → "RIGHT"
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
					a_tableCell.push(v_tableCell)
				})
				v_tableRow = new TableRow({ children: a_tableCell })
				a_tableRow.push(v_tableRow)
				a_tableCell = []
			})

			return a_tableRow
		},
		async saveFile(buffer) {
			try {
				// Convertir buffer a Blob con codificación correcta
				const blob = new Blob([buffer], {
					type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
				});

				// Crear URL
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;

				// Nombre del archivo
				const fecha = new Date().toISOString().split('T')[0];
				const nombreArchivo = `Notas_Financieras_${fecha}_${this.selVigencia}.docx`;
				link.download = nombreArchivo;

				// Descargar
				document.body.appendChild(link);
				link.click();

				// Limpiar
				setTimeout(() => {
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
				}, 100);

			} catch (error) {
				console.error('Error guardando archivo:', error);
				this.$toast.error('Error al guardar el archivo');
			}
		},
		f_modifica_nota(r_nota) {
			this.formNotas = r_nota
			this.formCuentas = r_nota
			this.codReporte = this.dialogReportes
			Balance.getNotas(this.codReporte, this.idCompania, this.vigencia, r_nota.numero)
				.then((result) => {
					this.a_detalle = result.data.a_detalle
					this.a_detalle_columnas = result.data.a_detalle_columnas
					this.a_detalle_cuentas = result.data.a_detalle_cuentas
					this.a_detalle_niif = result.data.a_detalle_niif
					this.a_detalle_filas = result.data.a_detalle_filas
					this.a_detalle_tabla = result.data.a_detalle_tabla
					this.a_detalle_texto = result.data.a_detalle_texto
					this.a_informacion_tblm = result.data.a_informacion_tblm
					this.a_informacion_txfc = result.data.a_informacion_txfc
					this.a_informacion_txfg = result.data.a_informacion_txfg
					this.a_informacion_txvc = result.data.a_informacion_txvc
					this.a_informacion_txvg = result.data.a_informacion_txvg
				})
				.catch(() => {
					this.error = true
				});
			setTimeout(() => {
				this.Modifica = true
			}, 1000)
		},
		f_cambia_texto_html(html) {
			this.formParrafo.texto_html = html;

			this.formParrafo.texto = this.htmlToPlainText(html);

		},
		htmlToPlainText(html) {
			if (!html) return '';

			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = html;

			let text = tempDiv.textContent || tempDiv.innerText || '';

			text = text.replace(/\s+/g, ' ')
				.replace(/\n\s*\n/g, '\n')
				.trim();

			return text;
		},
		f_actualiza_nota(r_parrafo) {
			this.showDialog = true
			this.Informacion = false
			this.formParrafo = r_parrafo

			// Limpiar datos anteriores de tabla
			this.tbmTableData = {
				columns: [],
				rows: [],
				values: {} // { "fila-columna": valor }
			}

			// Si es TBM, preparar datos de tabla
			if (r_parrafo.tipo === "TBM") {
				// 1. Filtrar columnas para este número y párrafo
				this.tbmTableData.columns = this.a_detalle_columnas
					.filter(col => col.numero === r_parrafo.numero && col.parrafo === r_parrafo.parrafo)
					.sort((a, b) => a.columna - b.columna)

				// 2. Filtrar filas para este número y párrafo
				this.tbmTableData.rows = this.a_detalle_filas
					.filter(fila => fila.numero === r_parrafo.numero && fila.parrafo === r_parrafo.parrafo)
					.sort((a, b) => a.fila - b.fila)

				// 3. Cargar valores existentes
				this.tbmTableData.values = {}

				// Primero, inicializar todas las celdas como vacías
				this.tbmTableData.rows.forEach(fila => {
					this.tbmTableData.columns.forEach(col => {
						const key = `${fila.fila}-${col.columna}`
						this.tbmTableData.values[key] = ''
					})
				})

				// Luego, cargar valores existentes de a_informacion_tblm
				this.a_informacion_tblm.forEach(item => {
					if (item.numero === r_parrafo.numero && item.parrafo === r_parrafo.parrafo) {
						const key = `${item.fila}-${item.columna}`
						this.tbmTableData.values[key] = item.valor
					}
				})

				// No cargar el editor de texto para TBM
				return
			}

			let texto_html = '';
			let texto_plano = '';

			// TEXTO FIJO GENERAL
			if (this.formParrafo.tipo == "TFG") {
				const txfg = this.a_informacion_txfg.find((parrafo) =>
					parrafo.parrafo == r_parrafo.parrafo)
				if (txfg) {
					texto_html = txfg.texto_html || txfg.texto || '';
					texto_plano = txfg.texto || '';
				}
			}

			// TEXTO FIJO COMPAÑÍA
			if (this.formParrafo.tipo == "TFC") {
				const txfc = this.a_informacion_txfc.find((parrafo) =>
					parrafo.parrafo == r_parrafo.parrafo)
				if (txfc) {
					texto_html = txfc.texto_html || txfc.texto || '';
					texto_plano = txfc.texto || '';
				}
			}

			// TEXTO VARIABLE GENERAL
			if (this.formParrafo.tipo == "TVG") {
				const txvg = this.a_informacion_txvg.find((parrafo) =>
					parrafo.parrafo == r_parrafo.parrafo)
				if (txvg) {
					// Primero intentamos obtener de valor_campo0
					texto_html = txvg.valor_campo0 || '';
					texto_plano = txvg.valor_campo0 || '';

					// Si está vacío, usamos la plantilla de tbl_notas_detalle_texto
					if (!texto_html || texto_html.trim() === '') {
						const dt = this.a_detalle_texto.find((variable) =>
							variable.parrafo == r_parrafo.parrafo)
						if (dt) {
							texto_html = dt.texto_html || dt.texto || '';
							texto_plano = dt.texto || '';
						}
					}

					// Cargamos los otros campos de valor
					this.formParrafo.valor_campo0 = txvg.valor_campo0
					this.formParrafo.valor_campo1 = txvg.valor_campo1
					this.formParrafo.valor_campo2 = txvg.valor_campo2
					this.formParrafo.valor_campo3 = txvg.valor_campo3
					this.formParrafo.valor_campo4 = txvg.valor_campo4
					this.formParrafo.valor_campo5 = txvg.valor_campo5
					this.formParrafo.valor_campo6 = txvg.valor_campo6
					this.formParrafo.valor_campo7 = txvg.valor_campo7
					this.formParrafo.valor_campo8 = txvg.valor_campo8
					this.formParrafo.valor_campo9 = txvg.valor_campo9
				} else {
					// Si no existe registro en txvg, usamos solo la plantilla
					const dt = this.a_detalle_texto.find((variable) =>
						variable.parrafo == r_parrafo.parrafo)
					if (dt) {
						texto_html = dt.texto_html || dt.texto || '';
						texto_plano = dt.texto || '';
					}
				}

				// Buscamos los nombres de campos en detalle_texto
				const dt = this.a_detalle_texto.find((variable) =>
					variable.parrafo == r_parrafo.parrafo)
				if (dt) {
					this.formParrafo.texto = dt.texto
					this.formParrafo.campo0 = dt.campo0
					this.formParrafo.campo1 = dt.campo1
					this.formParrafo.campo2 = dt.campo2
					this.formParrafo.campo3 = dt.campo3
					this.formParrafo.campo4 = dt.campo4
					this.formParrafo.campo5 = dt.campo5
					this.formParrafo.campo6 = dt.campo6
					this.formParrafo.campo7 = dt.campo7
					this.formParrafo.campo8 = dt.campo8
					this.formParrafo.campo9 = dt.campo9
				}
			}

			if (this.formParrafo.tipo == "TVC") {
				const txvcArray = this.a_informacion_txvc
					.filter((parrafo) => parrafo.parrafo == r_parrafo.parrafo)
					.sort((a, b) => a.orden - b.orden);

				if (txvcArray.length > 0) {
					texto_html = '';
					for (const txvc of txvcArray) {
						texto_html += txvc.valor_campo0 || '';
					}
					texto_plano = texto_html;

					if (!texto_html || texto_html.trim() === '') {
						const dt = this.a_detalle_texto.find((variable) =>
							variable.parrafo == r_parrafo.parrafo && variable.numero == r_parrafo.numero)
						if (dt) {
							texto_html = dt.texto_html || dt.texto || '';
							texto_plano = dt.texto || '';

							const primerRegistro = txvcArray[0];
							if (texto_html && primerRegistro) {
								let htmlConValores = texto_html;
								let textoConValores = texto_plano;

								for (let i = 0; i <= 9; i++) {
									const token = `%valor_campo${i}%`;
									const valor = primerRegistro[`valor_campo${i}`] || '';

									if (htmlConValores.includes(token)) {
										htmlConValores = htmlConValores.replace(new RegExp(token, 'g'), valor);
									}
									if (textoConValores.includes(token)) {
										textoConValores = textoConValores.replace(new RegExp(token, 'g'), valor);
									}
								}

								texto_html = htmlConValores;
								texto_plano = textoConValores;
							}
						}
					}

					const primerRegistro = txvcArray[0];
					this.formParrafo.valor_campo0 = primerRegistro.valor_campo0 || ''
					this.formParrafo.valor_campo1 = primerRegistro.valor_campo1 || ''
					this.formParrafo.valor_campo2 = primerRegistro.valor_campo2 || ''
					this.formParrafo.valor_campo3 = primerRegistro.valor_campo3 || ''
					this.formParrafo.valor_campo4 = primerRegistro.valor_campo4 || ''
					this.formParrafo.valor_campo5 = primerRegistro.valor_campo5 || ''
					this.formParrafo.valor_campo6 = primerRegistro.valor_campo6 || ''
					this.formParrafo.valor_campo7 = primerRegistro.valor_campo7 || ''
					this.formParrafo.valor_campo8 = primerRegistro.valor_campo8 || ''
					this.formParrafo.valor_campo9 = primerRegistro.valor_campo9 || ''

				} else {

					const dt = this.a_detalle_texto.find((variable) =>
						variable.parrafo == r_parrafo.parrafo && variable.numero == r_parrafo.numero)
					if (dt) {
						texto_html = dt.texto_html || dt.texto || '';
						texto_plano = dt.texto || '';
					}
				}

				const dt = this.a_detalle_texto.find((variable) =>
					variable.parrafo == r_parrafo.parrafo && variable.numero == r_parrafo.numero)
				if (dt) {
					this.formParrafo.texto = dt.texto
					this.formParrafo.campo0 = dt.campo0
					this.formParrafo.campo1 = dt.campo1
					this.formParrafo.campo2 = dt.campo2
					this.formParrafo.campo3 = dt.campo3
					this.formParrafo.campo4 = dt.campo4
					this.formParrafo.campo5 = dt.campo5
					this.formParrafo.campo6 = dt.campo6
					this.formParrafo.campo7 = dt.campo7
					this.formParrafo.campo8 = dt.campo8
					this.formParrafo.campo9 = dt.campo9
				}
			}

			this.formParrafo.texto = texto_plano;
			this.formParrafo.texto_html = texto_html || texto_plano;

			this.$nextTick(() => {
				if (this.$refs.textEditor && this.$refs.textEditor.setHTML) {
					this.$refs.textEditor.setHTML(this.formParrafo.texto_html);
				}
			});
		},
	},

	mounted() {
		this.isLoading = true;

		Grupo.getAllGrupos()
			.then((result) => {
				this.grupos = result.data.grupos;
				this.gruposFiltrados = result.data.grupos;
				console.log('Grupos cargados:', this.grupos);
				console.log('Grupos filtrados:', this.gruposFiltrados);
			})
			.catch((error) => {
				console.log("Error cargando grupos:", error);
			});

		Balance.leaCompaniaUsuario()
			.then((result) => {
				this.companiaUsuario = result.data.companiaUsuario

				Balance.getCompanias(true)
					.then((result) => {
						this.companias = result.data.companias;

						console.log('Estructura de compañías:', this.companias[0]);
						console.log('¿Tienen id_grupos?:', this.companias[0]?.id_grupos);

						let v_companias = [];
						result.data.companias.forEach((element) => {
							const v_usuario = this.companiaUsuario.find((r_usuario) =>
								r_usuario.id_usuario == this.$store.state.userId &&
								r_usuario.id_compania == element.id)
							if (this.$store.state.userRole == 1 || v_usuario) {
								v_companias.push(element)
							}
						})

						this.companias = v_companias;
						this.companiasFiltradas = v_companias;
						this.dialogCompanias = "";
						this.codigoCompanias = "{";
						let primero = true;

						result.data.companias.forEach(element => {
							this.dialogCompanias.push(element.id);
							if (!primero) {
								this.codigoCompanias = this.codigoCompanias + ",";
							}
							primero = false;
							this.codigoCompanias = this.codigoCompanias + "\"id" + element.id + "\":" +
								"\"" + element.codigo + "\"";
						});
						this.codigoCompanias = this.codigoCompanias + "}";
						this.codigoCompanias = JSON.parse(this.codigoCompanias);
					})
					.catch((error) => {
						console.log(error)
						this.error = true
					});
			})

		// Cargar fechas
		Balance.getFechas()
			.then((result) => {
				this.fechas = ordenefechas(result.data.fechas)
				this.dialogFechas = ""
				result.data.fechas.forEach(element => {
					this.dialogFechas.push(element.fecha);
				})
			})
			.catch(() => {
				this.error = true
			});

		// Cargar reportes
		Balance.getReportes()
			.then((result) => {
				this.reportes = result.data.reportes
			})
			.catch(() => {
				this.error = true
			});

		// Cargar currency
		Currency.getAllCurrency()
			.then((result) => {
				this.currency = result.data.currency;
			})
			.catch(() => {
				this.error = true;
			});

		this.isLoading = false;
	},
};
</script>

<style src="../main.css"></style>
